<script>
  import { Icon, Row, Col, Container, TabContent, TabPane } from "sveltestrap";
  import { createEventDispatcher } from "svelte";
  import Panel from "../../components/Panel.svelte";
  import Modal from "../../components/Modal.svelte";

  export let sData = "";
  export let idcompany = "";
  export let token = "";
  export let master = "";
  export let company_name_field = "";
  export let company_url_field = "";
  export let company_angka_max_minbet_field = 0;
  export let company_angka_max_minbasket_field = 0;
  export let company_angka_max_maxbet_4d_field = 0;
  export let company_angka_max_maxbet_3d_field = 0;
  export let company_angka_max_maxbet_3dd_field = 0;
  export let company_angka_max_maxbet_2d_field = 0;
  export let company_angka_max_maxbet_2dd_field = 0;
  export let company_angka_max_maxbet_2dt_field = 0;
  export let company_angka_max_maxbet_4d_bbdisc_field = 0;
  export let company_angka_max_maxbet_3d_bbdisc_field = 0;
  export let company_angka_max_maxbet_3dd_bbdisc_field = 0;
  export let company_angka_max_maxbet_2d_bbdisc_field = 0;
  export let company_angka_max_maxbet_2dd_bbdisc_field = 0;
  export let company_angka_max_maxbet_2dt_bbdisc_field = 0;
  export let company_angka_max_win4d_full_field = 0;
  export let company_angka_max_win3d_full_field = 0;
  export let company_angka_max_win3dd_full_field = 0;
  export let company_angka_max_win2d_full_field = 0;
  export let company_angka_max_win2dd_full_field = 0;
  export let company_angka_max_win2dt_full_field = 0;
  export let company_angka_max_win4d_disc_field = 0;
  export let company_angka_max_win3d_disc_field = 0;
  export let company_angka_max_win3dd_disc_field = 0;
  export let company_angka_max_win2d_disc_field = 0;
  export let company_angka_max_win2dd_disc_field = 0;
  export let company_angka_max_win2dt_disc_field = 0;
  export let company_angka_max_win4d_bb_field = 0;
  export let company_angka_max_win3d_bb_field = 0;
  export let company_angka_max_win3dd_bb_field = 0;
  export let company_angka_max_win2d_bb_field = 0;
  export let company_angka_max_win2dd_bb_field = 0;
  export let company_angka_max_win2dt_bb_field = 0;
  export let company_angka_max_win4d_bbkena_field = 0;
  export let company_angka_max_win3d_bbkena_field = 0;
  export let company_angka_max_win3dd_bbkena_field = 0;
  export let company_angka_max_win2d_bbkena_field = 0;
  export let company_angka_max_win2dd_bbkena_field = 0;
  export let company_angka_max_win2dt_bbkena_field = 0;
  export let company_cbebas_max_minbet_field = 0;
  export let company_cbebas_max_maxbet_field = 0;
  export let company_cbebas_max_win_field = 0.0;
  export let company_cmacau_max_minbet_field = 0;
  export let company_cmacau_max_maxbet_field = 0;
  export let company_cmacau_max_win4_field = 0.0;
  export let company_cmacau_max_win3_field = 0.0;
  export let company_cmacau_max_win2_field = 0.0;
  export let company_cnaga_max_minbet_field = 0;
  export let company_cnaga_max_maxbet_field = 0;
  export let company_cnaga_max_win4_field = 0.0;
  export let company_cnaga_max_win3_field = 0.0;
  export let company_cjitu_max_minbet_field = 0;
  export let company_cjitu_max_maxbet_field = 0;
  export let company_cjitu_max_winas_field = 0.0;
  export let company_cjitu_max_winekor_field = 0.0;
  export let company_cjitu_max_winkepala_field = 0.0;
  export let company_cjitu_max_winkop_field = 0.0;
  export let company_umum50_max_minbet_field = 0;
  export let company_umum50_max_maxbet_field = 0;
  export let company_special50_max_minbet_field = 0;
  export let company_special50_max_maxbet_field = 0;
  export let company_kombinasi50_max_minbet_field = 0;
  export let company_kombinasi50_max_maxbet_field = 0;
  export let company_macau_max_minbet_field = 0;
  export let company_macau_max_maxbet_field = 0;
  export let company_macau_max_win_field = 0.0;
  export let company_dasar_max_minbet_field = 0;
  export let company_dasar_max_maxbet_field = 0;
  export let company_shio_max_minbet_field = 0;
  export let company_shio_max_maxbet_field = 0;
  export let company_shio_max_win_field = 0.0;
  export let company_shio_parent_field = "0";
  export let company_status_field = "";
  export let company_create_field = "";
  export let company_update_field = "";
  export let master_company_id = "";

  let admin_username_field = "";
  let admin_username_flag_field = false;
  let admin_password_field = "";
  let admin_name_field = "";
  let admin_status_field = "";
  let searchadmin = "";
  let filteradmin = "";

  let pasaran_id_field = "";
  let pasaran_alias_field = "";
  let companypasaran_id_field = "";

  let select_pasaranonline = "";

  let pasaran_nmpasarantogel_field = "";
  let pasaran_pasaranalias_field = "";
  let pasaran_urlpasaran_field = "";
  let pasaran_pasarandiundi_field = "";
  let pasaran_jamtutup_field = "";
  let pasaran_jamjadwal_field = "";
  let pasaran_jamopen_field = "";
  let pasaran_status_field = "";
  let searchpasaran = "";
  let filterpasaran = "";

  let startIndexShio = 0;
  let pasaran_limitline4d_field = 0;
  let pasaran_limitline3d_field = 0;
  let pasaran_limitline3dd_field = 0;
  let pasaran_limitline2d_field = 0;
  let pasaran_limitline2dd_field = 0;
  let pasaran_limitline2dt_field = 0;
  let pasaran_bbfs_field = 0;
  let pasaran_minbasket_field = 0;
  let pasaran_minbet_432d_field = 0;
  let pasaran_maxbet4d_432d_field = 0;
  let pasaran_maxbet3d_432d_field = 0;
  let pasaran_maxbet3dd_432d_field = 0;
  let pasaran_maxbet2d_432d_field = 0;
  let pasaran_maxbet2dd_432d_field = 0;
  let pasaran_maxbet2dt_432d_field = 0;
  let pasaran_maxbet4d_bbdisc_432d_field = 0;
  let pasaran_maxbet3d_bbdisc_432d_field = 0;
  let pasaran_maxbet3dd_bbdisc_432d_field = 0;
  let pasaran_maxbet2d_bbdisc_432d_field = 0;
  let pasaran_maxbet2dd_bbdisc_432d_field = 0;
  let pasaran_maxbet2dt_bbdisc_432d_field = 0;
  let pasaran_limitotal4d_432d_field = 0;
  let pasaran_limitotal3d_432d_field = 0;
  let pasaran_limitotal3dd_432d_field = 0;
  let pasaran_limitotal2d_432d_field = 0;
  let pasaran_limitotal2dd_432d_field = 0;
  let pasaran_limitotal2dt_432d_field = 0;
  let pasaran_limitglobal4d_432d_field = 0;
  let pasaran_limitglobal3d_432d_field = 0;
  let pasaran_limitglobal3dd_432d_field = 0;
  let pasaran_limitglobal2d_432d_field = 0;
  let pasaran_limitglobal2dd_432d_field = 0;
  let pasaran_limitglobal2dt_432d_field = 0;
  let pasaran_disc4d_432d_field = 0;
  let pasaran_disc3d_432d_field = 0;
  let pasaran_disc3dd_432d_field = 0;
  let pasaran_disc2d_432d_field = 0;
  let pasaran_disc2dd_432d_field = 0;
  let pasaran_disc2dt_432d_field = 0;
  let pasaran_win4d_432d_field = 0;
  let pasaran_win3d_432d_field = 0;
  let pasaran_win3dd_432d_field = 0;
  let pasaran_win2d_432d_field = 0;
  let pasaran_win2dd_432d_field = 0;
  let pasaran_win2dt_432d_field = 0;
  let pasaran_win4d_nodisc_432d_field = 0;
  let pasaran_win3d_nodisc_432d_field = 0;
  let pasaran_win3dd_nodisc_432d_field = 0;
  let pasaran_win2d_nodisc_432d_field = 0;
  let pasaran_win2dd_nodisc_432d_field = 0;
  let pasaran_win2dt_nodisc_432d_field = 0;
  let pasaran_win4d_bb_kena_432d_field = 0;
  let pasaran_win3d_bb_kena_432d_field = 0;
  let pasaran_win3dd_bb_kena_432d_field = 0;
  let pasaran_win2d_bb_kena_432d_field = 0;
  let pasaran_win2dd_bb_kena_432d_field = 0;
  let pasaran_win2dt_bb_kena_432d_field = 0;
  let pasaran_win4d_bb_432d_field = 0;
  let pasaran_win3d_bb_432d_field = 0;
  let pasaran_win3dd_bb_432d_field = 0;
  let pasaran_win2d_bb_432d_field = 0;
  let pasaran_win2dd_bb_432d_field = 0;
  let pasaran_win2dt_bb_432d_field = 0;

  let pasaran_minbet_cbebas_field = 0;
  let pasaran_maxbet_cbebas_field = 0;
  let pasaran_limitotal_cbebas_field = 0;
  let pasaran_limitglobal_cbebas_field = 0;
  let pasaran_win_cbebas_field = 0;
  let pasaran_disc_cbebas_field = 0;
  let pasaran_minbet_cmacau_field = 0;
  let pasaran_maxbet_cmacau_field = 0;
  let pasaran_limitotal_cmacau_field = 0;
  let pasaran_limitglobal_cmacau_field = 0;
  let pasaran_win2_cmacau_field = 0;
  let pasaran_win3_cmacau_field = 0;
  let pasaran_win4_cmacau_field = 0;
  let pasaran_disc_cmacau_field = 0;
  let pasaran_minbet_cnaga_field = 0;
  let pasaran_maxbet_cnaga_field = 0;
  let pasaran_win3_cnaga_field = 0;
  let pasaran_win4_cnaga_field = 0;
  let pasaran_disc_cnaga_field = 0;
  let pasaran_limitglobal_cnaga_field = 0;
  let pasaran_limittotal_cnaga_field = 0;
  let pasaran_minbet_cjitu_field = 0;
  let pasaran_maxbet_cjitu_field = 0;
  let pasaran_winas_cjitu_field = 0;
  let pasaran_winkop_cjitu_field = 0;
  let pasaran_winkepala_cjitu_field = 0;
  let pasaran_winekor_cjitu_field = 0;
  let pasaran_desc_cjitu_field = 0;
  let pasaran_limitglobal_cjitu_field = 0;
  let pasaran_limittotal_cjitu_field = 0;
  let pasaran_minbet_5050umum_field = 0;
  let pasaran_maxbet_5050umum_field = 0;
  let pasaran_keibesar_5050umum_field = 0;
  let pasaran_keikecil_5050umum_field = 0;
  let pasaran_keigenap_5050umum_field = 0;
  let pasaran_keiganjil_5050umum_field = 0;
  let pasaran_keitengah_5050umum_field = 0;
  let pasaran_keitepi_5050umum_field = 0;
  let pasaran_discbesar_5050umum_field = 0;
  let pasaran_disckecil_5050umum_field = 0;
  let pasaran_discgenap_5050umum_field = 0;
  let pasaran_discganjil_5050umum_field = 0;
  let pasaran_disctengah_5050umum_field = 0;
  let pasaran_disctepi_5050umum_field = 0;
  let pasaran_limitglobal_5050umum_field = 0;
  let pasaran_limittotal_5050umum_field = 0;
  let pasaran_minbet_5050special_field = 0;
  let pasaran_maxbet_5050special_field = 0;
  let pasaran_keiasganjil_5050special_field = 0;
  let pasaran_keiasgenap_5050special_field = 0;
  let pasaran_keiasbesar_5050special_field = 0;
  let pasaran_keiaskecil_5050special_field = 0;
  let pasaran_keikopganjil_5050special_field = 0;
  let pasaran_keikopgenap_5050special_field = 0;
  let pasaran_keikopbesar_5050special_field = 0;
  let pasaran_keikopkecil_5050special_field = 0;
  let pasaran_keikepalaganjil_5050special_field = 0;
  let pasaran_keikepalagenap_5050special_field = 0;
  let pasaran_keikepalabesar_5050special_field = 0;
  let pasaran_keikepalakecil_5050special_field = 0;
  let pasaran_keiekorganjil_5050special_field = 0;
  let pasaran_keiekorgenap_5050special_field = 0;
  let pasaran_keiekorbesar_5050special_field = 0;
  let pasaran_keiekorkecil_5050special_field = 0;
  let pasaran_discasganjil_5050special_field = 0;
  let pasaran_discasgenap_5050special_field = 0;
  let pasaran_discasbesar_5050special_field = 0;
  let pasaran_discaskecil_5050special_field = 0;
  let pasaran_disckopganjil_5050special_field = 0;
  let pasaran_disckopgenap_5050special_field = 0;
  let pasaran_disckopbesar_5050special_field = 0;
  let pasaran_disckopkecil_5050special_field = 0;
  let pasaran_disckepalaganjil_5050special_field = 0;
  let pasaran_disckepalagenap_5050special_field = 0;
  let pasaran_disckepalabesar_5050special_field = 0;
  let pasaran_disckepalakecil_5050special_field = 0;
  let pasaran_discekorganjil_5050special_field = 0;
  let pasaran_discekorgenap_5050special_field = 0;
  let pasaran_discekorbesar_5050special_field = 0;
  let pasaran_discekorkecil_5050special_field = 0;
  let pasaran_limitglobal_5050special_field = 0;
  let pasaran_limittotal_5050special_field = 0;
  let pasaran_minbet_5050kombinasi_field = 0;
  let pasaran_maxbet_5050kombinasi_field = 0;
  let pasaran_belakangkeimono_5050kombinasi_field = 0;
  let pasaran_belakangkeistereo_5050kombinasi_field = 0;
  let pasaran_belakangkeikembang_5050kombinasi_field = 0;
  let pasaran_belakangkeikempis_5050kombinasi_field = 0;
  let pasaran_belakangkeikembar_5050kombinasi_field = 0;
  let pasaran_tengahkeimono_5050kombinasi_field = 0;
  let pasaran_tengahkeistereo_5050kombinasi_field = 0;
  let pasaran_tengahkeikembang_5050kombinasi_field = 0;
  let pasaran_tengahkeikempis_5050kombinasi_field = 0;
  let pasaran_tengahkeikembar_5050kombinasi_field = 0;
  let pasaran_depankeimono_5050kombinasi_field = 0;
  let pasaran_depankeistereo_5050kombinasi_field = 0;
  let pasaran_depankeikembang_5050kombinasi_field = 0;
  let pasaran_depankeikempis_5050kombinasi_field = 0;
  let pasaran_depankeikembar_5050kombinasi_field = 0;
  let pasaran_belakangdiscmono_5050kombinasi_field = 0;
  let pasaran_belakangdiscstereo_5050kombinasi_field = 0;
  let pasaran_belakangdisckembang_5050kombinasi_field = 0;
  let pasaran_belakangdisckempis_5050kombinasi_field = 0;
  let pasaran_belakangdisckembar_5050kombinasi_field = 0;
  let pasaran_tengahdiscmono_5050kombinasi_field = 0;
  let pasaran_tengahdiscstereo_5050kombinasi_field = 0;
  let pasaran_tengahdisckembang_5050kombinasi_field = 0;
  let pasaran_tengahdisckempis_5050kombinasi_field = 0;
  let pasaran_tengahdisckembar_5050kombinasi_field = 0;
  let pasaran_depandiscmono_5050kombinasi_field = 0;
  let pasaran_depandiscstereo_5050kombinasi_field = 0;
  let pasaran_depandisckembang_5050kombinasi_field = 0;
  let pasaran_depandisckempis_5050kombinasi_field = 0;
  let pasaran_depandisckembar_5050kombinasi_field = 0;
  let pasaran_limitglobal_5050kombinasi_field = 0;
  let pasaran_limittotal_5050kombinasi_field = 0;
  let pasaran_minbet_kombinasi_field = 0;
  let pasaran_maxbet_kombinasi_field = 0;
  let pasaran_win_kombinasi_field = 0;
  let pasaran_disc_kombinasi_field = 0;
  let pasaran_limitglobal_kombinasi_field = 0;
  let pasaran_limittotal_kombinasi_field = 0;
  let pasaran_minbet_dasar_field = 0;
  let pasaran_maxbet_dasar_field = 0;
  let pasaran_keibesar_dasar_field = 0;
  let pasaran_keikecil_dasar_field = 0;
  let pasaran_keigenap_dasar_field = 0;
  let pasaran_keiganjil_dasar_field = 0;
  let pasaran_discbesar_dasar_field = 0;
  let pasaran_disckecil_dasar_field = 0;
  let pasaran_discgenap_dasar_field = 0;
  let pasaran_discganjil_dasar_field = 0;
  let pasaran_limitglobal_dasar_field = 0;
  let pasaran_limittotal_dasar_field = 0;
  let pasaran_minbet_shio_field = 0;
  let pasaran_maxbet_shio_field = 0;
  let pasaran_win_shio_field = 0;
  let pasaran_disc_shio_field = 0;
  let pasaran_shioyear_shio_field = "";
  let pasaran_limitglobal_shio_field = 0;
  let pasaran_limittotal_shio_field = 0;

  let dispatch = createEventDispatcher();
  let listAdmin = [];
  let listPasaran = [];
  let listPasaranonline = [];
  let listPasaranMaster = [];
  let record = "";
  let totalrecordadmin = "";
  let totalpasaran = 0;
  let totalpasaran_css = "color:red;font-weight:bold;";
  let css_loader = "display: none;";
  let msgloader = "";
  let loaderhari = "done";
  let rotatedShio = [];
  let resultShio = "";
  const BackHalaman = () => {
    dispatch("handleBackHalaman", "call");
  };
  $: {
    rotatedShio = [
      ...masterShio.slice(parseInt(company_shio_parent_field)),
      ...masterShio.slice(0, parseInt(company_shio_parent_field))
    ];
    resultShio = rotatedShio.map((shio, index) => ({
      index,
      shio,
      angka: group_shioangka[index]
    }));
    if (searchadmin) {
      filteradmin = listAdmin.filter(
        (item) =>
          item.company_admin_username
            .toLowerCase()
            .includes(searchadmin.toLowerCase()) ||
          item.company_admin_nama
            .toLowerCase()
            .includes(searchadmin.toLowerCase())
      );
    } else {
      filteradmin = [...listAdmin];
    }
    if (searchpasaran) {
      filterpasaran = listPasaran.filter((item) =>
        item.company_pasaran_nmpasarantogel
          .toLowerCase()
          .includes(searchpasaran.toLowerCase())
      );
    } else {
      filterpasaran = [...listPasaran];
    }
  }
  async function saveEntry() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    msgloader = "Sending...";
    if (company_name_field == "") {
      flag = true;
      msg += "The Company is required\n";
    }
    if (company_url_field == "") {
      flag = true;
      msg += "The Url is required\n";
    }
    if (company_status_field == "") {
      flag = true;
      msg += "The Status is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/savecompany", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          name: company_name_field,
          urldomain: company_url_field,
          status: company_status_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
    } else {
      alert(msg);
    }
  }
  async function saveminmaxEntry() {
    let flag = false;
    let msg = "";
    if(parseInt(company_angka_max_minbet_field) < 0) {
        flag = true;
        msg += "The 432D-Minxbet is required\n";
    }
    if(parseInt(company_angka_max_maxbet_4d_field) < 0 ) {
        flag = true;
        msg += "The 432D-Maxbet 4D is required\n";
    }
    if(flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/savecompanyminmax", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          master: master,
          company: idcompany,
          angka_max_minbet: parseInt(company_angka_max_minbet_field),
          angka_max_minbasket: parseInt(company_angka_max_minbasket_field),
          angka_max_maxbet_4d: parseInt(company_angka_max_maxbet_4d_field),
          angka_max_maxbet_3d: parseInt(company_angka_max_maxbet_3d_field),
          angka_max_maxbet_3dd: parseInt(company_angka_max_maxbet_3dd_field),
          angka_max_maxbet_2d: parseInt(company_angka_max_maxbet_2d_field),
          angka_max_maxbet_2dd: parseInt(company_angka_max_maxbet_2dd_field),
          angka_max_maxbet_2dt: parseInt(company_angka_max_maxbet_2dt_field),
          angka_max_maxbet_4d_bbdisc: parseInt(company_angka_max_maxbet_4d_bbdisc_field),
          angka_max_maxbet_3d_bbdisc: parseInt(company_angka_max_maxbet_3d_bbdisc_field),
          angka_max_maxbet_3dd_bbdisc: parseInt(company_angka_max_maxbet_3dd_bbdisc_field),
          angka_max_maxbet_2d_bbdisc: parseInt(company_angka_max_maxbet_2d_bbdisc_field),
          angka_max_maxbet_2dd_bbdisc: parseInt(company_angka_max_maxbet_2dd_bbdisc_field),
          angka_max_maxbet_2dt_bbdisc: parseInt(company_angka_max_maxbet_2dt_bbdisc_field),
          angka_max_win4d_full: parseInt(company_angka_max_win4d_full_field),
          angka_max_win3d_full: parseInt(company_angka_max_win3d_full_field),
          angka_max_win3dd_full: parseInt(company_angka_max_win3dd_full_field),
          angka_max_win2d_full: parseInt(company_angka_max_win2d_full_field),
          angka_max_win2dd_full: parseInt(company_angka_max_win2dd_full_field),
          angka_max_win2dt_full: parseInt(company_angka_max_win2dt_full_field),
          angka_max_win4d_disc: parseInt(company_angka_max_win4d_disc_field),
          angka_max_win3d_disc: parseInt(company_angka_max_win3d_disc_field),
          angka_max_win3dd_disc: parseInt(company_angka_max_win3dd_disc_field),
          angka_max_win2d_disc: parseInt(company_angka_max_win2d_disc_field),
          angka_max_win2dd_disc: parseInt(company_angka_max_win2dd_disc_field),
          angka_max_win2dt_disc: parseInt(company_angka_max_win2dt_disc_field),
          angka_max_win4d_bb: parseInt(company_angka_max_win4d_bb_field),
          angka_max_win3d_bb: parseInt(company_angka_max_win3d_bb_field),
          angka_max_win3dd_bb: parseInt(company_angka_max_win3dd_bb_field),
          angka_max_win2d_bb: parseInt(company_angka_max_win2d_bb_field),
          angka_max_win2dd_bb: parseInt(company_angka_max_win2dd_bb_field),
          angka_max_win2dt_bb: parseInt(company_angka_max_win2dt_bb_field),
          angka_max_win4d_bb_kena: parseInt(company_angka_max_win4d_bbkena_field),
          angka_max_win3d_bb_kena: parseInt(company_angka_max_win3d_bbkena_field),
          angka_max_win3dd_bb_kena: parseInt(company_angka_max_win3dd_bbkena_field),
          angka_max_win2d_bb_kena: parseInt(company_angka_max_win2d_bbkena_field),
          angka_max_win2dd_bb_kena: parseInt(company_angka_max_win2dd_bbkena_field),
          angka_max_win2dt_bb_kena: parseInt(company_angka_max_win2dt_bbkena_field),
          angka_max_win2dt_bb_kena: parseInt(company_angka_max_win2dt_bbkena_field),
          cbebas_max_minbet: parseInt(company_cbebas_max_minbet_field),
          cbebas_max_maxbet: parseInt(company_cbebas_max_maxbet_field),
          cbebas_max_win: parseFloat(company_cbebas_max_win_field),
          cmacau_max_minbet: parseInt(company_cmacau_max_minbet_field),
          cmacau_max_maxbet: parseInt(company_cmacau_max_maxbet_field),
          cmacau_max_win2: parseFloat(company_cmacau_max_win2_field),
          cmacau_max_win3: parseFloat(company_cmacau_max_win3_field),
          cmacau_max_win4: parseFloat(company_cmacau_max_win4_field),
          cnaga_max_minbet: parseInt(company_cnaga_max_minbet_field),
          cnaga_max_maxbet: parseInt(company_cnaga_max_maxbet_field),
          cnaga_max_win3: parseFloat(company_cnaga_max_win3_field),
          cnaga_max_win4: parseFloat(company_cnaga_max_win4_field),
          cjitu_max_minbet: parseFloat(company_cjitu_max_minbet_field),
          cjitu_max_maxbet: parseFloat(company_cjitu_max_maxbet_field),
          cjitu_max_winas: parseFloat(company_cjitu_max_winas_field),
          cjitu_max_winkop: parseFloat(company_cjitu_max_winkop_field),
          cjitu_max_winkepala: parseFloat(company_cjitu_max_winkepala_field),
          cjitu_max_winekor: parseFloat(company_cjitu_max_winekor_field),
          umum50_max_minbet: parseInt(company_umum50_max_minbet_field),
          umum50_max_maxbet: parseInt(company_umum50_max_maxbet_field),
          special50_max_minbet: parseInt(company_special50_max_minbet_field),
          special50_max_maxbet: parseInt(company_special50_max_maxbet_field),
          kombinasi50_max_minbet: parseInt(company_kombinasi50_max_minbet_field),
          kombinasi50_max_maxbet: parseInt(company_kombinasi50_max_maxbet_field),
          macau_max_minbet: parseInt(company_macau_max_minbet_field),
          macau_max_maxbet: parseInt(company_macau_max_maxbet_field),
          macau_max_win: parseFloat(company_macau_max_win_field),
          dasar_max_minbet: parseInt(company_dasar_max_minbet_field),
          dasar_max_maxbet: parseInt(company_dasar_max_maxbet_field),
          shio_max_minbet: parseInt(company_shio_max_minbet_field),
          shio_max_maxbet: parseInt(company_shio_max_maxbet_field),
          shio_max_win: parseFloat(company_shio_max_win_field),
          shio_parent: parseInt(company_shio_parent_field),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
        console.log(json.record)
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
    } else {
      alert(msg);
    }
  }
  async function call_listadmin() {
    listAdmin = [];
    const res = await fetch("/api/companylistadmin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        sData: "New",
        page: "COMPANY_HOME",
        company: idcompany,
      }),
    });
    const json = await res.json();
    if (json.status == 200) {
      record = json.record;
      if (record != null) {
        totalrecordadmin = record.length;
        for (var i = 0; i < record.length; i++) {
          listAdmin = [
            ...listAdmin,
            {
              company_admin_username: record[i]["company_admin_username"],
              company_admin_typeadmin: record[i]["company_admin_typeadmin"],
              company_admin_nama: record[i]["company_admin_nama"],
              company_admin_status: record[i]["company_admin_status"],
              company_admin_status_css: record[i]["company_admin_status_css"],
              company_admin_lastlogin: record[i]["company_admin_lastlogin"],
              company_admin_lastipaddres:
                record[i]["company_admin_lastipaddres"],
              company_admin_create: record[i]["company_admin_create"],
              company_admin_update: record[i]["company_admin_update"],
            },
          ];
        }
      }
    }
  }
  async function call_listpasaran() {
    listPasaran = [];
    const res = await fetch("/api/companylistpasaran", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        sData: "New",
        page: "COMPANY_HOME",
        company: idcompany,
      }),
    });
    const json = await res.json();
    if (json.status == 200) {
      record = json.record;
      if (record != null) {
        totalrecordadmin = record.length;
        for (var i = 0; i < record.length; i++) {
          let css_winlose = "color:red;font-weight:bold;";
          if (record[i]["company_pasaran_winlose"] > 0) {
            css_winlose = "color:blue;font-weight:bold;";
          }
          totalpasaran = totalpasaran + parseInt(record[i]["company_pasaran_winlose"]);
          listPasaran = [
            ...listPasaran,
            {
              company_pasaran_idcomppasaran:record[i]["company_pasaran_idcomppasaran"],
              company_pasaran_idpasarantogel: record[i]["company_pasaran_idpasarantogel"],
              company_pasaran_nmpasarantogel: record[i]["company_pasaran_nmpasarantogel"],
              company_pasaran_aliasnmpasarantogel: record[i]["company_pasaran_aliasnmpasarantogel"],
              company_pasaran_periode: record[i]["company_pasaran_periode"],
              company_pasaran_winlose: record[i]["company_pasaran_winlose"],
              company_pasaran_csswinlose: css_winlose,
              company_pasaran_displaypasaran: record[i]["company_pasaran_displaypasaran"],
              company_pasaran_status: record[i]["company_pasaran_status"],
              company_pasaran_statuscss: record[i]["company_pasaran_statuscss"],
              company_pasaran_statuspasaranactive: record[i]["company_pasaran_statuspasaranactive"],
              company_pasaran_statuspasaranactivecss: record[i]["company_pasaran_statuspasaranactivecss"],
            },
          ];
        }
        if (totalpasaran > 0) {
          totalpasaran_css = "color:blue;font-weight:bold;";
        }
      }
    } else {
      logout();
    }
  }
  async function call_listpasaranmaster() {
    const res = await fetch("/api/allpasaran", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        company: idcompany,
      }),
    });
    const json = await res.json();
    if (json.status == 200) {
      record = json.record;
      if (record != null) {
        for (var i = 0; i < record.length; i++) {
          listPasaranMaster = [
            ...listPasaranMaster,
            {
              pasaran_idpasarantogel: record[i]["pasaran_idpasarantogel"],
              pasaran_nmpasarantogel: record[i]["pasaran_nmpasarantogel"],
            },
          ];
        }
      }
    }
  }
  async function call_listpasaranonline() {
    const res = await fetch("/api/companypasaranonline", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        sData: "New",
        page: "COMPANY_HOME",
        company: idcompany,
        companypasaran_id: companypasaran_id_field,
      }),
    });
    const json = await res.json();
    if (json.status == 200) {
      record = json.record;
      if (record != null) {
        for (var i = 0; i < record.length; i++) {
          listPasaranonline = [
            ...listPasaranonline,
            {
              company_pasaranonline_id: record[i]["company_pasaranonline_id"],
              company_pasaranonline_hari:
                record[i]["company_pasaranonline_hari"],
            },
          ];
        }
      }
    }
  }
  async function call_listpasaranconf() {
    clear_field();
    const res = await fetch("/api/companypasaranconf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        sData: "New",
        page: "COMPANY_HOME",
        company: idcompany,
        companypasaran_id: companypasaran_id_field,
      }),
    });
    const json = await res.json();
    let record = json.record;
    if (json.status === 400) {
      logout();
    } else {
      for (let i = 0; i < record.length; i++) {
        pasaran_urlpasaran_field = record[i]["pasaran_url"];
        pasaran_pasaranalias_field = record[i]["pasaran_aliasname"];
        pasaran_pasarandiundi_field = record[i]["pasaran_diundi"];
        pasaran_jamtutup_field = record[i]["pasaran_jamtutup"];
        pasaran_jamjadwal_field = record[i]["pasaran_jamjadwal"];
        pasaran_jamopen_field = record[i]["pasaran_jamopen"];
        pasaran_status_field = record[i]["pasaran_statusactive"];
        pasaran_bbfs_field = record[i]["bbfs"];
        pasaran_minbasket_field = record[i]["minbasket_432d"];
        pasaran_limitline4d_field = record[i]["limitline_4d"];
        pasaran_limitline3d_field = record[i]["limitline_3d"];
        pasaran_limitline3dd_field = record[i]["limitline_3dd"];
        pasaran_limitline2d_field = record[i]["limitline_2d"];
        pasaran_limitline2dd_field = record[i]["limitline_2dd"];
        pasaran_limitline2dt_field = record[i]["limitline_2dt"];
        pasaran_minbet_432d_field = record[i]["minbet_432d"];
        pasaran_maxbet4d_432d_field = record[i]["maxbet4d_432d"];
        pasaran_maxbet3d_432d_field = record[i]["maxbet3d_432d"];
        pasaran_maxbet3dd_432d_field = record[i]["maxbet3dd_432d"];
        pasaran_maxbet2d_432d_field = record[i]["maxbet2d_432d"];
        pasaran_maxbet2dd_432d_field = record[i]["maxbet2dd_432d"];
        pasaran_maxbet2dt_432d_field = record[i]["maxbet2dt_432d"];
        pasaran_maxbet4d_bbdisc_432d_field = record[i]["maxbet4d_bbdisc_432d"];
        pasaran_maxbet3d_bbdisc_432d_field = record[i]["maxbet3d_bbdisc_432d"];
        pasaran_maxbet3dd_bbdisc_432d_field = record[i]["maxbet3dd_bbdisc_432d"];
        pasaran_maxbet2d_bbdisc_432d_field = record[i]["maxbet2d_bbdisc_432d"];
        pasaran_maxbet2dd_bbdisc_432d_field = record[i]["maxbet2dd_bbdisc_432d"];
        pasaran_maxbet2dt_bbdisc_432d_field = record[i]["maxbet2dt_bbdisc_432d"];
        pasaran_limitotal4d_432d_field = record[i]["limitotal4d_432d"];
        pasaran_limitotal3d_432d_field = record[i]["limitotal3d_432d"];
        pasaran_limitotal3dd_432d_field = record[i]["limitotal3dd_432d"];
        pasaran_limitotal2d_432d_field = record[i]["limitotal2d_432d"];
        pasaran_limitotal2dd_432d_field = record[i]["limitotal2dd_432d"];
        pasaran_limitotal2dt_432d_field = record[i]["limitotal2dt_432d"];
        pasaran_limitglobal4d_432d_field = record[i]["limitglobal4d_432d"];
        pasaran_limitglobal3d_432d_field = record[i]["limitglobal3d_432d"];
        pasaran_limitglobal3dd_432d_field = record[i]["limitglobal3dd_432d"];
        pasaran_limitglobal2d_432d_field = record[i]["limitglobal2d_432d"];
        pasaran_limitglobal2dd_432d_field = record[i]["limitglobal2dd_432d"];
        pasaran_limitglobal2dt_432d_field = record[i]["limitglobal2dt_432d"];
        pasaran_disc4d_432d_field = (record[i]["disc4d_432d"] * 100).toFixed(2);
        pasaran_disc3d_432d_field = (record[i]["disc3d_432d"] * 100).toFixed(2);
        pasaran_disc3dd_432d_field = (record[i]["disc3dd_432d"] * 100).toFixed(
          2
        );
        pasaran_disc2d_432d_field = (record[i]["disc2d_432d"] * 100).toFixed(2);
        pasaran_disc2dd_432d_field = (record[i]["disc2dd_432d"] * 100).toFixed(
          2
        );
        pasaran_disc2dt_432d_field = (record[i]["disc2dt_432d"] * 100).toFixed(
          2
        );
        pasaran_win4d_432d_field = record[i]["win4d_432d"];
        pasaran_win3d_432d_field = record[i]["win3d_432d"];
        pasaran_win3dd_432d_field = record[i]["win3dd_432d"];
        pasaran_win2d_432d_field = record[i]["win2d_432d"];
        pasaran_win2dd_432d_field = record[i]["win2dd_432d"];
        pasaran_win2dt_432d_field = record[i]["win2dt_432d"];
        pasaran_win4d_nodisc_432d_field = record[i]["win4dnodisc_432d"];
        pasaran_win3d_nodisc_432d_field = record[i]["win3dnodisc_432d"];
        pasaran_win3dd_nodisc_432d_field = record[i]["win3ddnodisc_432d"];
        pasaran_win2d_nodisc_432d_field = record[i]["win2dnodisc_432d"];
        pasaran_win2dd_nodisc_432d_field = record[i]["win2ddnodisc_432d"];
        pasaran_win2dt_nodisc_432d_field = record[i]["win2dtnodisc_432d"];
        pasaran_win4d_bb_kena_432d_field = record[i]["win4dbb_kena_432d"];
        pasaran_win3d_bb_kena_432d_field = record[i]["win3dbb_kena_432d"];
        pasaran_win3dd_bb_kena_432d_field = record[i]["win3ddbb_kena_432d"];
        pasaran_win2d_bb_kena_432d_field = record[i]["win2dbb_kena_432d"];
        pasaran_win2dd_bb_kena_432d_field = record[i]["win2ddbb_kena_432d"];
        pasaran_win2dt_bb_kena_432d_field = record[i]["win2dtbb_kena_432d"];
        pasaran_win4d_bb_432d_field = record[i]["win4dbb_432d"];
        pasaran_win3d_bb_432d_field = record[i]["win3dbb_432d"];
        pasaran_win3dd_bb_432d_field = record[i]["win3ddbb_432d"];
        pasaran_win2d_bb_432d_field = record[i]["win2dbb_432d"];
        pasaran_win2dd_bb_432d_field = record[i]["win2ddbb_432d"];
        pasaran_win2dt_bb_432d_field = record[i]["win2dtbb_432d"];

        pasaran_minbet_cbebas_field = record[i]["minbet_cbebas"];
        pasaran_maxbet_cbebas_field = record[i]["maxbet_cbebas"];
        pasaran_limitotal_cbebas_field = record[i]["limittotal_cbebas"];
        pasaran_limitglobal_cbebas_field = record[i]["limitglobal_cbebas"];
        pasaran_win_cbebas_field = record[i]["win_cbebas"].toFixed(2);
        pasaran_disc_cbebas_field = (record[i]["disc_cbebas"] * 100).toFixed(2);

        pasaran_minbet_cmacau_field = record[i]["minbet_cmacau"];
        pasaran_maxbet_cmacau_field = record[i]["maxbet_cmacau"];
        pasaran_limitotal_cmacau_field = record[i]["limitotal_cmacau"];
        pasaran_limitglobal_cmacau_field = record[i]["limitglobal_cmacau"];
        pasaran_win2_cmacau_field = record[i]["win2d_cmacau"].toFixed(2);
        pasaran_win3_cmacau_field = record[i]["win3d_cmacau"].toFixed(2);
        pasaran_win4_cmacau_field = record[i]["win4d_cmacau"].toFixed(2);
        pasaran_disc_cmacau_field = (record[i]["disc_cmacau"] * 100).toFixed(2);

        pasaran_minbet_cnaga_field = record[i]["minbet_cnaga"];
        pasaran_maxbet_cnaga_field = record[i]["maxbet_cnaga"];
        pasaran_win3_cnaga_field = record[i]["win3_cnaga"].toFixed(2);
        pasaran_win4_cnaga_field = record[i]["win4_cnaga"].toFixed(2);
        pasaran_disc_cnaga_field = (record[i]["disc_cnaga"] * 100).toFixed(2);
        pasaran_limitglobal_cnaga_field = record[i]["limitglobal_cnaga"];
        pasaran_limittotal_cnaga_field = record[i]["limittotal_cnaga"];

        pasaran_minbet_cjitu_field = record[i]["minbet_cjitu"];
        pasaran_maxbet_cjitu_field = record[i]["maxbet_cjitu"];
        pasaran_winas_cjitu_field = record[i]["winas_cjitu"].toFixed(2);
        pasaran_winkop_cjitu_field = record[i]["winkop_cjitu"].toFixed(2);
        pasaran_winkepala_cjitu_field = record[i]["winkepala_cjitu"].toFixed(2);
        pasaran_winekor_cjitu_field = record[i]["winekor_cjitu"].toFixed(2);
        pasaran_desc_cjitu_field = (record[i]["desc_cjitu"] * 100).toFixed(2);
        pasaran_limitglobal_cjitu_field = record[i]["limitglobal_cjitu"];
        pasaran_limittotal_cjitu_field = record[i]["limittotal_cjitu"];

        pasaran_minbet_5050umum_field = record[i]["minbet_5050umum"];
        pasaran_maxbet_5050umum_field = record[i]["maxbet_5050umum"];
        pasaran_keibesar_5050umum_field = (
          record[i]["keibesar_5050umum"] * 100
        ).toFixed(2);
        pasaran_keikecil_5050umum_field = (
          record[i]["keikecil_5050umum"] * 100
        ).toFixed(2);
        pasaran_keigenap_5050umum_field = (
          record[i]["keigenap_5050umum"] * 100
        ).toFixed(2);
        pasaran_keiganjil_5050umum_field = (
          record[i]["keiganjil_5050umum"] * 100
        ).toFixed(2);
        pasaran_keitengah_5050umum_field = (
          record[i]["keitengah_5050umum"] * 100
        ).toFixed(2);
        pasaran_keitepi_5050umum_field = (
          record[i]["keitepi_5050umum"] * 100
        ).toFixed(2);
        pasaran_discbesar_5050umum_field = (
          record[i]["discbesar_5050umum"] * 100
        ).toFixed(2);
        pasaran_disckecil_5050umum_field = (
          record[i]["disckecil_5050umum"] * 100
        ).toFixed(2);
        pasaran_discgenap_5050umum_field = (
          record[i]["discgenap_5050umum"] * 100
        ).toFixed(2);
        pasaran_discganjil_5050umum_field = (
          record[i]["discganjil_5050umum"] * 100
        ).toFixed(2);
        pasaran_disctengah_5050umum_field = (
          record[i]["disctengah_5050umum"] * 100
        ).toFixed(2);
        pasaran_disctepi_5050umum_field = (
          record[i]["disctepi_5050umum"] * 100
        ).toFixed(2);
        pasaran_limitglobal_5050umum_field = record[i]["limitglobal_5050umum"];
        pasaran_limittotal_5050umum_field = record[i]["limittotal_5050umum"];

        pasaran_minbet_5050special_field = record[i]["minbet_5050special"];
        pasaran_maxbet_5050special_field = record[i]["maxbet_5050special"];
        pasaran_keiasganjil_5050special_field = (
          record[i]["keiasganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_keiasgenap_5050special_field = (
          record[i]["keiasgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_keiasbesar_5050special_field = (
          record[i]["keiasbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_keiaskecil_5050special_field = (
          record[i]["keiaskecil_5050special"] * 100
        ).toFixed(2);
        pasaran_keikopganjil_5050special_field = (
          record[i]["keikopganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_keikopgenap_5050special_field = (
          record[i]["keikopgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_keikopbesar_5050special_field = (
          record[i]["keikopbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_keikopkecil_5050special_field = (
          record[i]["keikopkecil_5050special"] * 100
        ).toFixed(2);
        pasaran_keikepalaganjil_5050special_field = (
          record[i]["keikepalaganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_keikepalagenap_5050special_field = (
          record[i]["keikepalagenap_5050special"] * 100
        ).toFixed(2);
        pasaran_keikepalabesar_5050special_field = (
          record[i]["keikepalabesar_5050special"] * 100
        ).toFixed(2);
        pasaran_keikepalakecil_5050special_field = (
          record[i]["keikepalakecil_5050special"] * 100
        ).toFixed(2);
        pasaran_keiekorganjil_5050special_field = (
          record[i]["keiekorganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_keiekorgenap_5050special_field = (
          record[i]["keiekorgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_keiekorbesar_5050special_field = (
          record[i]["keiekorbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_keiekorkecil_5050special_field = (
          record[i]["keiekorkecil_5050special"] * 100
        ).toFixed(2);
        pasaran_discasganjil_5050special_field = (
          record[i]["discasganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_discasgenap_5050special_field = (
          record[i]["discasgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_discasbesar_5050special_field = (
          record[i]["discasbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_discaskecil_5050special_field = (
          record[i]["discaskecil_5050special"] * 100
        ).toFixed(2);
        pasaran_disckopganjil_5050special_field = (
          record[i]["disckopganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_disckopgenap_5050special_field = (
          record[i]["disckopgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_disckopbesar_5050special_field = (
          record[i]["disckopbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_disckopkecil_5050special_field = (
          record[i]["disckopkecil_5050special"] * 100
        ).toFixed(2);
        pasaran_disckepalaganjil_5050special_field = (
          record[i]["disckepalaganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_disckepalagenap_5050special_field = (
          record[i]["disckepalagenap_5050special"] * 100
        ).toFixed(2);
        pasaran_disckepalabesar_5050special_field = (
          record[i]["disckepalabesar_5050special"] * 100
        ).toFixed(2);
        pasaran_disckepalakecil_5050special_field = (
          record[i]["disckepalakecil_5050special"] * 100
        ).toFixed(2);
        pasaran_discekorganjil_5050special_field = (
          record[i]["discekorganjil_5050special"] * 100
        ).toFixed(2);
        pasaran_discekorgenap_5050special_field = (
          record[i]["discekorgenap_5050special"] * 100
        ).toFixed(2);
        pasaran_discekorbesar_5050special_field = (
          record[i]["discekorbesar_5050special"] * 100
        ).toFixed(2);
        pasaran_discekorkecil_5050special_field = (
          record[i]["discekorkecil_5050special"] * 100
        ).toFixed(2);
        pasaran_limitglobal_5050special_field =
          record[i]["limitglobal_5050special"];
        pasaran_limittotal_5050special_field =
          record[i]["limittotal_5050special"];

        pasaran_minbet_5050kombinasi_field = record[i]["minbet_5050kombinasi"];
        pasaran_maxbet_5050kombinasi_field = record[i]["maxbet_5050kombinasi"];
        pasaran_belakangkeimono_5050kombinasi_field = (
          record[i]["belakangkeimono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangkeistereo_5050kombinasi_field = (
          record[i]["belakangkeistereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangkeikembang_5050kombinasi_field = (
          record[i]["belakangkeikembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangkeikempis_5050kombinasi_field = (
          record[i]["belakangkeikempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangkeikembar_5050kombinasi_field = (
          record[i]["belakangkeikembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahkeimono_5050kombinasi_field = (
          record[i]["tengahkeimono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahkeistereo_5050kombinasi_field = (
          record[i]["tengahkeistereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahkeikembang_5050kombinasi_field = (
          record[i]["tengahkeikembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahkeikempis_5050kombinasi_field = (
          record[i]["tengahkeikempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahkeikembar_5050kombinasi_field = (
          record[i]["tengahkeikembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depankeimono_5050kombinasi_field = (
          record[i]["depankeimono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depankeistereo_5050kombinasi_field = (
          record[i]["depankeistereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depankeikembang_5050kombinasi_field = (
          record[i]["depankeikembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depankeikempis_5050kombinasi_field = (
          record[i]["depankeikempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depankeikembar_5050kombinasi_field = (
          record[i]["depankeikembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangdiscmono_5050kombinasi_field = (
          record[i]["belakangdiscmono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangdiscstereo_5050kombinasi_field = (
          record[i]["belakangdiscstereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangdisckembang_5050kombinasi_field = (
          record[i]["belakangdisckembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangdisckempis_5050kombinasi_field = (
          record[i]["belakangdisckempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_belakangdisckembar_5050kombinasi_field = (
          record[i]["belakangdisckembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahdiscmono_5050kombinasi_field = (
          record[i]["tengahdiscmono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahdiscstereo_5050kombinasi_field = (
          record[i]["tengahdiscstereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahdisckembang_5050kombinasi_field = (
          record[i]["tengahdisckembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahdisckempis_5050kombinasi_field = (
          record[i]["tengahdisckempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_tengahdisckembar_5050kombinasi_field = (
          record[i]["tengahdisckembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depandiscmono_5050kombinasi_field = (
          record[i]["depandiscmono_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depandiscstereo_5050kombinasi_field = (
          record[i]["depandiscstereo_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depandisckembang_5050kombinasi_field = (
          record[i]["depandisckembang_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depandisckempis_5050kombinasi_field = (
          record[i]["depandisckempis_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_depandisckembar_5050kombinasi_field = (
          record[i]["depandisckembar_5050kombinasi"] * 100
        ).toFixed(2);
        pasaran_limitglobal_5050kombinasi_field =
          record[i]["limitglobal_5050kombinasi"];
        pasaran_limittotal_5050kombinasi_field =
          record[i]["limittotal_5050kombinasi"];

        pasaran_minbet_kombinasi_field = record[i]["minbet_kombinasi"];
        pasaran_maxbet_kombinasi_field = record[i]["maxbet_kombinasi"];
        pasaran_win_kombinasi_field = record[i]["win_kombinasi"].toFixed(2);
        pasaran_disc_kombinasi_field = (
          record[i]["disc_kombinasi"] * 100
        ).toFixed(2);
        pasaran_limitglobal_kombinasi_field =
          record[i]["limitglobal_kombinasi"];
        pasaran_limittotal_kombinasi_field = record[i]["limittotal_kombinasi"];

        pasaran_minbet_dasar_field = record[i]["minbet_dasar"];
        pasaran_maxbet_dasar_field = record[i]["maxbet_dasar"];
        pasaran_keibesar_dasar_field = (
          record[i]["keibesar_dasar"] * 100
        ).toFixed(2);
        pasaran_keikecil_dasar_field = (
          record[i]["keikecil_dasar"] * 100
        ).toFixed(2);
        pasaran_keigenap_dasar_field = (
          record[i]["keigenap_dasar"] * 100
        ).toFixed(2);
        pasaran_keiganjil_dasar_field = (
          record[i]["keiganjil_dasar"] * 100
        ).toFixed(2);
        pasaran_discbesar_dasar_field = (
          record[i]["discbesar_dasar"] * 100
        ).toFixed(2);
        pasaran_disckecil_dasar_field = (
          record[i]["disckecil_dasar"] * 100
        ).toFixed(2);
        pasaran_discgenap_dasar_field = (
          record[i]["discgenap_dasar"] * 100
        ).toFixed(2);
        pasaran_discganjil_dasar_field = (
          record[i]["discganjil_dasar"] * 100
        ).toFixed(2);
        pasaran_limitglobal_dasar_field = record[i]["limitglobal_dasar"];
        pasaran_limittotal_dasar_field = record[i]["limittotal_dasar"];
        pasaran_minbet_shio_field = record[i]["minbet_shio"];
        pasaran_maxbet_shio_field = record[i]["maxbet_shio"];
        pasaran_win_shio_field = record[i]["win_shio"].toFixed(2);
        pasaran_disc_shio_field = (record[i]["disc_shio"] * 100).toFixed(2);
        pasaran_shioyear_shio_field = record[i]["shioyear_shio"];
        pasaran_limitglobal_shio_field = record[i]["limitglobal_shio"];
        pasaran_limittotal_shio_field = record[i]["limittotal_shio"];
      }
    }
  }
  const newAdmin = () => {
    sData = "New";
    admin_username_flag_field = false;
    let myModalAdmin = new bootstrap.Modal(
      document.getElementById("modalNewAdmin")
    );
    myModalAdmin.show();
  };
  const editAdmin = (username, nama, status) => {
    sData = "Edit";
    let myModalAdmin = new bootstrap.Modal(
      document.getElementById("modalNewAdmin")
    );
    myModalAdmin.show();
    admin_username_field = username;
    admin_username_flag_field = true;
    admin_password_field = "";
    admin_name_field = nama;
    admin_status_field = status;
  };
  async function SaveNewAdmin() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    msgloader = "Sending...";
    if (admin_username_field == "") {
      flag = true;
      msg += "The Username is required\n";
    }
    if (sData == "New") {
      if (admin_password_field == "") {
        flag = true;
        msg += "The Password is required\n";
      }
    }
    if (admin_name_field == "") {
      flag = true;
      msg += "The Name is required\n";
    }
    if (admin_status_field == "") {
      flag = true;
      msg += "The Status is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/savecompanyadmin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          admin_username: admin_username_field,
          admin_password: admin_password_field,
          admin_name: admin_name_field,
          admin_status: admin_status_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
        if (sData == "New") {
          admin_username_field = "";
          admin_password_field = "";
          admin_name_field = "";
          admin_status_field = "";
        }
        listAdmin = [];
        call_listadmin();
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      alert(msgloader);
    } else {
      alert(msg);
    }
  }
  const RefreshListAdmin = () => {
    call_listadmin()
  }
  const RefreshListPasaran = () => {
    call_listpasaran()
  }
  const newPasaran = () => {
    sData = "New";
    let myModalPasaran = new bootstrap.Modal(
      document.getElementById("modalNewPasaran")
    );
    myModalPasaran.show();
  };
  const editPasaran = (idcomppasaran, idpasarantogel, nmpasaran) => {
    if (company_status_field == "ACTIVE") {
      sData = "Edit";
      let myModalPasaran = new bootstrap.Modal(
        document.getElementById("modalEditPasaran")
      );
      myModalPasaran.show();
      listPasaranonline = [];
      pasaran_nmpasarantogel_field = nmpasaran;
      companypasaran_id_field = idcomppasaran;
      pasaran_id_field = idpasarantogel;
      call_listpasaranconf();
      call_listpasaranonline();
    } else {
      alert("Maaf Status Company ini adalah Deactive");
    }
  };
  async function saveNewPasaran() {
    let flag = false;
    let msg = "";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/savecompanypasaran", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          pasaran_alias: pasaran_alias_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      pasaran_id_field = "";
      pasaran_alias_field = "";
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }

  function autofetchAll() {
    msgloader = "Sending...";
    let command = [
      "limitline","432d","cbebas",
      "cmacau","cnaga","cjitu",
      "50umum","50spc","50kombinasi",
      "macau","dasar","shio","onlinemarket"
    ]
    
    for (let i = 0; i < command.length; i++) {
      setTimeout(function () {
        console.log(command[i]);
        fetchQueue(command[i]);
      }, i * 5000);
    }
      
  }

  function fetchQueue(command) {
    switch (command) {
      case "limitline":
        fetchlimitline(); 
        break;
      case "432d":
        fetch432d();
        break;
      case "cbebas":
        fetchcolokbebas();
        break;
      case "cmacau":
        fetchcolokmacau();
        break;
      case "cnaga":
        fetchcoloknaga();
        break;
      case "cjitu":
        fetchcolokjitu();
        break;        
      case "50umum":
        fetch5050umum();
        break;        
      case "50spc":
        fetch5050special();
        break;        
      case "50kombinasi":
        fetch5050kombinasi();
        break;        
      case "macau":
        fetchmacau();
        break;        
      case "dasar": 
        fetchdasar();
        break;        
      case "shio":
        fetchshio();
        break;        
      default:
        let days = ["minggu", "senin", "selasa", "rabu", "kamis", "jumat", "sabtu"];

        for (let i = 0; i < days.length; i++) {
          setTimeout(function () {
            console.log(days[i]);
            select_pasaranonline = days[i];
            savePasaranOnline();
          }, i * 5000);
        }
        msgloader = "Finished";
        break;        
    }

  }

  async function fetchlimitline() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaranlimitline", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetch432d() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaran432", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchcolokbebas() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasarancbebas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchcolokmacau() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasarancmacau", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchcoloknaga() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasarancnaga", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchcolokjitu() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasarancjitu", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetch5050umum() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaran5050umum", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetch5050special() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaran5050special", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetch5050kombinasi() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaran5050kombinasi", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchmacau() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaranmacau", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchdasar() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasarandasar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function fetchshio() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (pasaran_id_field == "") {
      flag = true;
      msg += "The Pasaran is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/fetchpasaranshio", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          Companypasaran_id: companypasaran_id_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);

      call_listpasaranconf();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaran() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    msgloader = "Sending...";

    if (pasaran_urlpasaran_field == "") {
      flag = true;
      msg += "The Pasaran URL is required\n";
    }
    if (pasaran_pasarandiundi_field == "") {
      flag = true;
      msg += "The Pasaran diundi is required\n";
    }
    if (pasaran_jamtutup_field == "") {
      flag = true;
      msg += "The Pasaran Jam Tutup is required\n";
    }
    if (pasaran_jamjadwal_field == "") {
      flag = true;
      msg += "The Pasaran Jam Jadwal is required\n";
    }
    if (pasaran_jamopen_field == "") {
      flag = true;
      msg += "The Pasaran Jam Open is required\n";
    }
    if (pasaran_status_field == "") {
      flag = true;
      msg += "The Pasaran Status is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/savecompanyupdatepasaran", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_alias: pasaran_pasaranalias_field,
          pasaran_diundi: pasaran_pasarandiundi_field,
          pasaran_url: pasaran_urlpasaran_field,
          pasaran_jamtutup: pasaran_jamtutup_field,
          pasaran_jamjadwal: pasaran_jamjadwal_field,
          pasaran_jamopen: pasaran_jamopen_field,
          pasaran_statusactive: pasaran_status_field,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaranline() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    msgloader = "Sending...";

    if (pasaran_limitline4d_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 4D is required\n";
    }
    if (pasaran_limitline3d_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 3D is required\n";
    }
    if (pasaran_limitline3dd_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 3DD is required\n";
    }
    if (pasaran_limitline2d_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 2D is required\n";
    }
    if (pasaran_limitline2dd_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 2DD is required\n";
    }
    if (pasaran_limitline2dt_field == "") {
      flag = true;
      msg += "The Pasaran Limitline 2DT is required\n";
    }
    if (pasaran_bbfs_field == "") {
      flag = true;
      msg += "The Pasaran BBFS is required\n";
    }
    if (pasaran_minbasket_field == "") {
      flag = true;
      msg += "The Pasaran Minimal Total Keranjang is required\n";
    }
    if (flag == false) {
      const res = await fetch("/api/savecompanyupdatepasaranline", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          pasaran_id: pasaran_id_field,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_limitline_4d: parseInt(pasaran_limitline4d_field),
          pasaran_limitline_3d: parseInt(pasaran_limitline3d_field),
          pasaran_limitline_3dd: parseInt(pasaran_limitline3dd_field),
          pasaran_limitline_2d: parseInt(pasaran_limitline2d_field),
          pasaran_limitline_2dd: parseInt(pasaran_limitline2dd_field),
          pasaran_limitline_2dt: parseInt(pasaran_limitline2dt_field),
          pasaran_bbfs: parseInt(pasaran_bbfs_field),
          pasaran_minbasket: parseInt(pasaran_minbasket_field),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaran432() {
    let flag = false;
    let msg = "";
    
    if (pasaran_minbet_432d_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet4d_432d_field == "") {
      flag = true;
      msg += "The Max Bet 4D is required\n";
    }
    if (pasaran_maxbet3d_432d_field == "") {
      flag = true;
      msg += "The Max Bet 3D is required\n";
    }
    if (pasaran_maxbet3dd_432d_field == "") {
      flag = true;
      msg += "The Max Bet 3DD is required\n";
    }
    if (pasaran_maxbet2d_432d_field == "") {
      flag = true;
      msg += "The Max Bet 2D is required\n";
    }
    if (pasaran_maxbet2dd_432d_field == "") {
      flag = true;
      msg += "The Max Bet 2DD is required\n";
    }
    if (pasaran_maxbet2dt_432d_field == "") {
      flag = true;
      msg += "The Max Bet 2DT is required\n";
    }
    if (pasaran_limitotal4d_432d_field == "") {
      flag = true;
      msg += "The Limit Total 4D is required\n";
    }
    if (pasaran_limitotal3d_432d_field == "") {
      flag = true;
      msg += "The Limit Total 3D is required\n";
    }
    if (pasaran_limitotal3dd_432d_field == "") {
      flag = true;
      msg += "The Limit Total 3DD is required\n";
    }
    if (pasaran_limitotal2d_432d_field == "") {
      flag = true;
      msg += "The Limit Total 2D is required\n";
    }
    if (pasaran_limitotal2dd_432d_field == "") {
      flag = true;
      msg += "The Limit Total 2DD is required\n";
    }
    if (pasaran_limitotal2dt_432d_field == "") {
      flag = true;
      msg += "The Limit Total 2DT is required\n";
    }
    if (pasaran_limitglobal4d_432d_field == "") {
      flag = true;
      msg += "The Limit Global 4D is required\n";
    }
    if (pasaran_limitglobal3d_432d_field == "") {
      flag = true;
      msg += "The Limit Global 3D is required\n";
    }
    if (pasaran_limitglobal3dd_432d_field == "") {
      flag = true;
      msg += "The Limit Global 3DD is required\n";
    }
    if (pasaran_limitglobal2d_432d_field == "") {
      flag = true;
      msg += "The Limit Global 3D is required\n";
    }
    if (pasaran_limitglobal2dd_432d_field == "") {
      flag = true;
      msg += "The Limit Global 2DD is required\n";
    }
    if (pasaran_limitglobal2dt_432d_field == "") {
      flag = true;
      msg += "The Limit Global 2DT is required\n";
    }
    if (pasaran_win4d_432d_field == "") {
      flag = true;
      msg += "The Win 4D is required\n";
    }
    if (pasaran_win3d_432d_field == "") {
      flag = true;
      msg += "The Win 3D is required\n";
    }
    if (pasaran_win3dd_432d_field == "") {
      flag = true;
      msg += "The Win 3DD is required\n";
    }
    if (pasaran_win2d_432d_field == "") {
      flag = true;
      msg += "The Win 2D is required\n";
    }
    if (pasaran_win2dd_432d_field == "") {
      flag = true;
      msg += "The Win 2DD is required\n";
    }
    if (pasaran_win2dt_432d_field == "") {
      flag = true;
      msg += "The Win 2DT is required\n";
    }
    if (pasaran_win4d_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 4D NO DISKON is required\n";
    }
    if (pasaran_win3d_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 3D NO DISKON is required\n";
    }
    if (pasaran_win3dd_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 3DD NO DISKON is required\n";
    }
    if (pasaran_win2d_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 2D NO DISKON is required\n";
    }
    if (pasaran_win2dd_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 2DD NO DISKON is required\n";
    }
    if (pasaran_win2dt_nodisc_432d_field == "") {
      flag = true;
      msg += "The Win 2DT NO DISKON is required\n";
    }
    if (pasaran_win4d_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 4D BB KENA is required\n";
    }
    if (pasaran_win3d_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 3D BB KENA is required\n";
    }
    if (pasaran_win3dd_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 3DD BB KENA is required\n";
    }
    if (pasaran_win2d_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 2D BB KENA is required\n";
    }
    if (pasaran_win2dd_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 2DD BB KENA is required\n";
    }
    if (pasaran_win2dt_bb_kena_432d_field == "") {
      flag = true;
      msg += "The Win 2DT BB KENA is required\n";
    }
    if (pasaran_win4d_bb_432d_field == "") {
      flag = true;
      msg += "The Win 4D BB is required\n";
    }
    if (pasaran_win3d_bb_432d_field == "") {
      flag = true;
      msg += "The Win 3D BB is required\n";
    }
    if (pasaran_win3dd_bb_432d_field == "") {
      flag = true;
      msg += "The Win 3DD BB is required\n";
    }
    if (pasaran_win2d_bb_432d_field == "") {
      flag = true;
      msg += "The Win 2D BB is required\n";
    }
    if (pasaran_win2dd_bb_432d_field == "") {
      flag = true;
      msg += "The Win 2DD BB is required\n";
    }
    if (pasaran_win2dt_bb_432d_field == "") {
      flag = true;
      msg += "The Win 2DT BB is required\n";
    }
    if (pasaran_disc4d_432d_field == "") {
      flag = true;
      msg += "The Disc 4D is required\n";
    }
    if (pasaran_disc3d_432d_field == "") {
      flag = true;
      msg += "The Disc 3D is required\n";
    }
    if (pasaran_disc3dd_432d_field == "") {
      flag = true;
      msg += "The Disc 3DD is required\n";
    }
    if (pasaran_disc2d_432d_field == "") {
      flag = true;
      msg += "The Disc 2D is required\n";
    }
    if (pasaran_disc2dd_432d_field == "") {
      flag = true;
      msg += "The Disc 2DD is required\n";
    }
    if (pasaran_disc2dt_432d_field == "") {
      flag = true;
      msg += "The Disc 2DT is required\n";
    }
    if(parseInt(pasaran_minbet_432d_field) < parseInt(company_angka_max_minbet_field)){
      flag = true;
      msg += "The Minbet exceeds Max minbet\n";
    }
    if(parseInt(pasaran_maxbet4d_432d_field) > parseInt(company_angka_max_maxbet_4d_field)){
      flag = true;
      msg += "The Maxbet4D exceeds Max maxbet4D\n";
    }
    if(parseInt(pasaran_maxbet3d_432d_field) > parseInt(company_angka_max_maxbet_3d_field)){
      flag = true;
      msg += "The Maxbet3D exceeds Max maxbet3D\n";
    }
    if(parseInt(pasaran_maxbet3dd_432d_field) > parseInt(company_angka_max_maxbet_3dd_field)){
      flag = true;
      msg += "The Maxbet3DD exceeds Max maxbet3DD\n";
    }
    if(parseInt(pasaran_maxbet2d_432d_field) > parseInt(company_angka_max_maxbet_2d_field)){
      flag = true;
      msg += "The Maxbet2D exceeds Max maxbet2D\n";
    }
    if(parseInt(pasaran_maxbet2dd_432d_field) > parseInt(company_angka_max_maxbet_2dd_field)){
      flag = true;
      msg += "The Maxbet2DD exceeds Max maxbet2DD\n";
    }
    if(parseInt(pasaran_maxbet2dt_432d_field) > parseInt(company_angka_max_maxbet_2dt_field)){
      flag = true;
      msg += "The Maxbet2DT exceeds Max maxbet2DT\n";
    }
    if(parseInt(pasaran_maxbet4d_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_4d_bbdisc_field)){
      flag = true;
      msg += "The Maxbet4D BB/Disc exceeds Max Maxbet4D BB/Disc\n";
    }
    if(parseInt(pasaran_maxbet3d_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_3d_bbdisc_field)){
      flag = true;
      msg += "The Maxbet3D BB/Disc exceeds Max Maxbet3D BB/Disc\n";
    }
    if(parseInt(pasaran_maxbet3dd_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_3dd_bbdisc_field)){
      flag = true;
      msg += "The Maxbet3DD BB/Disc exceeds Max Maxbet3DD BB/Disc\n";
    }
    if(parseInt(pasaran_maxbet2d_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_2d_bbdisc_field)){
      flag = true;
      msg += "The Maxbet2D BB/Disc exceeds Max Maxbet2D BB/Disc\n";
    }
    if(parseInt(pasaran_maxbet2dd_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_2dd_bbdisc_field)){
      flag = true;
      msg += "The Maxbet2DD BB/Disc exceeds Max Maxbet2DD BB/Disc\n";
    }
    if(parseInt(pasaran_maxbet2dt_bbdisc_432d_field) > parseInt(company_angka_max_maxbet_2dt_bbdisc_field)){
      flag = true;
      msg += "The Maxbet2DT BB/Disc exceeds Max Maxbet2DT BB/Disc\n";
    }

    //DISC
    if(parseInt(pasaran_win4d_432d_field) > parseInt(company_angka_max_win4d_disc_field)){
      flag = true;
      msg += "The Win4D Disc exceeds Max Win4D Disc\n";
    }
    if(parseInt(pasaran_win3d_432d_field) > parseInt(company_angka_max_win3d_disc_field)){
      flag = true;
      msg += "The Win3D Disc exceeds Max Win3D\n";
    }
    if(parseInt(pasaran_win3dd_432d_field) > parseInt(company_angka_max_win3dd_disc_field)){
      flag = true;
      msg += "The Win3DD Disc exceeds Max Win3DD Disc\n";
    }
    if(parseInt(pasaran_win2d_432d_field) > parseInt(company_angka_max_win2d_disc_field)){
      flag = true;
      msg += "The Win2D Disc exceeds Max Win2D Disc\n";
    }
    if(parseInt(pasaran_win2dd_432d_field) > parseInt(company_angka_max_win2dd_disc_field)){
      flag = true;Win4D
      msg += "The Win2DD Disc exceeds Max Win2DD Disc\n";
    }
    if(parseInt(pasaran_win2dt_432d_field) > parseInt(company_angka_max_win2dt_disc_field)){
      flag = true;
      msg += "The Win2DT Disc exceeds Max Win2DT Disc\n";
    }

    //FULL
    if(parseInt(pasaran_win4d_nodisc_432d_field) > parseInt(company_angka_max_win4d_full_field)){
      flag = true;
      msg += "The Win4D Full exceeds Max Win4D Full\n";
    }
    if(parseInt(pasaran_win3d_nodisc_432d_field) > parseInt(company_angka_max_win3d_full_field)){
      flag = true;
      msg += "The Win3D Full exceeds Max Win3D Full\n";
    }
    if(parseInt(pasaran_win3dd_nodisc_432d_field) > parseInt(company_angka_max_win3dd_full_field)){
      flag = true;
      msg += "The Win3DD Full exceeds Max Win3DD Full\n";
    }
    if(parseInt(pasaran_win2d_nodisc_432d_field) > parseInt(company_angka_max_win2d_full_field)){
      flag = true;
      msg += "The Win2D Full exceeds Max Win2D Full\n";
    }
    if(parseInt(pasaran_win2dd_nodisc_432d_field) > parseInt(company_angka_max_win2dd_full_field)){
      flag = true;Win4D
      msg += "The Win2DD Full exceeds Max Win2DD Full\n";
    }
    if(parseInt(pasaran_win2dt_nodisc_432d_field) > parseInt(company_angka_max_win2dt_full_field)){
      flag = true;
      msg += "The Win2DT Full exceeds Max Win2DT Full\n";
    }

    //BB
    if(parseInt(pasaran_win4d_bb_432d_field) > parseInt(company_angka_max_win4d_bb_field)){
      flag = true;
      msg += "The Win4D BB exceeds Max Win4D BB\n";
    }
    if(parseInt(pasaran_win3d_bb_432d_field) > parseInt(company_angka_max_win3d_bb_field)){
      flag = true;
      msg += "The Win3D BB exceeds Max Win3D BB\n";
    }
    if(parseInt(pasaran_win3dd_bb_432d_field) > parseInt(company_angka_max_win3dd_bb_field)){
      flag = true;
      msg += "The Win3DD BB exceeds Max Win3DD BB\n";
    }
    if(parseInt(pasaran_win2d_bb_432d_field) > parseInt(company_angka_max_win2d_bb_field)){
      flag = true;
      msg += "The Win2D BB exceeds Max Win2D BB\n";
    }
    if(parseInt(pasaran_win2dd_bb_432d_field) > parseInt(company_angka_max_win2dd_bb_field)){
      flag = true;Win4D
      msg += "The Win2DD BB exceeds Max Win2DD BB\n";
    }
    if(parseInt(pasaran_win2dt_bb_432d_field) > parseInt(company_angka_max_win2dt_bb_field)){
      flag = true;
      msg += "The Win2DT BB exceeds Max Win2DT BB\n";
    }

    //BB KENA
    if(parseInt(pasaran_win4d_bb_kena_432d_field) > parseInt(company_angka_max_win4d_bbkena_field)){
      flag = true;
      msg += "The Win4D BBKENA exceeds Max Win4D BBKENA\n";
    }
    if(parseInt(pasaran_win3d_bb_kena_432d_field) > parseInt(company_angka_max_win3d_bbkena_field)){
      flag = true;
      msg += "The Win3D BBKENA exceeds Max Win3D BBKENA\n";
    }
    if(parseInt(pasaran_win3dd_bb_kena_432d_field) > parseInt(company_angka_max_win3dd_bbkena_field)){
      flag = true;
      msg += "The Win3DD BBKENA exceeds Max Win3DD BBKENA\n";
    }
    if(parseInt(pasaran_win2d_bb_kena_432d_field) > parseInt(company_angka_max_win2d_bbkena_field)){
      flag = true;
      msg += "The Win2D BBKENA exceeds Max Win2D BBKENA\n";
    }
    if(parseInt(pasaran_win2dd_bb_kena_432d_field) > parseInt(company_angka_max_win2dd_bbkena_field)){
      flag = true;Win4D
      msg += "The Win2DD BBKENA exceeds Max Win2DD BBKENA\n";
    }
    if(parseInt(pasaran_win2dt_bb_kena_432d_field) > parseInt(company_angka_max_win2dt_bbkena_field)){
      flag = true;
      msg += "The Win2DT BBKENA exceeds Max Win2DT BBKENA\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasaran432", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          pasaran_id: pasaran_id_field,
          companypasaran_id: companypasaran_id_field,
          pasaran_minbet_432d: parseInt(pasaran_minbet_432d_field),
          pasaran_maxbet4d_432d: parseInt(pasaran_maxbet4d_432d_field),
          pasaran_maxbet3d_432d: parseInt(pasaran_maxbet3d_432d_field),
          pasaran_maxbet3dd_432d: parseInt(pasaran_maxbet3dd_432d_field),
          pasaran_maxbet2d_432d: parseInt(pasaran_maxbet2d_432d_field),
          pasaran_maxbet2dd_432d: parseInt(pasaran_maxbet2dd_432d_field),
          pasaran_maxbet2dt_432d: parseInt(pasaran_maxbet2dt_432d_field),
          pasaran_maxbet4d_bbdisc_432d: parseInt(pasaran_maxbet4d_bbdisc_432d_field),
          pasaran_maxbet3d_bbdisc_432d: parseInt(pasaran_maxbet3d_bbdisc_432d_field),
          pasaran_maxbet3dd_bbdisc_432d: parseInt(pasaran_maxbet3dd_bbdisc_432d_field),
          pasaran_maxbet2d_bbdisc_432d: parseInt(pasaran_maxbet2d_bbdisc_432d_field),
          pasaran_maxbet2dd_bbdisc_432d: parseInt(pasaran_maxbet2dd_bbdisc_432d_field),
          pasaran_maxbet2dt_bbdisc_432d: parseInt(pasaran_maxbet2dt_bbdisc_432d_field),
          pasaran_limitotal4d_432d: parseInt(pasaran_limitotal4d_432d_field),
          pasaran_limitotal3d_432d: parseInt(pasaran_limitotal3d_432d_field),
          pasaran_limitotal3dd_432d: parseInt(pasaran_limitotal3dd_432d_field),
          pasaran_limitotal2d_432d: parseInt(pasaran_limitotal2d_432d_field),
          pasaran_limitotal2dd_432d: parseInt(pasaran_limitotal2dd_432d_field),
          pasaran_limitotal2dt_432d: parseInt(pasaran_limitotal2dt_432d_field),
          pasaran_limitglobal4d_432d: parseInt(pasaran_limitglobal4d_432d_field),
          pasaran_limitglobal3d_432d: parseInt(pasaran_limitglobal3d_432d_field),
          pasaran_limitglobal3dd_432d: parseInt(pasaran_limitglobal3dd_432d_field),
          pasaran_limitglobal2d_432d: parseInt(pasaran_limitglobal2d_432d_field),
          pasaran_limitglobal2dd_432d: parseInt(pasaran_limitglobal2dd_432d_field),
          pasaran_limitglobal2dt_432d: parseInt(pasaran_limitglobal2dt_432d_field),
          pasaran_win4d_432d: parseInt(pasaran_win4d_432d_field),
          pasaran_win3d_432d: parseInt(pasaran_win3d_432d_field),
          pasaran_win3dd_432d: parseInt(pasaran_win3dd_432d_field),
          pasaran_win2d_432d: parseInt(pasaran_win2d_432d_field),
          pasaran_win2dd_432d: parseInt(pasaran_win2dd_432d_field),
          pasaran_win2dt_432d: parseInt(pasaran_win2dt_432d_field),
          pasaran_win4dnodisc_432d: parseInt(pasaran_win4d_nodisc_432d_field),
          pasaran_win3dnodisc_432d: parseInt(pasaran_win3d_nodisc_432d_field),
          pasaran_win3ddnodisc_432d: parseInt(pasaran_win3dd_nodisc_432d_field),
          pasaran_win2dnodisc_432d: parseInt(pasaran_win2d_nodisc_432d_field),
          pasaran_win2ddnodisc_432d: parseInt(pasaran_win2dd_nodisc_432d_field),
          pasaran_win2dtnodisc_432d: parseInt(pasaran_win2dt_nodisc_432d_field),
          pasaran_win4d_bb_kena_432d: parseInt(pasaran_win4d_bb_kena_432d_field),
          pasaran_win3d_bb_kena_432d: parseInt(pasaran_win3d_bb_kena_432d_field),
          pasaran_win3dd_bb_kena_432d: parseInt(pasaran_win3dd_bb_kena_432d_field),
          pasaran_win2d_bb_kena_432d: parseInt(pasaran_win2d_bb_kena_432d_field),
          pasaran_win2dd_bb_kena_432d: parseInt(pasaran_win2dd_bb_kena_432d_field),
          pasaran_win2dt_bb_kena_432d: parseInt(pasaran_win2dt_bb_kena_432d_field),
          pasaran_win4d_bb_432d: parseInt(pasaran_win4d_bb_432d_field),
          pasaran_win3d_bb_432d: parseInt(pasaran_win3d_bb_432d_field),
          pasaran_win3dd_bb_432d: parseInt(pasaran_win3dd_bb_432d_field),
          pasaran_win2d_bb_432d: parseInt(pasaran_win2d_bb_432d_field),
          pasaran_win2dd_bb_432d: parseInt(pasaran_win2dd_bb_432d_field),
          pasaran_win2dt_bb_432d: parseInt(pasaran_win2dt_bb_432d_field),
          pasaran_disc4d_432d: parseFloat(pasaran_disc4d_432d_field / 100),
          pasaran_disc3d_432d: parseFloat(pasaran_disc3d_432d_field / 100),
          pasaran_disc3dd_432d: parseFloat(pasaran_disc3dd_432d_field / 100),
          pasaran_disc2d_432d: parseFloat(pasaran_disc2d_432d_field / 100),
          pasaran_disc2dd_432d: parseFloat(pasaran_disc2dd_432d_field / 100),
          pasaran_disc2dt_432d: parseFloat(pasaran_disc2dt_432d_field / 100),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarancolokbebas() {
    let flag = false;
    let msg = "";
    
    if (pasaran_minbet_cbebas_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_cbebas_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limitotal_cbebas_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_cbebas_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_win_cbebas_field == "") {
      flag = true;
      msg += "The Win is required\n";
    }
    if (pasaran_disc_cbebas_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_cbebas_field) < parseInt(company_cbebas_max_minbet_field)){
      flag = true;
      msg += "The Cbebas Minbet exceeds Cbebas Max minbet\n";
    }
    if(parseInt(pasaran_maxbet_cbebas_field) > parseInt(company_cbebas_max_maxbet_field)){
      flag = true;
      msg += "The Cbebas Maxbet exceeds Cbebas Max maxbet\n";
    }
    if(parseFloat(pasaran_win_cbebas_field) > parseFloat(company_cbebas_max_win_field)){
      flag = true;
      msg += "The Cbebas Win exceeds Cbebas Max Win\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarancolokbebas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_cbebas: parseInt(pasaran_minbet_cbebas_field),
          pasaran_maxbet_cbebas: parseInt(pasaran_maxbet_cbebas_field),
          pasaran_limitotal_cbebas: parseInt(pasaran_limitotal_cbebas_field),
          pasaran_limitglobal_cbebas: parseInt(pasaran_limitglobal_cbebas_field),
          pasaran_win_cbebas: parseFloat(pasaran_win_cbebas_field),
          pasaran_disc_cbebas: parseFloat(pasaran_disc_cbebas_field / 100),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarancolokmacau() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_cmacau_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_cmacau_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limitotal_cmacau_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_cmacau_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_win2_cmacau_field == "") {
      flag = true;
      msg += "The Win 2 Digit is required\n";
    }
    if (pasaran_win3_cmacau_field == "") {
      flag = true;
      msg += "The Win 3 Digit is required\n";
    }
    if (pasaran_win4_cmacau_field == "") {
      flag = true;
      msg += "The Win 4 Digit is required\n";
    }
    if (pasaran_disc_cmacau_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_cmacau_field) < parseInt(company_cmacau_max_minbet_field)){
      flag = true;
      msg += "The Cmacau Minbet exceeds Cmacau Max minbet\n";
    }
    if(parseInt(pasaran_maxbet_cmacau_field) > parseInt(company_cmacau_max_maxbet_field)){
      flag = true;
      msg += "The Cmacau Maxbet exceeds Cmacau Max maxbet\n";
    }
    if(parseFloat(pasaran_win2_cmacau_field) > parseFloat(company_cmacau_max_win2_field)){
      flag = true;
      msg += "The Cmacau Win2 exceeds Cmacau Max Win2\n";
    }
    if(parseFloat(pasaran_win3_cmacau_field) > parseFloat(company_cmacau_max_win3_field)){
      flag = true;
      msg += "The Cmacau Win3 exceeds Cmacau Max Win3\n";
    }
    if(parseFloat(pasaran_win4_cmacau_field) > parseFloat(company_cmacau_max_win4_field)){
      flag = true;
      msg += "The Cmacau Win4 exceeds Cmacau Max Win4\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarancolokmacau", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_cmacau: parseInt(pasaran_minbet_cmacau_field),
          pasaran_maxbet_cmacau: parseInt(pasaran_maxbet_cmacau_field),
          pasaran_limitotal_cmacau: parseInt(pasaran_limitotal_cmacau_field),
          pasaran_limitglobal_cmacau: parseInt(pasaran_limitglobal_cmacau_field),
          pasaran_win2_cmacau: parseFloat(pasaran_win2_cmacau_field),
          pasaran_win3_cmacau: parseFloat(pasaran_win3_cmacau_field),
          pasaran_win4_cmacau: parseFloat(pasaran_win4_cmacau_field),
          pasaran_disc_cmacau: parseFloat(pasaran_disc_cmacau_field / 100),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarancoloknaga() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_cnaga_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_cnaga_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_cnaga_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_cnaga_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_win3_cnaga_field == "") {
      flag = true;
      msg += "The Win 3 Digit is required\n";
    }
    if (pasaran_win4_cnaga_field == "") {
      flag = true;
      msg += "The Win 4 Digit is required\n";
    }
    if (pasaran_disc_cnaga_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_cnaga_field) < parseInt(company_cnaga_max_minbet_field)){
      flag = true;
      msg += "The Cnaga Minbet exceeds Cnaga Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_cnaga_field) > parseInt(company_cnaga_max_maxbet_field)){
      flag = true;
      msg += "The Cnaga Maxbet exceeds Cnaga Max maxbet\n";
    }
    if(parseFloat(pasaran_win3_cnaga_field) > parseFloat(company_cnaga_max_win3_field)){
      flag = true;
      msg += "The Cnaga Win3 exceeds Cnaga Max Win3\n";
    }
    if(parseFloat(pasaran_win4_cnaga_field) > parseFloat(company_cnaga_max_win4_field)){
      flag = true;
      msg += "The Cnaga Win4 exceeds Cnaga Max Win4\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarancoloknaga", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_cnaga: parseInt(pasaran_minbet_cnaga_field),
          pasaran_maxbet_cnaga: parseInt(pasaran_maxbet_cnaga_field),
          pasaran_limittotal_cnaga: parseInt(pasaran_limittotal_cnaga_field),
          pasaran_limitglobal_cnaga: parseInt(pasaran_limitglobal_cnaga_field),
          pasaran_win3_cnaga: parseFloat(pasaran_win3_cnaga_field),
          pasaran_win4_cnaga: parseFloat(pasaran_win4_cnaga_field),
          pasaran_disc_cnaga: parseFloat(pasaran_disc_cnaga_field / 100),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarancolokjitu() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_cjitu_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_cjitu_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_cjitu_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_cjitu_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_winas_cjitu_field == "") {
      flag = true;
      msg += "The Win AS is required\n";
    }
    if (pasaran_winkop_cjitu_field == "") {
      flag = true;
      msg += "The Win KOP is required\n";
    }
    if (pasaran_winkepala_cjitu_field == "") {
      flag = true;
      msg += "The Win KEPALA is required\n";
    }
    if (pasaran_winekor_cjitu_field == "") {
      flag = true;
      msg += "The Win EKOR is required\n";
    }
    if (pasaran_desc_cjitu_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_cjitu_field) < parseInt(company_cjitu_max_minbet_field)){
      flag = true;
      msg += "The Cjitu Minbet exceeds Cjitu Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_cjitu_field) > parseInt(company_cjitu_max_maxbet_field)){
      flag = true;
      msg += "The Cjitu Maxbet exceeds Cjitu Max maxbet\n";
    }
    if(parseFloat(pasaran_winas_cjitu_field) > parseFloat(company_cjitu_max_winas_field)){
      flag = true;
      msg += "The Cjitu WinAs exceeds Cjitu Max Win3\n";
    }
    if(parseFloat(pasaran_winkop_cjitu_field) > parseFloat(company_cjitu_max_winkop_field)){
      flag = true;
      msg += "The Cjitu WinKop exceeds Cjitu Max Win4\n";
    }
    if(parseFloat(pasaran_winkepala_cjitu_field) > parseFloat(company_cjitu_max_winkepala_field)){
      flag = true;
      msg += "The Cjitu WinKepala exceeds Cjitu Max Win4\n";
    }
    if(parseFloat(pasaran_winekor_cjitu_field) > parseFloat(company_cjitu_max_winekor_field)){
      flag = true;
      msg += "The Cjitu WinEkor exceeds Cjitu Max Win4\n";
    }
  
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarancolokjitu", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_cjitu: parseInt(pasaran_minbet_cjitu_field),
          pasaran_maxbet_cjitu: parseInt(pasaran_maxbet_cjitu_field),
          pasaran_limittotal_cjitu: parseInt(pasaran_limittotal_cjitu_field),
          pasaran_limitglobal_cjitu: parseInt(pasaran_limitglobal_cjitu_field),
          pasaran_winas_cjitu: parseFloat(pasaran_winas_cjitu_field),
          pasaran_winkop_cjitu: parseFloat(pasaran_winkop_cjitu_field),
          pasaran_winkepala_cjitu: parseFloat(pasaran_winkepala_cjitu_field),
          pasaran_winekor_cjitu: parseFloat(pasaran_winekor_cjitu_field),
          pasaran_desc_cjitu: parseFloat(pasaran_desc_cjitu_field / 100),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaran5050umum() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_5050umum_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_5050umum_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_5050umum_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_5050umum_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_keibesar_5050umum_field == "") {
      flag = true;
      msg += "The Kei Besar is required\n";
    }
    if (pasaran_keikecil_5050umum_field == "") {
      flag = true;
      msg += "The Kei Kecil is required\n";
    }
    if (pasaran_keigenap_5050umum_field == "") {
      flag = true;
      msg += "The Kei Genap is required\n";
    }
    if (pasaran_keiganjil_5050umum_field == "") {
      flag = true;
      msg += "The Kei Ganjil is required\n";
    }
    if (pasaran_keitengah_5050umum_field == "") {
      flag = true;
      msg += "The Kei Tengah is required\n";
    }
    if (pasaran_keitepi_5050umum_field == "") {
      flag = true;
      msg += "The Kei Tepi is required\n";
    }
    if (pasaran_discbesar_5050umum_field == "") {
      flag = true;
      msg += "The Disc Besar is required\n";
    }
    if (pasaran_disckecil_5050umum_field == "") {
      flag = true;
      msg += "The Disc Kecil is required\n";
    }
    if (pasaran_discgenap_5050umum_field == "") {
      flag = true;
      msg += "The Disc Genap is required\n";
    }
    if (pasaran_discganjil_5050umum_field == "") {
      flag = true;
      msg += "The Disc Ganjil is required\n";
    }
    if (pasaran_disctengah_5050umum_field == "") {
      flag = true;
      msg += "The Disc Tengah is required\n";
    }
    if (pasaran_disctepi_5050umum_field == "") {
      flag = true;
      msg += "The Disc Tepi is required\n";
    }
    if(parseInt(pasaran_minbet_5050umum_field) < parseInt(company_umum50_max_minbet_field)){
      flag = true;
      msg += "The 5050Umum Minbet exceeds 5050Umum Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_5050umum_field) > parseInt(company_umum50_max_maxbet_field)){
      flag = true;
      msg += "The 5050Umum Maxbet exceeds 5050Umum Max maxbet\n";
    }
    
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasaran5050umum", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_5050umum: parseInt(pasaran_minbet_5050umum_field),
          pasaran_maxbet_5050umum: parseInt(pasaran_maxbet_5050umum_field),
          pasaran_limittotal_5050umum: parseInt(
            pasaran_limittotal_5050umum_field
          ),
          pasaran_limitglobal_5050umum: parseInt(
            pasaran_limitglobal_5050umum_field
          ),
          pasaran_keibesar_5050umum: parseFloat(
            (pasaran_keibesar_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_keikecil_5050umum: parseFloat(
            (pasaran_keikecil_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_keigenap_5050umum: parseFloat(
            (pasaran_keigenap_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_keiganjil_5050umum: parseFloat(
            (pasaran_keiganjil_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_keitengah_5050umum: parseFloat(
            (pasaran_keitengah_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_keitepi_5050umum: parseFloat(
            (pasaran_keitepi_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_discbesar_5050umum: parseFloat(
            (pasaran_discbesar_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_disckecil_5050umum: parseFloat(
            (pasaran_disckecil_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_discgenap_5050umum: parseFloat(
            (pasaran_discgenap_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_discganjil_5050umum: parseFloat(
            (pasaran_discganjil_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_disctengah_5050umum: parseFloat(
            (pasaran_disctengah_5050umum_field / 100).toPrecision(3)
          ),
          pasaran_disctepi_5050umum: parseFloat(
            (pasaran_disctepi_5050umum_field / 100).toPrecision(3)
          ),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaran5050special() {
    let flag = false;
    let msg = "";
    
    if (pasaran_minbet_5050special_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_5050special_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_5050special_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_5050special_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_keiasganjil_5050special_field == "") {
      flag = true;
      msg += "The Kei AS Ganjil is required\n";
    }
    if (pasaran_keiasgenap_5050special_field == "") {
      flag = true;
      msg += "The Kei As Genap is required\n";
    }
    if (pasaran_keiasbesar_5050special_field == "") {
      flag = true;
      msg += "The Kei As Besar is required\n";
    }
    if (pasaran_keiaskecil_5050special_field == "") {
      flag = true;
      msg += "The Kei As Kecil is required\n";
    }
    if (pasaran_keikopganjil_5050special_field == "") {
      flag = true;
      msg += "The Kei Kop Ganjil is required\n";
    }
    if (pasaran_keikopgenap_5050special_field == "") {
      flag = true;
      msg += "The Kei Kop Genap is required\n";
    }
    if (pasaran_keikopbesar_5050special_field == "") {
      flag = true;
      msg += "The Kei Kop Besar is required\n";
    }
    if (pasaran_keikopkecil_5050special_field == "") {
      flag = true;
      msg += "The Kei Kop Kecil is required\n";
    }
    if (pasaran_keikepalaganjil_5050special_field == "") {
      flag = true;
      msg += "The Kei Kepala Ganjil is required\n";
    }
    if (pasaran_keikepalagenap_5050special_field == "") {
      flag = true;
      msg += "The Kei Kepala Genap is required\n";
    }
    if (pasaran_keikepalabesar_5050special_field == "") {
      flag = true;
      msg += "The Kei Kepala Besar is required\n";
    }
    if (pasaran_keikepalakecil_5050special_field == "") {
      flag = true;
      msg += "The Kei Kepala Kecil is required\n";
    }
    if (pasaran_keiekorganjil_5050special_field == "") {
      flag = true;
      msg += "The Kei Ekor Ganjil is required\n";
    }
    if (pasaran_keiekorgenap_5050special_field == "") {
      flag = true;
      msg += "The Kei Ekor Genap is required\n";
    }
    if (pasaran_keiekorbesar_5050special_field == "") {
      flag = true;
      msg += "The Kei Ekor Besar is required\n";
    }
    if (pasaran_keiekorkecil_5050special_field == "") {
      flag = true;
      msg += "The Kei Ekor Kecil is required\n";
    }
    if (pasaran_discasganjil_5050special_field == "") {
      flag = true;
      msg += "The Disc As Ganjil is required\n";
    }
    if (pasaran_discasgenap_5050special_field == "") {
      flag = true;
      msg += "The Disc As Genap is required\n";
    }
    if (pasaran_discasbesar_5050special_field == "") {
      flag = true;
      msg += "The Disc As Besar is required\n";
    }
    if (pasaran_discaskecil_5050special_field == "") {
      flag = true;
      msg += "The Disc As Kecil is required\n";
    }
    if (pasaran_disckopganjil_5050special_field == "") {
      flag = true;
      msg += "The Disc Kop Ganjil is required\n";
    }
    if (pasaran_disckopgenap_5050special_field == "") {
      flag = true;
      msg += "The Disc Kop Genap is required\n";
    }
    if (pasaran_disckopbesar_5050special_field == "") {
      flag = true;
      msg += "The Disc Kop Besar is required\n";
    }
    if (pasaran_disckopkecil_5050special_field == "") {
      flag = true;
      msg += "The Disc Kop Kecil is required\n";
    }
    if (pasaran_disckepalaganjil_5050special_field == "") {
      flag = true;
      msg += "The Disc Kepala Ganjil is required\n";
    }
    if (pasaran_disckepalagenap_5050special_field == "") {
      flag = true;
      msg += "The Disc Kepala Genap is required\n";
    }
    if (pasaran_disckepalabesar_5050special_field == "") {
      flag = true;
      msg += "The Disc Kepala Besar is required\n";
    }
    if (pasaran_disckepalakecil_5050special_field == "") {
      flag = true;
      msg += "The Disc Kepala Kecil is required\n";
    }
    if (pasaran_discekorganjil_5050special_field == "") {
      flag = true;
      msg += "The Disc Ekor Ganjil is required\n";
    }
    if (pasaran_discekorgenap_5050special_field == "") {
      flag = true;
      msg += "The Disc Ekor Genap is required\n";
    }
    if (pasaran_discekorbesar_5050special_field == "") {
      flag = true;
      msg += "The Disc Ekor Besar is required\n";
    }
    if (pasaran_discekorkecil_5050special_field == "") {
      flag = true;
      msg += "The Disc Ekor Kecil is required\n";
    }
    if(parseInt(pasaran_minbet_5050special_field) < parseInt(company_special50_max_minbet_field)){
      flag = true;
      msg += "The 5050Special Minbet exceeds 5050Special Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_5050special_field) > parseInt(company_special50_max_maxbet_field)){
      flag = true;
      msg += "The 5050Special Maxbet exceeds 5050Special Max maxbet\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasaran5050special", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_5050special: parseInt(pasaran_minbet_5050special_field),
          pasaran_maxbet_5050special: parseInt(pasaran_maxbet_5050special_field),
          pasaran_limitglobal_5050special: parseInt(
            pasaran_limitglobal_5050special_field
          ),
          pasaran_limittotal_5050special: parseInt(
            pasaran_limittotal_5050special_field
          ),
          pasaran_keiasganjil_5050special: parseFloat(
            pasaran_keiasganjil_5050special_field / 100
          ),
          pasaran_keiasgenap_5050special: parseFloat(
            pasaran_keiasgenap_5050special_field / 100
          ),
          pasaran_keiasbesar_5050special: parseFloat(
            pasaran_keiasbesar_5050special_field / 100
          ),
          pasaran_keiaskecil_5050special: parseFloat(
            pasaran_keiaskecil_5050special_field / 100
          ),
          pasaran_keikopganjil_5050special: parseFloat(
            pasaran_keikopganjil_5050special_field / 100
          ),
          pasaran_keikopgenap_5050special: parseFloat(
            pasaran_keikopgenap_5050special_field / 100
          ),
          pasaran_keikopbesar_5050special: parseFloat(
            pasaran_keikopbesar_5050special_field / 100
          ),
          pasaran_keikopkecil_5050special: parseFloat(
            pasaran_keikopkecil_5050special_field / 100
          ),
          pasaran_keikepalaganjil_5050special: parseFloat(
            pasaran_keikepalaganjil_5050special_field / 100
          ),
          pasaran_keikepalagenap_5050special: parseFloat(
            pasaran_keikepalagenap_5050special_field / 100
          ),
          pasaran_keikepalabesar_5050special: parseFloat(
            pasaran_keikepalabesar_5050special_field / 100
          ),
          pasaran_keikepalakecil_5050special: parseFloat(
            pasaran_keikepalakecil_5050special_field / 100
          ),
          pasaran_keiekorganjil_5050special: parseFloat(
            pasaran_keiekorganjil_5050special_field / 100
          ),
          pasaran_keiekorgenap_5050special: parseFloat(
            pasaran_keiekorgenap_5050special_field / 100
          ),
          pasaran_keiekorbesar_5050special: parseFloat(
            pasaran_keiekorbesar_5050special_field / 100
          ),
          pasaran_keiekorkecil_5050special: parseFloat(
            pasaran_keiekorkecil_5050special_field / 100
          ),
          pasaran_discasganjil_5050special: parseFloat(
            pasaran_discasganjil_5050special_field / 100
          ),
          pasaran_discasgenap_5050special: parseFloat(
            pasaran_discasgenap_5050special_field / 100
          ),
          pasaran_discasbesar_5050special: parseFloat(
            pasaran_discasbesar_5050special_field / 100
          ),
          pasaran_discaskecil_5050special: parseFloat(
            pasaran_discaskecil_5050special_field / 100
          ),
          pasaran_disckopganjil_5050special: parseFloat(
            pasaran_disckopganjil_5050special_field / 100
          ),
          pasaran_disckopgenap_5050special: parseFloat(
            pasaran_disckopgenap_5050special_field / 100
          ),
          pasaran_disckopbesar_5050special: parseFloat(
            pasaran_disckopbesar_5050special_field / 100
          ),
          pasaran_disckopkecil_5050special: parseFloat(
            pasaran_disckopkecil_5050special_field / 100
          ),
          pasaran_disckepalaganjil_5050special: parseFloat(
            pasaran_disckepalaganjil_5050special_field / 100
          ),
          pasaran_disckepalagenap_5050special: parseFloat(
            pasaran_disckepalagenap_5050special_field / 100
          ),
          pasaran_disckepalabesar_5050special: parseFloat(
            pasaran_disckepalabesar_5050special_field / 100
          ),
          pasaran_disckepalakecil_5050special: parseFloat(
            pasaran_disckepalakecil_5050special_field / 100
          ),
          pasaran_discekorganjil_5050special: parseFloat(
            pasaran_discekorganjil_5050special_field / 100
          ),
          pasaran_discekorgenap_5050special: parseFloat(
            pasaran_discekorgenap_5050special_field / 100
          ),
          pasaran_discekorbesar_5050special: parseFloat(
            pasaran_discekorbesar_5050special_field / 100
          ),
          pasaran_discekorkecil_5050special: parseFloat(
            pasaran_discekorkecil_5050special_field / 100
          ),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaran5050kombinasi() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_5050kombinasi_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_5050kombinasi_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_5050kombinasi_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_5050kombinasi_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_belakangkeimono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Kei Mono is required\n";
    }
    if (pasaran_belakangkeistereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Kei Stereo is required\n";
    }
    if (pasaran_belakangkeikembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Kei Kembang is required\n";
    }
    if (pasaran_belakangkeikempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Kei Kempis is required\n";
    }
    if (pasaran_belakangkeikembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Kei Kembar is required\n";
    }
    if (pasaran_tengahkeimono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Kei Mono is required\n";
    }
    if (pasaran_tengahkeistereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Kei Stereo is required\n";
    }
    if (pasaran_tengahkeikembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Kei Kembang is required\n";
    }
    if (pasaran_tengahkeikempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Kei Kempis is required\n";
    }
    if (pasaran_tengahkeikembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Kei Kembar is required\n";
    }
    if (pasaran_depankeimono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Kei Mono is required\n";
    }
    if (pasaran_depankeistereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Kei Stereo is required\n";
    }
    if (pasaran_depankeikembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Kei Kembang is required\n";
    }
    if (pasaran_depankeikempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Kei Kempis is required\n";
    }
    if (pasaran_depankeikembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Kei Kembar is required\n";
    }
    if (pasaran_belakangdiscmono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Disc Mono is required\n";
    }
    if (pasaran_belakangdiscstereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Disc Stereo is required\n";
    }
    if (pasaran_belakangdisckembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Disc Kembang is required\n";
    }
    if (pasaran_belakangdisckempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Disc Kempis is required\n";
    }
    if (pasaran_belakangdisckembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Belakang Disc Kembar is required\n";
    }
    if (pasaran_tengahdiscmono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Disc Mono is required\n";
    }
    if (pasaran_tengahdiscstereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Disc Stereo is required\n";
    }
    if (pasaran_tengahdisckembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Disc Kembang is required\n";
    }
    if (pasaran_tengahdisckempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Disc Kempis is required\n";
    }
    if (pasaran_tengahdisckembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Tengah Disc Kembar is required\n";
    }
    if (pasaran_depandiscmono_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Disc Mono is required\n";
    }
    if (pasaran_depandiscstereo_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Disc Stereo is required\n";
    }
    if (pasaran_depandisckembang_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Disc Kembang is required\n";
    }
    if (pasaran_depandisckempis_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Disc Kempis is required\n";
    }
    if (pasaran_depandisckembar_5050kombinasi_field == "") {
      flag = true;
      msg += "The Depan Disc Kembar is required\n";
    }
    if(parseInt(pasaran_minbet_5050kombinasi_field) < parseInt(company_kombinasi50_max_minbet_field)){
      flag = true;
      msg += "The 5050Kombinasi Minbet exceeds 5050Kombinasi Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_5050kombinasi_field) > parseInt(company_kombinasi50_max_maxbet_field)){
      flag = true;
      msg += "The 5050Kombinasi Maxbet exceeds 5050Kombinasi Max maxbet\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasaran5050kombinasi", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_5050kombinasi: parseInt(pasaran_minbet_5050kombinasi_field),
          pasaran_maxbet_5050kombinasi: parseInt(pasaran_maxbet_5050kombinasi_field),
          pasaran_limitglobal_5050kombinasi: parseInt(
            pasaran_limitglobal_5050kombinasi_field
          ),
          pasaran_limittotal_5050kombinasi: parseInt(
            pasaran_limittotal_5050kombinasi_field
          ),
          pasaran_belakangkeimono_5050kombinasi: parseFloat(
            pasaran_belakangkeimono_5050kombinasi_field / 100
          ),
          pasaran_belakangkeistereo_5050kombinasi: parseFloat(
            pasaran_belakangkeistereo_5050kombinasi_field / 100
          ),
          pasaran_belakangkeikembang_5050kombinasi: parseFloat(
            pasaran_belakangkeikembang_5050kombinasi_field / 100
          ),
          pasaran_belakangkeikempis_5050kombinasi: parseFloat(
            pasaran_belakangkeikempis_5050kombinasi_field / 100
          ),
          pasaran_belakangkeikembar_5050kombinasi: parseFloat(
            pasaran_belakangkeikembar_5050kombinasi_field / 100
          ),
          pasaran_tengahkeimono_5050kombinasi: parseFloat(
            pasaran_tengahkeimono_5050kombinasi_field / 100
          ),
          pasaran_tengahkeistereo_5050kombinasi: parseFloat(
            pasaran_tengahkeistereo_5050kombinasi_field / 100
          ),
          pasaran_tengahkeikembang_5050kombinasi: parseFloat(
            pasaran_tengahkeikembang_5050kombinasi_field / 100
          ),
          pasaran_tengahkeikempis_5050kombinasi: parseFloat(
            pasaran_tengahkeikempis_5050kombinasi_field / 100
          ),
          pasaran_tengahkeikembar_5050kombinasi: parseFloat(
            pasaran_tengahkeikembar_5050kombinasi_field / 100
          ),
          pasaran_depankeimono_5050kombinasi: parseFloat(
            pasaran_depankeimono_5050kombinasi_field / 100
          ),
          pasaran_depankeistereo_5050kombinasi: parseFloat(
            pasaran_depankeistereo_5050kombinasi_field / 100
          ),
          pasaran_depankeikembang_5050kombinasi: parseFloat(
            pasaran_depankeikembang_5050kombinasi_field / 100
          ),
          pasaran_depankeikempis_5050kombinasi: parseFloat(
            pasaran_depankeikempis_5050kombinasi_field / 100
          ),
          pasaran_depankeikembar_5050kombinasi: parseFloat(
            pasaran_depankeikembar_5050kombinasi_field / 100
          ),
          pasaran_belakangdiscmono_5050kombinasi: parseFloat(
            pasaran_belakangdiscmono_5050kombinasi_field / 100
          ),
          pasaran_belakangdiscstereo_5050kombinasi: parseFloat(
            pasaran_belakangdiscstereo_5050kombinasi_field / 100
          ),
          pasaran_belakangdisckembang_5050kombinasi: parseFloat(
            pasaran_belakangdisckembang_5050kombinasi_field / 100
          ),
          pasaran_belakangdisckempis_5050kombinasi: parseFloat(
            pasaran_belakangdisckempis_5050kombinasi_field / 100
          ),
          pasaran_belakangdisckembar_5050kombinasi: parseFloat(
            pasaran_belakangdisckembar_5050kombinasi_field / 100
          ),
          pasaran_tengahdiscmono_5050kombinasi: parseFloat(
            pasaran_tengahdiscmono_5050kombinasi_field / 100
          ),
          pasaran_tengahdiscstereo_5050kombinasi: parseFloat(
            pasaran_tengahdiscstereo_5050kombinasi_field / 100
          ),
          pasaran_tengahdisckembang_5050kombinasi: parseFloat(
            pasaran_tengahdisckembang_5050kombinasi_field / 100
          ),
          pasaran_tengahdisckempis_5050kombinasi: parseFloat(
            pasaran_tengahdisckempis_5050kombinasi_field / 100
          ),
          pasaran_tengahdisckembar_5050kombinasi: parseFloat(
            pasaran_tengahdisckembar_5050kombinasi_field / 100
          ),
          pasaran_depandiscmono_5050kombinasi: parseFloat(
            pasaran_depandiscmono_5050kombinasi_field / 100
          ),
          pasaran_depandiscstereo_5050kombinasi: parseFloat(
            pasaran_depandiscstereo_5050kombinasi_field / 100
          ),
          pasaran_depandisckembang_5050kombinasi: parseFloat(
            pasaran_depandisckembang_5050kombinasi_field / 100
          ),
          pasaran_depandisckempis_5050kombinasi: parseFloat(
            pasaran_depandisckempis_5050kombinasi_field / 100
          ),
          pasaran_depandisckembar_5050kombinasi: parseFloat(
            pasaran_depandisckembar_5050kombinasi_field / 100
          ),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarankombinasi() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_kombinasi_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_kombinasi_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_kombinasi_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_kombinasi_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_win_kombinasi_field == "") {
      flag = true;
      msg += "The Win is required\n";
    }
    if (pasaran_disc_kombinasi_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_kombinasi_field) < parseInt(company_macau_max_minbet_field)){
      flag = true;
      msg += "The Macau Minbet exceeds Macau Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_kombinasi_field) > parseInt(company_macau_max_maxbet_field)){
      flag = true;
      msg += "The Macau Maxbet exceeds Macau Max maxbet\n";
    }
    if(parseFloat(pasaran_win_kombinasi_field) > parseFloat(company_macau_max_win_field)){
      flag = true;
      msg += "The Macau exceeds Macau Max Win\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarankombinasi", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_kombinasi: parseInt(pasaran_minbet_kombinasi_field),
          pasaran_maxbet_kombinasi: parseInt(pasaran_maxbet_kombinasi_field),
          pasaran_limittotal_kombinasi: parseInt(
            pasaran_limittotal_kombinasi_field
          ),
          pasaran_limitglobal_kombinasi: parseInt(
            pasaran_limitglobal_kombinasi_field
          ),
          pasaran_win_kombinasi: parseFloat(pasaran_win_kombinasi_field),
          pasaran_disc_kombinasi: parseFloat(
            (pasaran_disc_kombinasi_field / 100).toPrecision(3)
          ),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasarandasar() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_dasar_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_dasar_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_dasar_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_dasar_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_keibesar_dasar_field == "") {
      flag = true;
      msg += "The Kei Besar is required\n";
    }
    if (pasaran_keikecil_dasar_field == "") {
      flag = true;
      msg += "The Kei Kecil is required\n";
    }
    if (pasaran_keigenap_dasar_field == "") {
      flag = true;
      msg += "The Kei Genap is required\n";
    }
    if (pasaran_keiganjil_dasar_field == "") {
      flag = true;
      msg += "The Kei Ganjil is required\n";
    }
    if (pasaran_discbesar_dasar_field == "") {
      flag = true;
      msg += "The Diskon Besar is required\n";
    }
    if (pasaran_disckecil_dasar_field == "") {
      flag = true;
      msg += "The Diskon Kecil is required\n";
    }
    if (pasaran_discgenap_dasar_field == "") {
      flag = true;
      msg += "The Diskon Genap is required\n";
    }
    if (pasaran_discganjil_dasar_field == "") {
      flag = true;
      msg += "The Diskon Ganjil is required\n";
    }
    if(parseInt(pasaran_minbet_dasar_field) < parseInt(company_dasar_max_minbet_field)){
      flag = true;
      msg += "The Dasar Minbet exceeds Dasar Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_dasar_field) > parseInt(company_dasar_max_maxbet_field)){
      flag = true;
      msg += "The Dasar Maxbet exceeds Dasar Max maxbet\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasarandasar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_dasar: parseInt(pasaran_minbet_dasar_field),
          pasaran_maxbet_dasar: parseInt(pasaran_maxbet_dasar_field),
          pasaran_limittotal_dasar: parseInt(pasaran_limittotal_dasar_field),
          pasaran_limitglobal_dasar: parseInt(pasaran_limitglobal_dasar_field),
          pasaran_keibesar_dasar: parseFloat(
            (pasaran_keibesar_dasar_field / 100).toPrecision(3)
          ),
          pasaran_keikecil_dasar: parseFloat(
            (pasaran_keikecil_dasar_field / 100).toPrecision(3)
          ),
          pasaran_keigenap_dasar: parseFloat(
            (pasaran_keigenap_dasar_field / 100).toPrecision(3)
          ),
          pasaran_keiganjil_dasar: parseFloat(
            (pasaran_keiganjil_dasar_field / 100).toPrecision(3)
          ),
          pasaran_discbesar_dasar: parseFloat(
            (pasaran_discbesar_dasar_field / 100).toPrecision(3)
          ),
          pasaran_disckecil_dasar: parseFloat(
            (pasaran_disckecil_dasar_field / 100).toPrecision(3)
          ),
          pasaran_discgenap_dasar: parseFloat(
            (pasaran_discgenap_dasar_field / 100).toPrecision(3)
          ),
          pasaran_discganjil_dasar: parseFloat(
            (pasaran_discganjil_dasar_field / 100).toPrecision(3)
          ),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function saveupdatepasaranshio() {
    let flag = false;
    let msg = "";
    

    if (pasaran_minbet_shio_field == "") {
      flag = true;
      msg += "The Min Bet is required\n";
    }
    if (pasaran_maxbet_shio_field == "") {
      flag = true;
      msg += "The Max Bet is required\n";
    }
    if (pasaran_limittotal_shio_field == "") {
      flag = true;
      msg += "The Limit Total is required\n";
    }
    if (pasaran_limitglobal_shio_field == "") {
      flag = true;
      msg += "The Limit Global is required\n";
    }
    if (pasaran_win_shio_field == "") {
      flag = true;
      msg += "The Win is required\n";
    }
    if (pasaran_disc_shio_field == "") {
      flag = true;
      msg += "The Diskon is required\n";
    }
    if(parseInt(pasaran_minbet_shio_field) < parseInt(company_shio_max_minbet_field)){
      flag = true;
      msg += "The Shio Minbet exceeds Shio Min minbet\n";
    }
    if(parseInt(pasaran_maxbet_shio_field) > parseInt(company_shio_max_maxbet_field)){
      flag = true;
      msg += "The Shio Maxbet exceeds Shio Max maxbet\n";
    }
    if(parseFloat(pasaran_win_shio_field) > parseFloat(company_shio_max_win_field)){
      flag = true;
      msg += "The Shio exceeds Shio Max Win\n";
    }
    if (flag == false) {
      css_loader = "display: inline-block;";
      msgloader = "Sending...";
      const res = await fetch("/api/updatecompanypasaranshio", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          sdata: sData,
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_id: pasaran_id_field,
          pasaran_minbet_shio: parseInt(pasaran_minbet_shio_field),
          pasaran_maxbet_shio: parseInt(pasaran_maxbet_shio_field),
          pasaran_limittotal_shio: parseInt(pasaran_limittotal_shio_field),
          pasaran_limitglobal_shio: parseInt(pasaran_limitglobal_shio_field),
          pasaran_shioyear_shio: pasaran_shioyear_shio_field,
          pasaran_disc_shio: parseFloat(
            (pasaran_disc_shio_field / 100).toPrecision(3)
          ),
          pasaran_win_shio: parseFloat(pasaran_win_shio_field),
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaran = [];
      call_listpasaran();
    } else {
      alert(msg);
    }
  }
  async function savePasaranOnline() {
    let flag = false;
    let msg = "";
    css_loader = "display: inline-block;";
    if (select_pasaranonline == "" || select_pasaranonline == null) {
      flag = true;
      msg += "The Pasaran Online is required";
    }
    msgloader = "Saving "+select_pasaranonline;
    if (flag == false) {
      const res = await fetch("/api/savecompanypasaranonline", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          master: master,
          company: idcompany,
          companypasaran_id: companypasaran_id_field,
          pasaran_hari: select_pasaranonline,
        }),
      });
      const json = await res.json();
      if (json.status == 200) {
        msgloader = json.message;
      } else {
        msgloader = json.message;
      }
      loaderhari = "done";
      setTimeout(function () {
        css_loader = "display: none;";
      }, 1000);
      listPasaranonline = [];
      call_listpasaranonline();
    } else {
      alert(msg);
    }
  }
  async function removeharionline(e) {
    const res = await fetch("/api/deletecompanypasaranonline", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        master: master,
        company: idcompany,
        companypasaran_id: parseInt(companypasaran_id_field),
        companypasaran_idoffline: parseInt(e),
      }),
    });
    const json = await res.json();
    if (json.status == 200) {
      listPasaranonline = [];
      call_listpasaranonline();
    }
  }
  call_listadmin();
  call_listpasaran();
  call_listpasaranmaster();
  const handleKeyboard_number = (e) => {
    let numbera;
    for (let i = 0; i < company_angka_max_minbet_field.length; i++) {
      numbera = parseInt(company_angka_max_minbet_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_minbet_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_4d_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_4d_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_4d_field = "";
      }
    }

    for (let i = 0; i < company_angka_max_maxbet_4d_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_4d_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_4d_bbdisc_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_3d_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_3d_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_3d_bbdisc_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_3dd_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_3dd_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_3dd_bbdisc_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_2d_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_2d_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_2d_bbdisc_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_2dd_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_2dd_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_2dd_bbdisc_field = "";
      }
    }
    for (let i = 0; i < company_angka_max_maxbet_2dt_bbdisc_field.length; i++) {
      numbera = parseInt(company_angka_max_maxbet_2dt_bbdisc_field[i]);
      if (isNaN(numbera)) {
        company_angka_max_maxbet_2dt_bbdisc_field = "";
      }
    }

    for (let i = 0; i < pasaran_limitline4d_field.length; i++) {
      numbera = parseInt(pasaran_limitline4d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline4d_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitline3d_field.length; i++) {
      numbera = parseInt(pasaran_limitline3d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline3d_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitline3dd_field.length; i++) {
      numbera = parseInt(pasaran_limitline3dd_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline3dd_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitline2d_field.length; i++) {
      numbera = parseInt(pasaran_limitline2d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline2d_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitline2dd_field.length; i++) {
      numbera = parseInt(pasaran_limitline2dd_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline2dd_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitline2dt_field.length; i++) {
      numbera = parseInt(pasaran_limitline2dt_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitline2dt_field = "";
      }
    }
    for (let i = 0; i < pasaran_bbfs_field.length; i++) {
      numbera = parseInt(pasaran_bbfs_field[i]);
      if (isNaN(numbera)) {
        pasaran_bbfs_field = "";
      }
    }
    for (let i = 0; i < pasaran_minbasket_field.length; i++) {
      numbera = parseInt(pasaran_minbasket_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbasket_field = "";
      }
    }
    for (let i = 0; i < pasaran_minbet_432d_field.length; i++) {
      numbera = parseInt(pasaran_minbet_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet4d_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet4d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet4d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet3d_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet3d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet3d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet3dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet3dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet3dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet2d_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet2d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet2d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet2dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet2dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet2dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet2dt_432d_field.length; i++) {
      numbera = parseInt(pasaran_maxbet2dt_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet2dt_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal4d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal4d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal4d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal3d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal3d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal3d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal3dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal3dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal3dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal2d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal2d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal2d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal2dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal2dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal2dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal2dt_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitotal2dt_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal2dt_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal4d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal4d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal4d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal3d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal3d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal3d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal3dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal3dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal3dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal2d_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal2d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal2d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal2dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal2dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal2dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal2dt_432d_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal2dt_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal2dt_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win4d_432d_field.length; i++) {
      numbera = parseInt(pasaran_win4d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win4d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win3d_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win3dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2d_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2d_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2d_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dd_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dd_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2dt_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dt_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dt_432d_field = 0;
      }
    }

    for (let i = 0; i < pasaran_win4d_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win4d_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win4d_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win3d_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3d_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3d_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win3dd_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3dd_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3dd_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2d_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2d_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2d_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2dd_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dd_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dd_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2dt_nodisc_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dt_nodisc_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dt_nodisc_432d_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win4d_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win4d_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win4d_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win3d_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3d_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3d_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win3dd_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3dd_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3dd_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2d_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2d_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2d_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2dd_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dd_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dd_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2dt_bb_kena_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dt_bb_kena_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dt_bb_kena_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win4d_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win4d_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win4d_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win3d_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3d_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3d_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win3dd_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win3dd_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win3dd_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2d_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2d_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2d_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2dd_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dd_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dd_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_win2dt_bb_432d_field.length; i++) {
      numbera = parseInt(pasaran_win2dt_bb_432d_field[i]);
      if (isNaN(numbera)) {
        pasaran_win2dt_bb_432d_field = "";
      }
    }
    for (let i = 0; i < pasaran_disc4d_432d_field.length; i++) {
      numbera = parseInt(pasaran_disc4d_432d_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc4d_432d_field[i] != ".") {
          pasaran_disc4d_432d_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc3d_432d_field.length; i++) {
      numbera = parseInt(pasaran_disc3d_432d_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc3d_432d_field[i] != ".") {
          pasaran_disc3d_432d_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc2d_432d_field.length; i++) {
      numbera = parseInt(pasaran_disc2d_432d_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc2d_432d_field[i] != ".") {
          pasaran_disc2d_432d_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc2dd_432d_field.length; i++) {
      numbera = parseInt(pasaran_disc2dd_432d_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc2dd_432d_field[i] != ".") {
          pasaran_disc2dd_432d_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc2dt_432d_field.length; i++) {
      numbera = parseInt(pasaran_disc2dt_432d_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc2dt_432d_field[i] != ".") {
          pasaran_disc2dt_432d_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_minbet_cbebas_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_cbebas_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_cbebas_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_cbebas_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_limitotal_cbebas_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal_cbebas_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_cbebas_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_cbebas_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_win_cbebas_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win_cbebas_field[i] != ".") {
          pasaran_win_cbebas_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc_cbebas_field.length; i++) {
      numbera = parseInt(pasaran_disc_cbebas_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc_cbebas_field[i] != ".") {
          pasaran_disc_cbebas_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_minbet_cmacau_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_cmacau_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_cmacau_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_cmacau_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitotal_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_limitotal_cmacau_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitotal_cmacau_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_cmacau_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_cmacau_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win2_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_win2_cmacau_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win2_cmacau_field[i] != ".") {
          pasaran_win2_cmacau_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_win3_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_win3_cmacau_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win3_cmacau_field[i] != ".") {
          pasaran_win3_cmacau_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_win4_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_win4_cmacau_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win4_cmacau_field[i] != ".") {
          pasaran_win4_cmacau_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc_cmacau_field.length; i++) {
      numbera = parseInt(pasaran_disc_cmacau_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc_cmacau_field[i] != ".") {
          pasaran_disc_cmacau_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_minbet_cnaga_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_cnaga_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_cnaga_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_cnaga_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_cnaga_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_cnaga_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_cnaga_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_cnaga_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win3_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_win3_cnaga_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win3_cnaga_field[i] != ".") {
          pasaran_win3_cnaga_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_win4_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_win4_cnaga_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win4_cnaga_field[i] != ".") {
          pasaran_win4_cnaga_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc_cnaga_field.length; i++) {
      numbera = parseInt(pasaran_disc_cnaga_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc_cnaga_field[i] != ".") {
          pasaran_disc_cnaga_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_minbet_cjitu_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_cjitu_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_cjitu_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_cjitu_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_cjitu_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_cjitu_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_cjitu_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_cjitu_field = 0;
      }
    }
    for (let i = 0; i < pasaran_winas_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_winas_cjitu_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_winas_cjitu_field[i] != ".") {
          pasaran_winas_cjitu_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_winkop_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_winkop_cjitu_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_winkop_cjitu_field[i] != ".") {
          pasaran_winkop_cjitu_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_winkepala_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_winkepala_cjitu_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_winkepala_cjitu_field[i] != ".") {
          pasaran_winkepala_cjitu_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_winekor_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_winekor_cjitu_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_winekor_cjitu_field[i] != ".") {
          pasaran_winekor_cjitu_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_desc_cjitu_field.length; i++) {
      numbera = parseInt(pasaran_desc_cjitu_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_desc_cjitu_field[i] != ".") {
          pasaran_desc_cjitu_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_minbet_5050umum_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_5050umum_field = "";
      }
    }
    for (let i = 0; i < pasaran_maxbet_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_5050umum_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_5050umum_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitglobal_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_5050umum_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_5050umum_field = "";
      }
    }
    for (let i = 0; i < pasaran_limittotal_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_5050umum_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_5050umum_field = "";
      }
    }
    for (let i = 0; i < pasaran_keibesar_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keibesar_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keibesar_5050umum_field[i] != "." &&
          pasaran_keibesar_5050umum_field[i] != "-"
        ) {
          pasaran_keibesar_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikecil_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keikecil_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikecil_5050umum_field[i] != "." &&
          pasaran_keikecil_5050umum_field[i] != "-"
        ) {
          pasaran_keikecil_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keigenap_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keigenap_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keigenap_5050umum_field[i] != "." &&
          pasaran_keigenap_5050umum_field[i] != "-"
        ) {
          pasaran_keigenap_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiganjil_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keiganjil_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiganjil_5050umum_field[i] != "." &&
          pasaran_keiganjil_5050umum_field[i] != "-"
        ) {
          pasaran_keiganjil_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keitengah_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keitengah_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keitengah_5050umum_field[i] != "." &&
          pasaran_keitengah_5050umum_field[i] != "-"
        ) {
          pasaran_keitengah_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keitepi_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_keitepi_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keitepi_5050umum_field[i] != "." &&
          pasaran_keitepi_5050umum_field[i] != "-"
        ) {
          pasaran_keitepi_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discbesar_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_discbesar_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discbesar_5050umum_field[i] != ".") {
          pasaran_discbesar_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckecil_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_disckecil_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckecil_5050umum_field[i] != ".") {
          pasaran_disckecil_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discgenap_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_discgenap_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discgenap_5050umum_field[i] != ".") {
          pasaran_discgenap_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discganjil_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_discganjil_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discganjil_5050umum_field[i] != ".") {
          pasaran_discganjil_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disctengah_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_disctengah_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disctengah_5050umum_field[i] != ".") {
          pasaran_disctengah_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disctepi_5050umum_field.length; i++) {
      numbera = parseInt(pasaran_disctepi_5050umum_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disctepi_5050umum_field[i] != ".") {
          pasaran_disctepi_5050umum_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_5050special_field.length; i++) {
      numbera = parseInt(pasaran_minbet_5050special_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_5050special_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_5050special_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_5050special_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_5050special_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_5050special_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_5050special_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_5050special_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_5050special_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_5050special_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_5050special_field = 0;
      }
    }
    for (let i = 0; i < pasaran_keiasganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiasganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiasganjil_5050special_field[i] != "." &&
          pasaran_keiasganjil_5050special_field[i] != "-"
        ) {
          pasaran_keiasganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiasgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiasgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiasgenap_5050special_field[i] != "." &&
          pasaran_keiasgenap_5050special_field[i] != "-"
        ) {
          pasaran_keiasgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiasbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiasbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiasbesar_5050special_field[i] != "." &&
          pasaran_keiasbesar_5050special_field[i] != "-"
        ) {
          pasaran_keiasbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiaskecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiaskecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiaskecil_5050special_field[i] != "." &&
          pasaran_keiaskecil_5050special_field[i] != "-"
        ) {
          pasaran_keiaskecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikopganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikopganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikopganjil_5050special_field[i] != "." &&
          pasaran_keikopganjil_5050special_field[i] != "-"
        ) {
          pasaran_keikopganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikopgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikopgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikopgenap_5050special_field[i] != "." &&
          pasaran_keikopgenap_5050special_field[i] != "-"
        ) {
          pasaran_keikopgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikopbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikopbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikopbesar_5050special_field[i] != "." &&
          pasaran_keikopbesar_5050special_field[i] != "-"
        ) {
          pasaran_keikopbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikopkecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikopkecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikopkecil_5050special_field[i] != "." &&
          pasaran_keikopkecil_5050special_field[i] != "-"
        ) {
          pasaran_keikopkecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikepalaganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikepalaganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikepalaganjil_5050special_field[i] != "." &&
          pasaran_keikepalaganjil_5050special_field[i] != "-"
        ) {
          pasaran_keikepalaganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikepalagenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikepalagenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikepalagenap_5050special_field[i] != "." &&
          pasaran_keikepalagenap_5050special_field[i] != "-"
        ) {
          pasaran_keikepalagenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikepalabesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikepalabesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikepalabesar_5050special_field[i] != "." &&
          pasaran_keikepalabesar_5050special_field[i] != "-"
        ) {
          pasaran_keikepalabesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikepalakecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keikepalakecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikepalakecil_5050special_field[i] != "." &&
          pasaran_keikepalakecil_5050special_field[i] != "-"
        ) {
          pasaran_keikepalakecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiekorganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiekorganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiekorganjil_5050special_field[i] != "." &&
          pasaran_keiekorganjil_5050special_field[i] != "-"
        ) {
          pasaran_keiekorganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiekorgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiekorgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiekorgenap_5050special_field[i] != "." &&
          pasaran_keiekorgenap_5050special_field[i] != "-"
        ) {
          pasaran_keiekorgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiekorbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiekorbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiekorbesar_5050special_field[i] != "." &&
          pasaran_keiekorbesar_5050special_field[i] != "-"
        ) {
          pasaran_keiekorbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiekorkecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_keiekorkecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiekorkecil_5050special_field[i] != "." &&
          pasaran_keiekorkecil_5050special_field[i] != "-"
        ) {
          pasaran_keiekorkecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discasganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discasganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discasganjil_5050special_field[i] != ".") {
          pasaran_discasganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discasgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discasgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discasgenap_5050special_field[i] != ".") {
          pasaran_discasgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discasbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discasbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discasbesar_5050special_field[i] != ".") {
          pasaran_discasbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discaskecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discaskecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discaskecil_5050special_field[i] != ".") {
          pasaran_discaskecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckopganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckopganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckopganjil_5050special_field[i] != ".") {
          pasaran_disckopganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckopgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckopgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckopgenap_5050special_field[i] != ".") {
          pasaran_disckopgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckopbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckopbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckopbesar_5050special_field[i] != ".") {
          pasaran_disckopbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckopkecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckopkecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckopkecil_5050special_field[i] != ".") {
          pasaran_disckopkecil_5050special_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_disckepalaganjil_5050special_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_disckepalaganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckepalaganjil_5050special_field[i] != ".") {
          pasaran_disckepalaganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckepalagenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckepalagenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckepalagenap_5050special_field[i] != ".") {
          pasaran_disckepalagenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckepalabesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckepalabesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckepalabesar_5050special_field[i] != ".") {
          pasaran_disckepalabesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckepalakecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_disckepalakecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckepalakecil_5050special_field[i] != ".") {
          pasaran_disckepalakecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discekorganjil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discekorganjil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discekorganjil_5050special_field[i] != ".") {
          pasaran_discekorganjil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discekorgenap_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discekorgenap_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discekorgenap_5050special_field[i] != ".") {
          pasaran_discekorgenap_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discekorbesar_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discekorbesar_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discekorbesar_5050special_field[i] != ".") {
          pasaran_discekorbesar_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discekorkecil_5050special_field.length; i++) {
      numbera = parseInt(pasaran_discekorkecil_5050special_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discekorkecil_5050special_field[i] != ".") {
          pasaran_discekorkecil_5050special_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_minbet_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_5050kombinasi_field = "";
      }
    }
    for (let i = 0; i < pasaran_maxbet_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_5050kombinasi_field = "";
      }
    }
    for (let i = 0; i < pasaran_limitglobal_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_5050kombinasi_field = "";
      }
    }
    for (let i = 0; i < pasaran_limittotal_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_5050kombinasi_field = "";
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangkeimono_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangkeimono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_belakangkeimono_5050kombinasi_field[i] != "." &&
          pasaran_belakangkeimono_5050kombinasi_field[i] != "-"
        ) {
          pasaran_belakangkeimono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangkeistereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangkeistereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_belakangkeistereo_5050kombinasi_field[i] != "." &&
          pasaran_belakangkeistereo_5050kombinasi_field[i] != "-"
        ) {
          pasaran_belakangkeistereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangkeikembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangkeikembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_belakangkeikembang_5050kombinasi_field[i] != "." &&
          pasaran_belakangkeikembang_5050kombinasi_field[i] != "-"
        ) {
          pasaran_belakangkeikembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangkeikempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangkeikempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_belakangkeikempis_5050kombinasi_field[i] != "." &&
          pasaran_belakangkeikempis_5050kombinasi_field[i] != "-"
        ) {
          pasaran_belakangkeikempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangkeikembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangkeikembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_belakangkeikembar_5050kombinasi_field[i] != "." &&
          pasaran_belakangkeikembar_5050kombinasi_field[i] != "-"
        ) {
          pasaran_belakangkeikembar_5050kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_tengahkeimono_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_tengahkeimono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_tengahkeimono_5050kombinasi_field[i] != "." &&
          pasaran_tengahkeimono_5050kombinasi_field[i] != "-"
        ) {
          pasaran_tengahkeimono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahkeistereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahkeistereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_tengahkeistereo_5050kombinasi_field[i] != "." &&
          pasaran_tengahkeistereo_5050kombinasi_field[i] != "-"
        ) {
          pasaran_tengahkeistereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahkeikembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahkeikembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_tengahkeikembang_5050kombinasi_field[i] != "." &&
          pasaran_tengahkeikembang_5050kombinasi_field[i] != "-"
        ) {
          pasaran_tengahkeikembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahkeikempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahkeikempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_tengahkeikempis_5050kombinasi_field[i] != "." &&
          pasaran_tengahkeikempis_5050kombinasi_field[i] != "-"
        ) {
          pasaran_tengahkeikempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahkeikembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahkeikembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_tengahkeikembar_5050kombinasi_field[i] != "." &&
          pasaran_tengahkeikembar_5050kombinasi_field[i] != "-"
        ) {
          pasaran_tengahkeikembar_5050kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_depankeimono_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_depankeimono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_depankeimono_5050kombinasi_field[i] != "." &&
          pasaran_depankeimono_5050kombinasi_field[i] != "-"
        ) {
          pasaran_depankeimono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depankeistereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depankeistereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_depankeistereo_5050kombinasi_field[i] != "." &&
          pasaran_depankeistereo_5050kombinasi_field[i] != "-"
        ) {
          pasaran_depankeistereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depankeikembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depankeikembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_depankeikembang_5050kombinasi_field[i] != "." &&
          pasaran_depankeikembang_5050kombinasi_field[i] != "-"
        ) {
          pasaran_depankeikembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depankeikempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depankeikempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_depankeikempis_5050kombinasi_field[i] != "." &&
          pasaran_depankeikempis_5050kombinasi_field[i] != "-"
        ) {
          pasaran_depankeikempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depankeikembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depankeikembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_depankeikembar_5050kombinasi_field[i] != "." &&
          pasaran_depankeikembar_5050kombinasi_field[i] != "-"
        ) {
          pasaran_depankeikembar_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangdiscmono_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangdiscmono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_belakangdiscmono_5050kombinasi_field[i] != ".") {
          pasaran_belakangdiscmono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangdiscstereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangdiscstereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_belakangdiscstereo_5050kombinasi_field[i] != ".") {
          pasaran_belakangdiscstereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangdisckembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangdisckembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_belakangdisckembang_5050kombinasi_field[i] != ".") {
          pasaran_belakangdisckembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangdisckempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangdisckempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_belakangdisckempis_5050kombinasi_field[i] != ".") {
          pasaran_belakangdisckempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_belakangdisckembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_belakangdisckembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_belakangdisckembar_5050kombinasi_field[i] != ".") {
          pasaran_belakangdisckembar_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahdiscmono_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahdiscmono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_tengahdiscmono_5050kombinasi_field[i] != ".") {
          pasaran_tengahdiscmono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahdiscstereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahdiscstereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_tengahdiscstereo_5050kombinasi_field[i] != ".") {
          pasaran_tengahdiscstereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahdisckembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahdisckembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_tengahdisckembang_5050kombinasi_field[i] != ".") {
          pasaran_tengahdisckembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahdisckempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahdisckempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_tengahdisckempis_5050kombinasi_field[i] != ".") {
          pasaran_tengahdisckempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_tengahdisckembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_tengahdisckembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_tengahdisckembar_5050kombinasi_field[i] != ".") {
          pasaran_tengahdisckembar_5050kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_depandiscmono_5050kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_depandiscmono_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_depandiscmono_5050kombinasi_field[i] != ".") {
          pasaran_depandiscmono_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depandiscstereo_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depandiscstereo_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_depandiscstereo_5050kombinasi_field[i] != ".") {
          pasaran_depandiscstereo_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depandisckembang_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depandisckembang_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_depandisckembang_5050kombinasi_field[i] != ".") {
          pasaran_depandisckembang_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depandisckempis_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depandisckempis_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_depandisckempis_5050kombinasi_field[i] != ".") {
          pasaran_depandisckempis_5050kombinasi_field = 0;
        }
      }
    }
    for (
      let i = 0;
      i < pasaran_depandisckembar_5050kombinasi_field.length;
      i++
    ) {
      numbera = parseInt(pasaran_depandisckembar_5050kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_depandisckembar_5050kombinasi_field[i] != ".") {
          pasaran_depandisckembar_5050kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_minbet_kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_kombinasi_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_kombinasi_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_kombinasi_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_kombinasi_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_kombinasi_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_win_kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win_kombinasi_field[i] != ".") {
          pasaran_win_kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc_kombinasi_field.length; i++) {
      numbera = parseInt(pasaran_disc_kombinasi_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc_kombinasi_field[i] != ".") {
          pasaran_disc_kombinasi_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_dasar_field.length; i++) {
      numbera = parseInt(pasaran_minbet_dasar_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_dasar_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_dasar_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_dasar_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_dasar_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_dasar_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_dasar_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_dasar_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_dasar_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_dasar_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_dasar_field = 0;
      }
    }
    for (let i = 0; i < pasaran_keibesar_dasar_field.length; i++) {
      numbera = parseInt(pasaran_keibesar_dasar_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keibesar_dasar_field[i] != "." &&
          pasaran_keibesar_dasar_field[i] != "-"
        ) {
          pasaran_keibesar_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keikecil_dasar_field.length; i++) {
      numbera = parseInt(pasaran_keikecil_dasar_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keikecil_dasar_field[i] != "." &&
          pasaran_keikecil_dasar_field[i] != "-"
        ) {
          pasaran_keikecil_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keigenap_dasar_field.length; i++) {
      numbera = parseInt(pasaran_keigenap_dasar_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keigenap_dasar_field[i] != "." &&
          pasaran_keigenap_dasar_field[i] != "-"
        ) {
          pasaran_keigenap_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_keiganjil_dasar_field.length; i++) {
      numbera = parseInt(pasaran_keiganjil_dasar_field[i]);
      if (isNaN(numbera)) {
        if (
          pasaran_keiganjil_dasar_field[i] != "." &&
          pasaran_keiganjil_dasar_field[i] != "-"
        ) {
          pasaran_keiganjil_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discbesar_dasar_field.length; i++) {
      numbera = parseInt(pasaran_discbesar_dasar_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discbesar_dasar_field[i] != ".") {
          pasaran_discbesar_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disckecil_dasar_field.length; i++) {
      numbera = parseInt(pasaran_disckecil_dasar_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disckecil_dasar_field[i] != ".") {
          pasaran_disckecil_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discgenap_dasar_field.length; i++) {
      numbera = parseInt(pasaran_discgenap_dasar_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discgenap_dasar_field[i] != ".") {
          pasaran_discgenap_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_discganjil_dasar_field.length; i++) {
      numbera = parseInt(pasaran_discganjil_dasar_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_discganjil_dasar_field[i] != ".") {
          pasaran_discganjil_dasar_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_minbet_shio_field.length; i++) {
      numbera = parseInt(pasaran_minbet_shio_field[i]);
      if (isNaN(numbera)) {
        pasaran_minbet_shio_field = 0;
      }
    }
    for (let i = 0; i < pasaran_maxbet_shio_field.length; i++) {
      numbera = parseInt(pasaran_maxbet_shio_field[i]);
      if (isNaN(numbera)) {
        pasaran_maxbet_shio_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limitglobal_shio_field.length; i++) {
      numbera = parseInt(pasaran_limitglobal_shio_field[i]);
      if (isNaN(numbera)) {
        pasaran_limitglobal_shio_field = 0;
      }
    }
    for (let i = 0; i < pasaran_limittotal_shio_field.length; i++) {
      numbera = parseInt(pasaran_limittotal_shio_field[i]);
      if (isNaN(numbera)) {
        pasaran_limittotal_shio_field = 0;
      }
    }
    for (let i = 0; i < pasaran_win_shio_field.length; i++) {
      numbera = parseInt(pasaran_win_shio_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_win_shio_field[i] != ".") {
          pasaran_win_shio_field = 0;
        }
      }
    }
    for (let i = 0; i < pasaran_disc_shio_field.length; i++) {
      numbera = parseInt(pasaran_disc_shio_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_disc_shio_field[i] != ".") {
          pasaran_disc_shio_field = 0;
        }
      }
    }
  };
  const handleKeyboard_time = (e) => {
    let numbera;
    for (let i = 0; i < pasaran_jamtutup_field.length; i++) {
      numbera = parseInt(pasaran_jamtutup_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_jamtutup_field[i] != ":") {
          pasaran_jamtutup_field = "";
        }
      }
    }
    for (let i = 0; i < pasaran_jamjadwal_field.length; i++) {
      numbera = parseInt(pasaran_jamjadwal_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_jamjadwal_field[i] != ":") {
          pasaran_jamjadwal_field = "";
        }
      }
    }
    for (let i = 0; i < pasaran_jamopen_field.length; i++) {
      numbera = parseInt(pasaran_jamopen_field[i]);
      if (isNaN(numbera)) {
        if (pasaran_jamopen_field[i] != ":") {
          pasaran_jamopen_field = "";
        }
      }
    }
  };
  async function newHariOnline() {
    let myModal = new bootstrap.Modal(document.getElementById("modaNewOnline"));
    myModal.show();
  }
  function clear_field() {
    pasaran_limitline4d_field = 0;
    pasaran_limitline3d_field = 0;
    pasaran_limitline3dd_field = 0;
    pasaran_limitline2d_field = 0;
    pasaran_limitline2dd_field = 0;
    pasaran_limitline2dt_field = 0;
    pasaran_bbfs_field = 0;
    pasaran_minbasket_field = 0;
    pasaran_minbet_432d_field = 0;
    pasaran_maxbet4d_432d_field = 0;
    pasaran_maxbet3d_432d_field = 0;
    pasaran_maxbet3dd_432d_field = 0;
    pasaran_maxbet2d_432d_field = 0;
    pasaran_maxbet2dd_432d_field = 0;
    pasaran_maxbet2dt_432d_field = 0;
    pasaran_maxbet4d_bbdisc_432d_field = 0;
    pasaran_maxbet3d_bbdisc_432d_field = 0;
    pasaran_maxbet3dd_bbdisc_432d_field = 0;
    pasaran_maxbet2d_bbdisc_432d_field = 0;
    pasaran_maxbet2dd_bbdisc_432d_field = 0;
    pasaran_maxbet2dt_bbdisc_432d_field = 0;
    pasaran_limitotal4d_432d_field = 0;
    pasaran_limitotal3d_432d_field = 0;
    pasaran_limitotal3dd_432d_field = 0;
    pasaran_limitotal2d_432d_field = 0;
    pasaran_limitotal2dd_432d_field = 0;
    pasaran_limitotal2dt_432d_field = 0;
    pasaran_limitglobal4d_432d_field = 0;
    pasaran_limitglobal3d_432d_field = 0;
    pasaran_limitglobal3dd_432d_field = 0;
    pasaran_limitglobal2d_432d_field = 0;
    pasaran_limitglobal2dd_432d_field = 0;
    pasaran_limitglobal2dt_432d_field = 0;
    pasaran_disc4d_432d_field = 0;
    pasaran_disc3d_432d_field = 0;
    pasaran_disc3dd_432d_field = 0;
    pasaran_disc2d_432d_field = 0;
    pasaran_disc2dd_432d_field = 0;
    pasaran_disc2dt_432d_field = 0;
    pasaran_win4d_432d_field = 0;
    pasaran_win3d_432d_field = 0;
    pasaran_win3dd_432d_field = 0;
    pasaran_win2d_432d_field = 0;
    pasaran_win2dd_432d_field = 0;
    pasaran_win2dt_432d_field = 0;
    pasaran_win4d_nodisc_432d_field = 0;
    pasaran_win3d_nodisc_432d_field = 0;
    pasaran_win3dd_nodisc_432d_field = 0;
    pasaran_win2d_nodisc_432d_field = 0;
    pasaran_win2dd_nodisc_432d_field = 0;
    pasaran_win2dt_nodisc_432d_field = 0;
    pasaran_win4d_bb_kena_432d_field = 0;
    pasaran_win3d_bb_kena_432d_field = 0;
    pasaran_win3dd_bb_kena_432d_field = 0;
    pasaran_win2d_bb_kena_432d_field = 0;
    pasaran_win2dd_bb_kena_432d_field = 0;
    pasaran_win2dt_bb_kena_432d_field = 0;
    pasaran_win4d_bb_432d_field = 0;
    pasaran_win3d_bb_432d_field = 0;
    pasaran_win3dd_bb_432d_field = 0;
    pasaran_win2d_bb_432d_field = 0;
    pasaran_win2dd_bb_432d_field = 0;
    pasaran_win2dt_bb_432d_field = 0;
    pasaran_minbet_cbebas_field = 0;
    pasaran_maxbet_cbebas_field = 0;
    pasaran_limitotal_cbebas_field = 0;
    pasaran_limitglobal_cbebas_field = 0;
    pasaran_win_cbebas_field = 0;
    pasaran_disc_cbebas_field = 0;
    pasaran_minbet_cmacau_field = 0;
    pasaran_maxbet_cmacau_field = 0;
    pasaran_limitotal_cmacau_field = 0;
    pasaran_limitglobal_cmacau_field = 0;
    pasaran_win2_cmacau_field = 0;
    pasaran_win3_cmacau_field = 0;
    pasaran_win4_cmacau_field = 0;
    pasaran_disc_cmacau_field = 0;
    pasaran_minbet_cnaga_field = 0;
    pasaran_maxbet_cnaga_field = 0;
    pasaran_win3_cnaga_field = 0;
    pasaran_win4_cnaga_field = 0;
    pasaran_disc_cnaga_field = 0;
    pasaran_limitglobal_cnaga_field = 0;
    pasaran_limittotal_cnaga_field = 0;
    pasaran_minbet_cjitu_field = 0;
    pasaran_maxbet_cjitu_field = 0;
    pasaran_winas_cjitu_field = 0;
    pasaran_winkop_cjitu_field = 0;
    pasaran_winkepala_cjitu_field = 0;
    pasaran_winekor_cjitu_field = 0;
    pasaran_desc_cjitu_field = 0;
    pasaran_limitglobal_cjitu_field = 0;
    pasaran_limittotal_cjitu_field = 0;
    pasaran_minbet_5050umum_field = 0;
    pasaran_maxbet_5050umum_field = 0;
    pasaran_keibesar_5050umum_field = 0;
    pasaran_keikecil_5050umum_field = 0;
    pasaran_keigenap_5050umum_field = 0;
    pasaran_keiganjil_5050umum_field = 0;
    pasaran_keitengah_5050umum_field = 0;
    pasaran_keitepi_5050umum_field = 0;
    pasaran_discbesar_5050umum_field = 0;
    pasaran_disckecil_5050umum_field = 0;
    pasaran_discgenap_5050umum_field = 0;
    pasaran_discganjil_5050umum_field = 0;
    pasaran_disctengah_5050umum_field = 0;
    pasaran_disctepi_5050umum_field = 0;
    pasaran_limitglobal_5050umum_field = 0;
    pasaran_limittotal_5050umum_field = 0;
    pasaran_minbet_5050special_field = 0;
    pasaran_maxbet_5050special_field = 0;
    pasaran_keiasganjil_5050special_field = 0;
    pasaran_keiasgenap_5050special_field = 0;
    pasaran_keiasbesar_5050special_field = 0;
    pasaran_keiaskecil_5050special_field = 0;
    pasaran_keikopganjil_5050special_field = 0;
    pasaran_keikopgenap_5050special_field = 0;
    pasaran_keikopbesar_5050special_field = 0;
    pasaran_keikopkecil_5050special_field = 0;
    pasaran_keikepalaganjil_5050special_field = 0;
    pasaran_keikepalagenap_5050special_field = 0;
    pasaran_keikepalabesar_5050special_field = 0;
    pasaran_keikepalakecil_5050special_field = 0;
    pasaran_keiekorganjil_5050special_field = 0;
    pasaran_keiekorgenap_5050special_field = 0;
    pasaran_keiekorbesar_5050special_field = 0;
    pasaran_keiekorkecil_5050special_field = 0;
    pasaran_discasganjil_5050special_field = 0;
    pasaran_discasgenap_5050special_field = 0;
    pasaran_discasbesar_5050special_field = 0;
    pasaran_discaskecil_5050special_field = 0;
    pasaran_disckopganjil_5050special_field = 0;
    pasaran_disckopgenap_5050special_field = 0;
    pasaran_disckopbesar_5050special_field = 0;
    pasaran_disckopkecil_5050special_field = 0;
    pasaran_disckepalaganjil_5050special_field = 0;
    pasaran_disckepalagenap_5050special_field = 0;
    pasaran_disckepalabesar_5050special_field = 0;
    pasaran_disckepalakecil_5050special_field = 0;
    pasaran_discekorganjil_5050special_field = 0;
    pasaran_discekorgenap_5050special_field = 0;
    pasaran_discekorbesar_5050special_field = 0;
    pasaran_discekorkecil_5050special_field = 0;
    pasaran_limitglobal_5050special_field = 0;
    pasaran_limittotal_5050special_field = 0;
    pasaran_minbet_5050kombinasi_field = 0;
    pasaran_maxbet_5050kombinasi_field = 0;
    pasaran_belakangkeimono_5050kombinasi_field = 0;
    pasaran_belakangkeistereo_5050kombinasi_field = 0;
    pasaran_belakangkeikembang_5050kombinasi_field = 0;
    pasaran_belakangkeikempis_5050kombinasi_field = 0;
    pasaran_belakangkeikembar_5050kombinasi_field = 0;
    pasaran_tengahkeimono_5050kombinasi_field = 0;
    pasaran_tengahkeistereo_5050kombinasi_field = 0;
    pasaran_tengahkeikembang_5050kombinasi_field = 0;
    pasaran_tengahkeikempis_5050kombinasi_field = 0;
    pasaran_tengahkeikembar_5050kombinasi_field = 0;
    pasaran_depankeimono_5050kombinasi_field = 0;
    pasaran_depankeistereo_5050kombinasi_field = 0;
    pasaran_depankeikembang_5050kombinasi_field = 0;
    pasaran_depankeikempis_5050kombinasi_field = 0;
    pasaran_depankeikembar_5050kombinasi_field = 0;
    pasaran_belakangdiscmono_5050kombinasi_field = 0;
    pasaran_belakangdiscstereo_5050kombinasi_field = 0;
    pasaran_belakangdisckembang_5050kombinasi_field = 0;
    pasaran_belakangdisckempis_5050kombinasi_field = 0;
    pasaran_belakangdisckembar_5050kombinasi_field = 0;
    pasaran_tengahdiscmono_5050kombinasi_field = 0;
    pasaran_tengahdiscstereo_5050kombinasi_field = 0;
    pasaran_tengahdisckembang_5050kombinasi_field = 0;
    pasaran_tengahdisckempis_5050kombinasi_field = 0;
    pasaran_tengahdisckembar_5050kombinasi_field = 0;
    pasaran_depandiscmono_5050kombinasi_field = 0;
    pasaran_depandiscstereo_5050kombinasi_field = 0;
    pasaran_depandisckembang_5050kombinasi_field = 0;
    pasaran_depandisckempis_5050kombinasi_field = 0;
    pasaran_depandisckembar_5050kombinasi_field = 0;
    pasaran_limitglobal_5050kombinasi_field = 0;
    pasaran_limittotal_5050kombinasi_field = 0;
    pasaran_minbet_kombinasi_field = 0;
    pasaran_maxbet_kombinasi_field = 0;
    pasaran_win_kombinasi_field = 0;
    pasaran_disc_kombinasi_field = 0;
    pasaran_limitglobal_kombinasi_field = 0;
    pasaran_limittotal_kombinasi_field = 0;
    pasaran_minbet_dasar_field = 0;
    pasaran_maxbet_dasar_field = 0;
    pasaran_keibesar_dasar_field = 0;
    pasaran_keikecil_dasar_field = 0;
    pasaran_keigenap_dasar_field = 0;
    pasaran_keiganjil_dasar_field = 0;
    pasaran_discbesar_dasar_field = 0;
    pasaran_disckecil_dasar_field = 0;
    pasaran_discgenap_dasar_field = 0;
    pasaran_discganjil_dasar_field = 0;
    pasaran_limitglobal_dasar_field = 0;
    pasaran_limittotal_dasar_field = 0;
    pasaran_minbet_shio_field = 0;
    pasaran_maxbet_shio_field = 0;
    pasaran_win_shio_field = 0;
    pasaran_disc_shio_field = 0;
    pasaran_shioyear_shio_field = "";
    pasaran_limitglobal_shio_field = 0;
    pasaran_limittotal_shio_field = 0;
  }

  //GENERATE TABLE SHIO
  const masterShio = [
    "tikus", "babi", "anjing", "ayam",
    "monyet", "kambing", "kuda", "ular",
    "naga", "kelinci", "harimau", "kerbau"
  ];
  
  const group_shioangka = [
    ["01","13","25","37","49","61","73","85","97"],
    ["02","14","26","38","50","62","74","86","98"],
    ["03","15","27","39","51","63","75","87","99"],
    ["04","16","28","40","52","64","76","88","00"],
    ["05","17","29","41","53","65","77","89",""],
    ["06","18","30","42","54","66","78","90",""],
    ["07","19","31","43","55","67","79","91",""],
    ["08","20","32","44","56","68","80","92",""],
    ["09","21","33","45","57","69","81","93",""],
    ["10","22","34","46","58","70","82","94",""],
    ["11","23","35","47","59","71","83","95",""],
    ["12","24","36","48","60","72","84","96",""]
  ];
  
  //END GENERATE TABLE SHIO
</script>

<div id="loader" style="margin-left:50%;width:auto;{css_loader}">
  {msgloader}
</div>
<Container fluid style="margin-top: 70px;">
  <Row>
    <Col>
      <button on:click={() => {
          BackHalaman();
        }} class="btn btn-dark btn-sm" style="border-radius: 0px;">
        Back
      </button>
    </Col>
  </Row>
  <div class="clearfix" />
  <Row>
    <Col md="3">
      <div class="card" style="border-radius: 0px;margin-top:10px;">
        <div class="card-header" style="">
          Company / {sData}
          <div class="float-end">
            {#if company_status_field == "ACTIVE"}
              <button on:click={() => {
                  saveEntry();
                }} class="btn btn-warning btn-sm" style="border-radius: 0px;">
                Save
              </button>
            {/if}
          </div>
        </div>
        <div class="card-body" style="height:600px;">
          <Row>
            <div class="mb-3">
              <label for="exampleForm" class="form-label">ID</label>
              <input bind:value={idcompany}
                type="text"
                disabled
                class="form-control"
                placeholder="ID"
                aria-label="ID"/>
            </div>
            <div class="mb-3">
              <label for="exampleForm" class="form-label">Master Company ID</label>
              <input bind:value={master_company_id}
                type="text"
                disabled
                class="form-control required"
                placeholder="Master Company"
                aria-label="Master Company"/>
            </div>
            <div class="mb-3">
              <label for="exampleForm" class="form-label">Company</label>
              <input bind:value={company_name_field}
                type="text"
                class="form-control required"
                placeholder="Company"
                aria-label="Company"/>
            </div>
            <div class="mb-3">
              <label for="exampleForm" class="form-label">URL</label>
              <input bind:value={company_url_field}
                type="text"
                class="form-control required"
                placeholder="URL"
                aria-label="URL"/>
            </div>
            <div class="mb-3">
              <label for="exampleForm" class="form-label">Status</label>
              <select class="form-control required" bind:value={company_status_field}>
                <option value="ACTIVE">ACTIVE</option>
                <option value="DEACTIVE">DEACTIVE</option>
              </select>
            </div>
            
            <div class="mb-3">
              <table>
                <tr>
                  <td style="font-size: 11px;">Create</td>
                  <td style="font-size: 11px;">:</td>
                  <td style="font-size: 11px;">{company_create_field}</td>
                </tr>
                <tr>
                  <td style="font-size: 11px;">Update</td>
                  <td style="font-size: 11px;">:</td>
                  <td style="font-size: 11px;">{company_update_field}</td>
                </tr>
              </table>
            </div>
          </Row>
        </div>
      </div>
    </Col>
    <Col md="9">
      <div class="card" style="border-radius: 0px;margin-top:10px;">
        <div class="card-header" style="">Setting Min Max
          <div class="float-end">
            {#if company_status_field == "ACTIVE"}
              <button on:click={() => {
                  saveminmaxEntry();
                }} class="btn btn-warning btn-sm" style="border-radius: 0px;">
                Save
              </button>
            {/if}
          </div>
        </div>
        <div class="card-body" style="height:600px;overflow-y:scroll;">
          <TabContent pills>
            <TabPane tabId="4-3-2" tab="4D/3D/2D" active>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Min Basket</label>
                    <input bind:value={company_angka_max_minbasket_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Minimal Basket 432D"
                      aria-label="Minimal Basket 432D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_minbasket_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Min Bet</label>
                    <input bind:value={company_angka_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Minimal 432D"
                      aria-label="Minimal 432D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_minbet_field)}</small>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 4D</label>
                    <input bind:value={company_angka_max_maxbet_4d_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 4D"
                      aria-label="Max Bet 4D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 4D BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_4d_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 4D BB/Disc"
                      aria-label="Max Bet 4D BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 3D</label>
                    <input bind:value={company_angka_max_maxbet_3d_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 3D"
                      aria-label="Max Bet 3D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 3D BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_3d_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 3D BB/Disc"
                      aria-label="Max Bet 3D BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 3DD</label>
                    <input bind:value={company_angka_max_maxbet_3dd_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 3DD"
                      aria-label="Max Bet 3DD"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 3DD BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_3dd_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 3DD  BB/Disc"
                      aria-label="Max Bet 3DD  BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2D</label>
                    <input bind:value={company_angka_max_maxbet_2d_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2D"
                      aria-label="Max Bet 2D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2D BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_2d_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2D BB/Disc"
                      aria-label="Max Bet 2D BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2DD</label>
                    <input bind:value={company_angka_max_maxbet_2dd_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2DD"
                      aria-label="Max Bet 2DD"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2DD BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_2dd_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2DD BB/Disc"
                      aria-label="Max Bet 2DD BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2DT</label>
                    <input bind:value={company_angka_max_maxbet_2dt_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2DT"
                      aria-label="Max Bet 2DT"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Max Bet 2DT BB/Disc</label>
                    <input bind:value={company_angka_max_maxbet_2dt_bbdisc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Max Bet 2DT BB/Disc"
                      aria-label="Max Bet 2DT BB/Disc"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win4D FULL</label>
                    <input bind:value={company_angka_max_win4d_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win4D FULL"
                      aria-label="Win4D FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win4d_full_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3D FULL</label>
                    <input bind:value={company_angka_max_win3d_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3D FULL"
                      aria-label="Win3D FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3d_full_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3DD FULL</label>
                    <input bind:value={company_angka_max_win3dd_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3DD FULL"
                      aria-label="Win3DD FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3dd_full_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2D FULL</label>
                    <input bind:value={company_angka_max_win2d_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2D FULL"
                      aria-label="Win2D FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2d_full_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DD FULL</label>
                    <input bind:value={company_angka_max_win2dd_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DD FULL"
                      aria-label="Win2DD FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dd_full_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DT FULL</label>
                    <input bind:value={company_angka_max_win2dt_full_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DT FULL"
                      aria-label="Win2DT FULL"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dt_full_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win4D DISC</label>
                    <input bind:value={company_angka_max_win4d_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win4D DISC"
                      aria-label="Win4D DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win4d_disc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3D DISC</label>
                    <input bind:value={company_angka_max_win3d_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3D DISC"
                      aria-label="Win3D DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3d_disc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3DD DISC</label>
                    <input bind:value={company_angka_max_win3dd_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3DD DISC"
                      aria-label="Win3DD DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3dd_disc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2D DISC</label>
                    <input bind:value={company_angka_max_win2d_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2D DISC"
                      aria-label="Win2D DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2d_disc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DD DISC</label>
                    <input bind:value={company_angka_max_win2dd_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DD DISC"
                      aria-label="Win2DD DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dd_disc_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DT DISC</label>
                    <input bind:value={company_angka_max_win2dt_disc_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DT DISC"
                      aria-label="Win2DT DISC"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dt_disc_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win4D BB Match</label>
                    <input bind:value={company_angka_max_win4d_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win4D BB KENA"
                      aria-label="Win4D BB KENA"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win4d_bbkena_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3D BB Match</label>
                    <input bind:value={company_angka_max_win3d_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3D BB KENA 432D"
                      aria-label="Win3D BB KENA 432D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3d_bbkena_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3DD BB Match</label>
                    <input bind:value={company_angka_max_win3dd_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3DD BB KENA 432D"
                      aria-label="Win3DD BB KENA 432D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3dd_bbkena_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2D BB Match</label>
                    <input bind:value={company_angka_max_win2d_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2D BB Match"
                      aria-label="Win2D BB Match"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2d_bbkena_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DD BB Match</label>
                    <input bind:value={company_angka_max_win2dd_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DD BB Match"
                      aria-label="Win2DD BB Match"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dd_bbkena_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DT BB Match</label>
                    <input bind:value={company_angka_max_win2dt_bbkena_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DT BB Match"
                      aria-label="Win2DT BB Match"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dt_bbkena_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win4D BB</label>
                    <input bind:value={company_angka_max_win4d_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win4D BB"
                      aria-label="Win4D BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win4d_bb_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3D BB</label>
                    <input bind:value={company_angka_max_win3d_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3D BB"
                      aria-label="Win3D BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3d_bb_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win3DD BB</label>
                    <input bind:value={company_angka_max_win3dd_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win3DD BB"
                      aria-label="Win3DD BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win3dd_bb_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2D BB</label>
                    <input bind:value={company_angka_max_win2d_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2D BB"
                      aria-label="Win2D BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2d_bb_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DD BB</label>
                    <input bind:value={company_angka_max_win2dd_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DD BB"
                      aria-label="Win2DD BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dd_bb_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Win2DT BB</label>
                    <input bind:value={company_angka_max_win2dt_bb_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Win2DT BB"
                      aria-label="Win2DT BB"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_angka_max_win2dt_bb_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                          <td style="font-size: 11px;">Wind4D - FULL</td>
                          <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field*company_angka_max_win4d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field*company_angka_max_win4d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field*company_angka_max_win4d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field*company_angka_max_win4d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D BBDISC - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field*company_angka_max_win4d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field*company_angka_max_win4d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field*company_angka_max_win4d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind4D BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field*company_angka_max_win4d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field*company_angka_max_win3d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field*company_angka_max_win3d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field*company_angka_max_win3d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field*company_angka_max_win3d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D BBDISC - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field*company_angka_max_win3d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field*company_angka_max_win3d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field*company_angka_max_win3d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3D BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field*company_angka_max_win3d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field*company_angka_max_win3dd_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field*company_angka_max_win3dd_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field*company_angka_max_win3dd_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field*company_angka_max_win3dd_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD BBDISC - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field*company_angka_max_win3dd_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field*company_angka_max_win3dd_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field*company_angka_max_win3dd_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind3DD BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field*company_angka_max_win3dd_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field*company_angka_max_win2d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field*company_angka_max_win2d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field*company_angka_max_win2d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field*company_angka_max_win2d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D BBDISC- FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field*company_angka_max_win2d_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field*company_angka_max_win2d_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field*company_angka_max_win2d_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2D BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field*company_angka_max_win2d_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field*company_angka_max_win2dd_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field*company_angka_max_win2dd_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field*company_angka_max_win2dd_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field*company_angka_max_win2dd_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD BBDISC - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field*company_angka_max_win2dd_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field*company_angka_max_win2dd_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field*company_angka_max_win2dd_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DD BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field*company_angka_max_win2dd_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field*company_angka_max_win2dt_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field*company_angka_max_win2dt_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field*company_angka_max_win2dt_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field*company_angka_max_win2dt_bb_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT BBDISC - FULL</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field*company_angka_max_win2dt_full_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT BBDISC - DISC</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field*company_angka_max_win2dt_disc_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT BBDISC -  BB Match</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field*company_angka_max_win2dt_bbkena_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Wind2DT BBDISC - BB</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field*company_angka_max_win2dt_bb_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="colok" tab="Colok">
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Bebas - Min Bet</label>
                    <input bind:value={company_cbebas_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Bebas - Min Bet"
                      aria-label="Colok Bebas - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cbebas_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Bebas - Max Bet</label>
                    <input bind:value={company_cbebas_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Bebas - Max Bet"
                      aria-label="Colok Bebas - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cbebas_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Bebas - Win</label>
                    <input bind:value={company_cbebas_max_win_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Minimal 432D"
                      aria-label="Minimal 432D"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cbebas_max_win_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                          <td style="font-size: 11px;">Colok Bebas</td>
                          <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cbebas_max_maxbet_field*company_cbebas_max_win_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Macau - Min Bet</label>
                    <input bind:value={company_cmacau_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Macau - Min Bet"
                      aria-label="Colok Macau - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cmacau_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Macau - Max Bet</label>
                    <input bind:value={company_cmacau_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Macau - Max Bet"
                      aria-label="Colok Macau - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cmacau_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Macau - Win 2 Digit(x)</label>
                    <input bind:value={company_cmacau_max_win2_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Macau - Win 2 Digit(x)"
                      aria-label="Colok Macau - Win 2 Digit(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cmacau_max_win2_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Macau - Win 3 Digit(x)</label>
                    <input bind:value={company_cmacau_max_win3_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Macau - Win 3 Digit(x)"
                      aria-label="Colok Macau - Win 3 Digit(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cmacau_max_win3_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Macau - Win 4 Digit(x)</label>
                    <input bind:value={company_cmacau_max_win4_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Macau - Win 4 Digit(x)"
                      aria-label="Colok Macau - Win 4 Digit(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cmacau_max_win4_field)}</small>
                  </div>
                </Col>
                <Col md="3">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                          <td style="font-size: 11px;">Colok Macau Win 2 Digit</td>
                          <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cmacau_max_maxbet_field*company_cmacau_max_win2_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Colok Macau Win 3 Digit</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cmacau_max_maxbet_field*company_cmacau_max_win3_field)}</td>
                    </tr>
                    <tr>
                      <td style="font-size: 11px;">Colok Macau Win 4 Digit</td>
                      <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cmacau_max_maxbet_field*company_cmacau_max_win4_field)}</td>
                  </tr>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Naga - Min Bet</label>
                    <input bind:value={company_cnaga_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Naga - Min Bet"
                      aria-label="Colok Naga - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cnaga_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Naga - Max Bet</label>
                    <input bind:value={company_cnaga_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Naga - Max Bet"
                      aria-label="Colok Naga - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cnaga_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Naga - Win 3 Digit(x)</label>
                    <input bind:value={company_cnaga_max_win3_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Naga - Win 3 Digit(x)"
                      aria-label="Colok Naga - Win 3 Digit(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cnaga_max_win3_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Naga - Win 4 Digit(x)</label>
                    <input bind:value={company_cnaga_max_win4_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Naga - Win 3 Digit(x)"
                      aria-label="Colok Naga - Win 3 Digit(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cnaga_max_win4_field)}</small>
                  </div>
                </Col>
                <Col md="3">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                        <td style="font-size: 11px;">Colok Naga Win 3 Digit</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cnaga_max_maxbet_field*company_cnaga_max_win3_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Colok Naga Win 4 Digit</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cnaga_max_maxbet_field*company_cnaga_max_win4_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Min Bet</label>
                    <input bind:value={company_cjitu_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Min Bet"
                      aria-label="Colok Jitu - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Max Bet</label>
                    <input bind:value={company_cjitu_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Max Bet"
                      aria-label="Colok Jitu - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Win AS (x)</label>
                    <input bind:value={company_cjitu_max_winas_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Win AS(x)"
                      aria-label="Colok Jitu - Win AS(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_winas_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Win Kop(x)</label>
                    <input bind:value={company_cjitu_max_winkop_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Win Kop(x)"
                      aria-label="Colok Jitu - Win Kop(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_winkop_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Win Kepala(x)</label>
                    <input bind:value={company_cjitu_max_winkepala_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Win Kepala(x)"
                      aria-label="Colok Jitu - Win Kepala(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_winkepala_field)}</small>
                  </div>
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Colok Jitu - Win Ekor(x)</label>
                    <input bind:value={company_cjitu_max_winekor_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Colok Jitu - Win Ekor(x)"
                      aria-label="Colok Jitu - Win Ekor(x)"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_cjitu_max_winekor_field)}</small>
                  </div>
                </Col>
                <Col md="3">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                        <td style="font-size: 11px;">Colok Jitu Win AS</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cjitu_max_maxbet_field*company_cjitu_max_winas_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Colok Jitu Win Kop</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cjitu_max_maxbet_field*company_cjitu_max_winkop_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Colok Jitu Win Kepala</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cjitu_max_maxbet_field*company_cjitu_max_winkepala_field)}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 11px;">Colok Jitu Win Ekor</td>
                        <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_cjitu_max_maxbet_field*company_cjitu_max_winekor_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="5050umumspecialkombinasi" tab="5050">
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Umum - Min Bet</label>
                    <input bind:value={company_umum50_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Umum - Min Bet"
                      aria-label="5050 Umum - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_umum50_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Umum - Max Bet</label>
                    <input bind:value={company_umum50_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Umum - Max Bet"
                      aria-label="5050 Umum - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_umum50_max_maxbet_field)}</small>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Special - Min Bet</label>
                    <input bind:value={company_special50_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Special - Min Bet"
                      aria-label="5050 Special - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_special50_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Special - Max Bet</label>
                    <input bind:value={company_special50_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Special - Max Bet"
                      aria-label="5050 Special - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_special50_max_maxbet_field)}</small>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Kombinasi - Min Bet</label>
                    <input bind:value={company_kombinasi50_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Kombinasi - Min Bet"
                      aria-label="5050 Kombinasi - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_kombinasi50_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">5050 Special - Max Bet</label>
                    <input bind:value={company_kombinasi50_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="5050 Kombinasi - Max Bet"
                      aria-label="5050 Kombinasi - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_kombinasi50_max_maxbet_field)}</small>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="macaudasarshio" tab="Macau / Dasar / Shio">
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Macau - Min Bet</label>
                    <input bind:value={company_macau_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Macau - Min Bet"
                      aria-label="Macau - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_macau_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Macau - Max Bet</label>
                    <input bind:value={company_macau_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Macau - Max Bet"
                      aria-label="Macau - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_macau_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Macau - Win</label>
                    <input bind:value={company_macau_max_win_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Macau Win"
                      aria-label="Macau Win"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_macau_max_win_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                          <td style="font-size: 11px;">Macau</td>
                          <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_macau_max_maxbet_field*company_macau_max_win_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Dasar - Min Bet</label>
                    <input bind:value={company_dasar_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Dasar - Min Bet"
                      aria-label="Dasar - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_dasar_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Dasar - Max Bet</label>
                    <input bind:value={company_dasar_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Dasar - Max Bet"
                      aria-label="Dasar - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_dasar_max_maxbet_field)}</small>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Shio - Min Bet</label>
                    <input bind:value={company_shio_max_minbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Shio - Min Bet"
                      aria-label="Shio - Min Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_shio_max_minbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Shio - Max Bet</label>
                    <input bind:value={company_shio_max_maxbet_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Shio - Max Bet"
                      aria-label="Shio - Max Bet"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_shio_max_maxbet_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Shio - Win</label>
                    <input bind:value={company_shio_max_win_field}
                      on:keyup={handleKeyboard_number}
                      type="text"
                      style="text-align:right;"
                      class="form-control required"
                      placeholder="Shio Win"
                      aria-label="Shio Win"/>
                    <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(company_shio_max_win_field)}</small>
                  </div>
                </Col>
                <Col md="2">
                  <div class="alert alert-info" role="alert" style="padding:0px;margin:0px;">
                    <table>
                      <tr>
                          <td style="font-size: 11px;">Shio</td>
                          <td style="font-size: 11px;text-align: right;">{new Intl.NumberFormat().format(company_shio_max_maxbet_field*company_shio_max_win_field)}</td>
                      </tr>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row><Col md="2">&nbsp;</Col></Row>
              <Row>
                <Col md="2">
                  <div class="mb-3">
                    <label for="exampleForm" class="form-label">Shio - Parent</label>
                    <select bind:value={company_shio_parent_field}
                        name="selectshio"
                        class="form-control required">
                      <option value="0">Tikus</option>
                      <option value="1">Babi</option>
                      <option value="2">Anjing</option>
                      <option value="3">Ayam</option>
                      <option value="4">Monyet</option>
                      <option value="5">Kambing</option>
                      <option value="6">Kuda</option>
                      <option value="7">Ular</option>
                      <option value="8">Naga</option>
                      <option value="9">Kelinci</option>
                      <option value="10">Harimau</option>
                      <option value="11">Kerbau</option>
                    </select>
                  </div>
                </Col>
              </Row>
               <Row><Col md="2">&nbsp;</Col></Row>
               <Row>
                <div class="mb-5">
                  <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th width="1%" style="text-align: center;vertical-align:top;font-size: 14px;">INDEX</th>
                            <th width="5%" style="text-align: left;vertical-align:top;font-size: 14px;">SHIO</th>
                            <th width="*" style="text-align: left;vertical-align:top;font-size: 14px;" >ANGKA</th>
                        </tr>
                    </thead>
                     <tbody>
                       {#each resultShio as rec}
                          <tr>
                              <td NOWRAP style="text-align: center;vertical-align:top;font-size: 13px;">{rec.index}</td>
                              <td NOWRAP style="text-align: left;vertical-align:top;font-size: 13px;">{rec.shio}</td>
                              <td NOWRAP style="text-align: left;vertical-align:top;font-size: 13px;">{rec.angka}</td>
                          </tr>
                      {/each}
                     </tbody>
                  </table>
                  </div>
               </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Col>
  </Row>
  <Row>
    <Col md="6">
      <Panel height_body="365px" css_body="overflow-y:scroll;">
        <slot:template slot="cheader">
          List Admin
          <div class="float-end">
            {#if company_status_field == "ACTIVE"}
              <button on:click={() => {
                  newAdmin();
                }} class="btn btn-primary btn-sm" style="border-radius: 0px;">New</button>
            {/if}
            <button on:click={() => {
              RefreshListAdmin();
            }} class="btn btn-primary btn-sm" style="border-radius: 0px;">Refresh</button>
          </div>
        </slot:template>
        <slot:template slot="csearch">
          <div class="col-lg-12" style="padding: 5px;">
            <input
              bind:value={searchadmin}
              type="text"
              class="form-control"
              placeholder="Search Admin"
              aria-label="Search"/>
          </div>
        </slot:template>
        <slot:template slot="cbody">
          <table class="table table-striped">
            <thead>
              <tr>
                <th width="1%" style="text-align:center;vertical-align:top;font-size: 14px;">&nbsp;</th>
                <th width="1%" style="text-align:center;vertical-align:top;font-size: 14px;">STATUS</th>
                <th width="7%" style="text-align:center;vertical-align:top;font-size: 14px;">TYPE</th>
                <th width="15%" style="text-align:center;vertical-align:top;font-size: 14px;">LASTLOGIN</th>
                <th width="15%" style="text-align:left;vertical-align:top;font-size: 14px;">LASTIPADDRES</th>
                <th width="*" style="text-align:left;vertical-align:top;font-size: 14px;">USERNAME</th>
              </tr>
            </thead>
            <tbody>
              {#each filteradmin as rec}
                <tr>
                  <td on:click={() => {
                      editAdmin(
                        rec.company_admin_username,
                        rec.company_admin_nama,
                        rec.company_admin_status
                      );
                    }} width="1%" NOWRAP style="text-align: center;vertical-align:top;font-size: 13px;cursor:pointer;">
                    <Icon name="pencil" />
                  </td>
                  <td nowrap style="text-align: center;vertical-align:top;font-size:13px;{rec.company_admin_status_css}">{rec.company_admin_status}</td>
                  <td nowrap style="text-align: center;vertical-align:top;font-size:13px;">{rec.company_admin_typeadmin}</td>
                  <td nowrap style="text-align: center;vertical-align:top;font-size:13px;">{rec.company_admin_lastlogin}</td>
                  <td nowrap style="text-align: left;vertical-align:top;font-size:13px;">{rec.company_admin_lastipaddres}</td>
                  <td nowrap style="text-align: left;vertical-align:top;font-size:13px;">{rec.company_admin_username}</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </slot:template>
        <slot:template slot="cfooter">
          Total Record : {totalrecordadmin}
        </slot:template>
      </Panel>
    </Col>
    <Col md="6">
      <Panel height_body="365px" css_body="overflow-y:scroll;">
        <slot:template slot="cheader">
          List Pasaran
          <div class="float-end">
            {#if company_status_field == "ACTIVE"}
              <button on:click={() => {
                  newPasaran();
                }} class="btn btn-primary btn-sm" style="border-radius: 0px;">New</button>
            {/if}
            <button on:click={() => {
              RefreshListPasaran();
            }} class="btn btn-primary btn-sm" style="border-radius: 0px;">Refresh</button>
          </div>
        </slot:template>
        <slot:template slot="csearch">
          <div class="col-lg-12" style="padding: 5px;">
            <input
              bind:value={searchpasaran}
              type="text"
              class="form-control"
              placeholder="Search Pasaran"
              aria-label="Search"/>
          </div>
        </slot:template>
        <slot:template slot="cbody">
          <table class="table table-striped">
            <thead>
              <tr>
                <th width="1%" style="text-align:center;vertical-align:top;font-size: 14px;">&nbsp;</th>
                <th width="1%" style="text-align:center;vertical-align:top;font-size: 14px;">STATUS</th>
                <th width="1%" style="text-align:center;vertical-align:top;font-size: 14px;">&nbsp;</th>
                <th width="*" style="text-align:left;vertical-align:top;font-size: 14px;">PASARAN</th>
                <th width="10%" style="text-align:left;vertical-align:top;font-size: 14px;">ALIAS</th>
                <th width="10%" style="text-align:left;vertical-align:top;font-size: 14px;">PERIODE</th>
                <th width="10%" style="text-align:right;vertical-align:top;font-size: 14px;">WINLOSE</th>
              </tr>
            </thead>
            <tbody>
              {#each filterpasaran as rec}
                <tr>
                  <td on:click={() => {
                      editPasaran(
                        rec.company_pasaran_idcomppasaran,
                        rec.company_pasaran_idpasarantogel,
                        rec.company_pasaran_nmpasarantogel
                      );
                    }} width="1%" NOWRAP style="text-align: center;vertical-align:top;font-size: 13px;cursor:pointer;">
                    <Icon name="pencil" />
                  </td>
                  <td NOWRAP style="text-align: center;vertical-align:top;font-size:13px;{rec.company_pasaran_statuscss}">{rec.company_pasaran_status}</td>
                  <td NOWRAP style="text-align: center;vertical-align:top;font-size:13px;{rec.company_pasaran_statuspasaranactivecss}">{rec.company_pasaran_statuspasaranactive}</td>
                  <td NOWRAP style="text-align: left;vertical-align:top;font-size:13px;">{rec.company_pasaran_nmpasarantogel}</td>
                  <td NOWRAP style="text-align: left;vertical-align:top;font-size:13px;">{rec.company_pasaran_aliasnmpasarantogel}</td>
                  <td NOWRAP style="text-align: left;vertical-align:top;font-size:13px;">{rec.company_pasaran_periode}</td>
                  <td NOWRAP style="text-align: right;vertical-align:top;font-size: 13px;{rec.company_pasaran_csswinlose}">{new Intl.NumberFormat().format(rec.company_pasaran_winlose)}</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </slot:template>
        <slot:template slot="cfooter">
          <div class="float-end" style="font-size:12px;">
            TOTAL WINLOSE : <span style={totalpasaran_css}>{new Intl.NumberFormat().format(totalpasaran)}</span>
          </div>
          Total Record : {totalrecordadmin}
        </slot:template>
      </Panel>
    </Col>
  </Row>
</Container>
<Modal
  modal_id={"modalNewAdmin"}
  modal_size={"modal-dialog-centered"}
  modal_body_height={"height:300px;"}
  modal_footer_flag={true}>
  <slot:template slot="header">
    <h5 class="modal-title" id="exampleModalLabel">Entry/{sData}</h5>
  </slot:template>
  <slot:template slot="body">
    <Container>
      <Row>
        <div class="mb-3">
          <label for="exampleForm" class="form-label">Username</label>
          <input
            bind:value={admin_username_field}
            disabled={admin_username_flag_field}
            type="text"
            maxlength="70"
            class="form-control required"
            placeholder="Username"
            aria-label="Username"/>
        </div>
        <div class="mb-3">
          <label for="exampleForm" class="form-label">Password</label>
          <input
            bind:value={admin_password_field}
            type="password"
            class="form-control"
            placeholder="Password"
            aria-label="Password"/>
        </div>
        <div class="mb-3">
          <label for="exampleForm" class="form-label">Name</label>
          <input
            bind:value={admin_name_field}
            type="text"
            maxlength="70"
            class="form-control required"
            placeholder="Name"
            aria-label="Name"/>
        </div>
        <div class="mb-3">
          <label for="exampleForm" class="form-label">Status</label>
          <select bind:value={admin_status_field} class="form-control required">
            <option value="ACTIVE">ACTIVE</option>
            <option value="DEACTIVE">DEACTIVE</option>
          </select>
        </div>
      </Row>
    </Container>
  </slot:template>
  <slot:template slot="footer">
    <div class="float-end">
      <button
        on:click={() => {
          SaveNewAdmin();
        }}
        class="btn btn-warning"
        style="border-radius: 0px;"
      >
        Save
      </button>
    </div>
  </slot:template>
</Modal>
<Modal
  modal_id={"modalNewPasaran"}
  modal_size={"modal-dialog-centered"}
  modal_body_height={"height:200px;"}
  modal_footer_flag={true}>
  <slot:template slot="header">
    <h5 class="modal-title" id="exampleModalLabel">Entry/{sData}</h5>
  </slot:template>
  <slot:template slot="body">
    <Container>
      <Row>
        <div class="mb-3">
          <label for="exampleForm" class="form-label">Pasaran</label>
          <select bind:value={pasaran_id_field} class="form-select" required>
            <option selected value="" disabled>Pilih Pasaran</option>
            {#each listPasaranMaster as rec}
              <option value={rec.pasaran_idpasarantogel}
                >{rec.pasaran_nmpasarantogel}</option
              >
            {/each}
          </select>
        </div>
        {#if pasaran_id_field}
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label">Nama Alias Pasaran (opsional)</label>
            <input
              bind:value={pasaran_alias_field}
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="contoh: ASIA EXPRESS"/>
          </div>
        {/if}
      </Row>
    </Container>
  </slot:template>
  <slot:template slot="footer">
    <div class="float-end">
      <button on:click={() => {
          saveNewPasaran();
        }} class="btn btn-warning btn-sm" style="border-radius: 0px;">
        Save
      </button>
    </div>
  </slot:template>
</Modal>
<Modal
  modal_id={"modalEditPasaran"}
  modal_size={"modal-fullscreen"}
  modal_body_height={"700px;overflow:scroll;"}
  modal_footer_flag={false}>
  <slot:template slot="header">
    <h5 class="modal-title" id="exampleModalLabel">Pasaran : {pasaran_nmpasarantogel_field}</h5>
  </slot:template>
  <slot:template slot="body">
    <TabContent pills>
      <TabPane tabId="basic" tab="BASIC" active>
        <div class="card" style="border-radius: 0px;margin-top:10px;">
          <div class="card-header" style="">
            Pasaran / {sData}
            <div class="float-end">
              {#if sData == "Edit"}
                <button
                  on:click={() => {
                    autofetchAll();
                  }} class="btn btn-warning" style="border-radius: 0px;">Fetch</button>
              {/if}
              <button
                on:click={() => {
                  saveupdatepasaran();
                }} class="btn btn-warning"style="border-radius: 0px;">Save</button>
            </div>
          </div>
          <div class="card-body" style="height:450px;">
            <Row>
              <Col md="6">
                <div class="mb-3">
                  <label for="exampleform" class="form-label">Alias</label>
                  <input
                    bind:value={pasaran_pasaranalias_field}
                    type="text"
                    class="form-control"
                    placeholder="Alias Pasaran Togel"
                    aria-label="Alias Pasaran Togel"/>
                </div>
                <div class="mb-3">
                  <label for="exampleform" class="form-label">Situs</label>
                  <input
                    bind:value={pasaran_urlpasaran_field}
                    type="text"
                    class="form-control required"
                    placeholder="Pasaran Togel"
                    aria-label="Pasaran Togel"/>
                </div>
                <div class="mb-3">
                  <label for="exampleform" class="form-label">Hari diundi</label>
                  <input
                    bind:value={pasaran_pasarandiundi_field}
                    type="text"
                    class="form-control required"
                    placeholder="Pasaran Togel"
                    aria-label="Pasaran Togel"/>
                </div>
              </Col>
              <Col md="6">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Tutup</label>
                  <input
                    bind:value={pasaran_jamtutup_field}
                    on:keyup={handleKeyboard_time}
                    minlength="0"
                    maxlength="8"
                    type="text"
                    style="text-align:center;"
                    class="form-control required"
                    placeholder="Pasaran Togel"
                    aria-label="Pasaran Togel"/>
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Jadwal</label>
                  <input
                    bind:value={pasaran_jamjadwal_field}
                    on:keyup={handleKeyboard_time}
                    minlength="0"
                    maxlength="8"
                    type="text"
                    style="text-align:center;"
                    class="form-control required"
                    placeholder="Pasaran Togel"
                    aria-label="Pasaran Togel"/>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Buka</label>
                  <input
                    bind:value={pasaran_jamopen_field}
                    on:keyup={handleKeyboard_time}
                    minlength="0"
                    maxlength="8"
                    type="text"
                    style="text-align:center;"
                    class="form-control required"
                    placeholder="Pasaran Togel"
                    aria-label="Pasaran Togel"/>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Status</label>
                  <select bind:value={pasaran_status_field} class="form-control required">
                    <option value="Y">ACTIVE</option>
                    <option value="N">DEACTIVE</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </TabPane>
      <TabPane tabId="limitline" tab="LIMIT LINE">
        <Panel height_body="450px" card_footer="false" css_body="">
          <slot:template slot="cheader">
            Setting Limit Line + BBFS
            <div class="float-end">
              <button
                on:click={() => {
                  fetchlimitline();
                }} class="btn btn-warning" style="border-radius: 0px;">Fetch</button>
              <button
                on:click={() => {
                  saveupdatepasaranline();
                }} class="btn btn-warning" style="border-radius: 0px;">Save</button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="4">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">BBFS</label>
                  <input
                    bind:value={pasaran_bbfs_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="BBFS"
                    aria-label="BBFS"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_bbfs_field)}</small>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Min Total Keranjang</label>
                  <input
                    bind:value={pasaran_minbasket_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Total Keranjang"
                    aria-label="Min Total Keranjang"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_minbasket_field)}</small>
                </div>
              </Col>
              <Col md="4">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label" >LimitLine 4D</label>
                  <input
                    bind:value={pasaran_limitline4d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 4D"
                    aria-label="Limitline 4D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_limitline4d_field)}</small>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">LimitLine 3D</label>
                  <input
                    bind:value={pasaran_limitline3d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 3D"
                    aria-label="Limitline 3D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_limitline3d_field)}</small>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">LimitLine 3DD</label>
                  <input
                    bind:value={pasaran_limitline3dd_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 3DD"
                    aria-label="Limitline 3DD"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_limitline3dd_field)}</small>
                </div>
              </Col>
              <Col md="4">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">LimitLine 2D</label>
                  <input
                    bind:value={pasaran_limitline2d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 2D"
                    aria-label="Limitline 2D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_limitline2d_field)}</small>
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label" >LimitLine 2DD</label>
                  <input
                    bind:value={pasaran_limitline2dd_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 2DD"
                    aria-label="Limitline 2DD"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_limitline2dd_field)}</small>
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">LimitLine 2DT</label>
                  <input
                    bind:value={pasaran_limitline2dt_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limitline 2DT"
                    aria-label="Limitline 2DT"/>
                  <small style="float:right;font-size:11px;" >{new Intl.NumberFormat().format(pasaran_limitline2dt_field)}</small>
                </div>
              </Col>
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="pasaranonline" tab="ONLINE">
        <Panel height_body="365px" css_body="" card_footer="false">
          <slot:template slot="cheader">
            Hari Online
            <div class="float-end">
              <button
                on:click={() => {
                  newHariOnline();
                }}
                class="btn btn-primary"
                style="border-radius: 0px;"
              >
                New
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th
                    width="1%"
                    style="text-align:center;vertical-align:top;font-size: 14px;"
                    >&nbsp;</th
                  >

                  <th
                    style="text-align:left;vertical-align:top;font-size: 14px;"
                    >HARI</th
                  >
                </tr>
              </thead>
              <tbody>
                {#each listPasaranonline as rec}
                  <tr>
                    <td
                      on:click={() => {
                        removeharionline(rec.company_pasaranonline_id);
                      }}
                      width="1%"
                      NOWRAP
                      style="text-align: center;vertical-align:top;font-size: 13px;cursor:pointer;"
                    >
                      <Icon name="trash" />
                    </td>

                    <td
                      style="text-align: left;vertical-align:top;font-size:13px;"
                      >{rec.company_pasaranonline_hari}</td
                    >
                  </tr>
                {/each}
              </tbody>
            </table>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="4-3-2" tab="4D/3D/2D">
        <Panel height_body="1100px" card_footer="false" css_body="">
          <slot:template slot="cheader">
            <div class="float-end">
              <button on:click={() => {
                  fetch432d();
                }} class="btn btn-warning" style="border-radius: 0px;">Fetch</button>
              <button on:click={() => {
                  saveupdatepasaran432();
                }} class="btn btn-warning" style="border-radius: 0px;">Save</button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Min Bet : {new Intl.NumberFormat().format(company_angka_max_minbet_field)}</small>
                  <input bind:value={pasaran_minbet_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_minbet_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 4D</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 4D: {new Intl.NumberFormat().format(company_angka_max_maxbet_4d_field)}</small>
                  <input bind:value={pasaran_maxbet4d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 4D"
                    aria-label="Max Bet 4D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet4d_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 4D BB/Disc</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 4D BB/Disc: {new Intl.NumberFormat().format(company_angka_max_maxbet_4d_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet4d_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 4D  BB/Disc"
                    aria-label="Max Bet 4D  BB/Disc"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet4d_bbdisc_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 3D</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 3D : {new Intl.NumberFormat().format(company_angka_max_maxbet_3d_field)}</small>
                  <input bind:value={pasaran_maxbet3d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 3D"
                    aria-label="Max Bet 3D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet3d_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 3D BB/Disc</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 3D BB/Disc : {new Intl.NumberFormat().format(company_angka_max_maxbet_3d_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet3d_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 3D BB/Disc"
                    aria-label="Max Bet 3D BB/Disc"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet3d_bbdisc_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 3DD</label >
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 3DD : {new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_field)}</small>
                  <input bind:value={pasaran_maxbet3dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 3DD"
                    aria-label="Max Bet 3DD"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet3dd_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 3DD BB/Disc</label >
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 3DD BB/Disc : {new Intl.NumberFormat().format(company_angka_max_maxbet_3dd_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet3dd_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 3DD"
                    aria-label="Max Bet 3DD"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet3dd_bbdisc_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2D</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2D : {new Intl.NumberFormat().format(company_angka_max_maxbet_2d_field)}</small>
                  <input bind:value={pasaran_maxbet2d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2D"
                    aria-label="Max Bet 2D"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2d_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2D BB/Disc</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2D BB/Disc : {new Intl.NumberFormat().format(company_angka_max_maxbet_2d_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet2d_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2D BB/Disc"
                    aria-label="Max Bet 2D BB/Disc"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2d_bbdisc_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2DD</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2DD : {new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_field)}</small>
                  <input bind:value={pasaran_maxbet2dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2DD"
                    aria-label="Max Bet 2DD"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2dd_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2DD 2D BB/Disc</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2DD 2D BB/Disc : {new Intl.NumberFormat().format(company_angka_max_maxbet_2dd_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet2dd_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2DD 2D BB/Disc"
                    aria-label="Max Bet 2DD 2D BB/Disc"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2dd_bbdisc_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2DT</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2DT : {new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_field)}</small>
                  <input bind:value={pasaran_maxbet2dt_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2DT"
                    aria-label="Max Bet 2DT"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2dt_432d_field)}</small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet 2DT BB/Disc</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet 2DT BB/Disc : {new Intl.NumberFormat().format(company_angka_max_maxbet_2dt_bbdisc_field)}</small>
                  <input bind:value={pasaran_maxbet2dt_bbdisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet 2DT BB/Disc"
                    aria-label="Max Bet 2DT BB/Disc"/>
                  <small style="float:right;font-size:11px;">{new Intl.NumberFormat().format(pasaran_maxbet2dt_bbdisc_432d_field)}</small>
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 4D</label
                  >
                  <input
                    bind:value={pasaran_limitotal4d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 4D"
                    aria-label="Limit Total 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal4d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 3D</label
                  >
                  <input
                    bind:value={pasaran_limitotal3d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal3d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 3DD</label
                  >
                  <input
                    bind:value={pasaran_limitotal3dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3DD"
                    aria-label="Limit Total 3DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal3dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 2D</label
                  >
                  <input
                    bind:value={pasaran_limitotal2d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 2D"
                    aria-label="Limit Total 2D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal2d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 2DD</label
                  >
                  <input
                    bind:value={pasaran_limitotal2dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 2DD"
                    aria-label="Limit Total 2DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal2dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Total 2DT</label
                  >
                  <input
                    bind:value={pasaran_limitotal2dt_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 2DT"
                    aria-label="Limit Total 2DT"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal2dt_432d_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 4D</label
                  >
                  <input
                    bind:value={pasaran_limitglobal4d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal4d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 3D</label
                  >
                  <input
                    bind:value={pasaran_limitglobal3d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 3D"
                    aria-label="Limit Global 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal3d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 3DD</label
                  >
                  <input
                    bind:value={pasaran_limitglobal3dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 3DD"
                    aria-label="Limit Global 3DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal3dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 2D</label
                  >
                  <input
                    bind:value={pasaran_limitglobal2d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 2D"
                    aria-label="Limit Global 2D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal2d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 2DD</label
                  >
                  <input
                    bind:value={pasaran_limitglobal2dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 2DD"
                    aria-label="Limit Global 2DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal2dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Limit Global 2DT</label
                  >
                  <input
                    bind:value={pasaran_limitglobal2dt_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 2DT"
                    aria-label="Limit Global 2DT"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal2dt_432d_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 4D Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4D Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win4d_disc_field)}</small>
                  <input
                    bind:value={pasaran_win4d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D"
                    aria-label="Win 4D"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win4d_432d_field)}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3D Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3D Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win3d_disc_field)}</small>
                  <input
                    bind:value={pasaran_win3d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3D"
                    aria-label="Win 3D"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win3d_432d_field)}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3DD Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3DD Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win3dd_disc_field)}</small>
                  <input
                    bind:value={pasaran_win3dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3DD"
                    aria-label="Win 3DD"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win3dd_432d_field)}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2D Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2D Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win2d_disc_field)}</small>
                  <input
                    bind:value={pasaran_win2d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2D"
                    aria-label="Win 2D"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win2d_432d_field)}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DD Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DD Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win2dd_disc_field)}</small>
                  <input
                    bind:value={pasaran_win2dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DD"
                    aria-label="Win 2DD"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win2dd_432d_field)}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DT Disc(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DT Disc(x) : {new Intl.NumberFormat().format(company_angka_max_win2dt_disc_field)}</small>
                  <input
                    bind:value={pasaran_win2dt_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DT"
                    aria-label="Win 2DT"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(pasaran_win2dt_432d_field)}
                  </small>
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 4D Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4D Full(x) : {new Intl.NumberFormat().format(company_angka_max_win4d_full_field)}</small>
                  <input
                    bind:value={pasaran_win4d_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D NO DISKON"
                    aria-label="Win 4D NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win4d_nodisc_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3D Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3D Full(x) : {new Intl.NumberFormat().format(company_angka_max_win3d_full_field)}</small>
                  <input
                    bind:value={pasaran_win3d_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3D NO DISKON"
                    aria-label="Win 3D NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3d_nodisc_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3DD Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3DD Full(x) : {new Intl.NumberFormat().format(company_angka_max_win3dd_full_field)}</small>
                  <input
                    bind:value={pasaran_win3dd_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3DD NO DISKON"
                    aria-label="Win 3DD NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3dd_nodisc_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2D Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2D Full(x) : {new Intl.NumberFormat().format(company_angka_max_win2d_full_field)}</small>
                  <input
                    bind:value={pasaran_win2d_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2D NO DISKON"
                    aria-label="Win 2D NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2d_nodisc_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DD Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DD Full(x) : {new Intl.NumberFormat().format(company_angka_max_win2dd_full_field)}</small>
                  <input
                    bind:value={pasaran_win2dd_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DD NO DISKON"
                    aria-label="Win 2DD NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dd_nodisc_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DT Full(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DT Full(x) : {new Intl.NumberFormat().format(company_angka_max_win2dt_full_field)}</small>
                  <input
                    bind:value={pasaran_win2dt_nodisc_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DT NO DISKON"
                    aria-label="Win 2DT NO DISKON"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dt_nodisc_432d_field
                    )}
                  </small>
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 4D(%)</label
                  >
                  <input
                    bind:value={pasaran_disc4d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 4D"
                    aria-label="Disc 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc4d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 3D(%)</label
                  >
                  <input
                    bind:value={pasaran_disc3d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 3D"
                    aria-label="Disc 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc3d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 3D(%)</label
                  >
                  <input
                    bind:value={pasaran_disc3dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 3DD"
                    aria-label="Disc 3DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc3dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 2D(%)</label
                  >
                  <input
                    bind:value={pasaran_disc2d_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 2D"
                    aria-label="Disc 2D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc2d_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 2DD(%)</label
                  >
                  <input
                    bind:value={pasaran_disc2dd_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 2DD"
                    aria-label="Disc 2DD"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc2dd_432d_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label"
                    >Disc 2DT(%)</label
                  >
                  <input
                    bind:value={pasaran_disc2dt_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc 2DT"
                    aria-label="Disc 2DT"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc2dt_432d_field
                    )}</small
                  >
                </div>
              </Col>
              <div class="clearfix" />
              <Col md="2">&nbsp;</Col>
              <Col md="2">&nbsp;</Col>
              <Col md="2">&nbsp;</Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 4D BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4D BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win4d_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win4d_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D BB KENA"
                    aria-label="Win 4D BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win4d_bb_kena_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3D BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3D BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win3d_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win3d_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3D BB KENA"
                    aria-label="Win 3D BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3d_bb_kena_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3DD BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3DD BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win3dd_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win3dd_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3DD BB KENA"
                    aria-label="Win 3DD BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3dd_bb_kena_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2D BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2D BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win2d_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win2d_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2D BB KENA"
                    aria-label="Win 2D BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2d_bb_kena_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DD BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DD BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win2dd_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win2dd_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DD BB KENA"
                    aria-label="Win 2DD BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dd_bb_kena_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DT BB Kena(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DT BB Kena(x) : {new Intl.NumberFormat().format(company_angka_max_win2dt_bbkena_field)}</small>
                  <input
                    bind:value={pasaran_win2dt_bb_kena_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DT BB KENA"
                    aria-label="Win 2DT BB KENA"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dt_bb_kena_432d_field
                    )}
                  </small>
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 4D BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4D BB (x) : {new Intl.NumberFormat().format(company_angka_max_win4d_bb_field)}</small>
                  <input
                    bind:value={pasaran_win4d_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D BB"
                    aria-label="Win 4D BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win4d_bb_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3D BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3D BB (x) : {new Intl.NumberFormat().format(company_angka_max_win3d_bb_field)}</small>
                  <input
                    bind:value={pasaran_win3d_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3D BB"
                    aria-label="Win 3D BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3d_bb_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 3DD BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3DD BB (x) : {new Intl.NumberFormat().format(company_angka_max_win3dd_bb_field)}</small>
                  <input
                    bind:value={pasaran_win3dd_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 3DD BB"
                    aria-label="Win 3DD BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win3dd_bb_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2D BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2D BB (x) : {new Intl.NumberFormat().format(company_angka_max_win2d_bb_field)}</small>
                  <input
                    bind:value={pasaran_win2d_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2D BB"
                    aria-label="Win 2D BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2d_bb_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DD BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DD BB (x) : {new Intl.NumberFormat().format(company_angka_max_win2dd_bb_field)}</small>
                  <input
                    bind:value={pasaran_win2dd_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DD BB"
                    aria-label="Win 2DD BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dd_bb_432d_field
                    )}
                  </small>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Win 2DT BB (x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2DT BB (x) : {new Intl.NumberFormat().format(company_angka_max_win2dt_bb_field)}</small>
                  <input
                    bind:value={pasaran_win2dt_bb_432d_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 2DT BB"
                    aria-label="Win 2DT BB"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_win2dt_bb_432d_field
                    )}
                  </small>
                </div>
              </Col>
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="cbebas" tab="Colok Bebas">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchcolokbebas();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarancolokbebas();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;"> Max MinBet : {new Intl.NumberFormat().format(company_cbebas_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_cbebas_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;"> Max MaxBet : {new Intl.NumberFormat().format(company_cbebas_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_cbebas_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limitotal_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal_cbebas_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_cbebas_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Max Win(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win(x) : {new Intl.NumberFormat().format(company_cbebas_max_win_field)}</small>
                  <input
                    bind:value={pasaran_win_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win_cbebas_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Disc(%)</label>
                  <input
                    bind:value={pasaran_disc_cbebas_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D"
                    aria-label="Win 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc_cbebas_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="cmacau" tab="Colok Macau">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchcolokmacau();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarancolokmacau();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;"> Max MinBet : {new Intl.NumberFormat().format(company_cmacau_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_cmacau_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;"> Max MaxBet : {new Intl.NumberFormat().format(company_cmacau_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_cmacau_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limitotal_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitotal_cmacau_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_cmacau_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Win2Digit(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win2Digit(x) : {new Intl.NumberFormat().format(company_cmacau_max_win2_field)}</small>
                  <input
                    bind:value={pasaran_win2_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win2_cmacau_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Win3Digit(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3Digit(x) : {new Intl.NumberFormat().format(company_cmacau_max_win3_field)}</small>
                  <input
                    bind:value={pasaran_win3_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win3_cmacau_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Win4Digit(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4Digit(x) : {new Intl.NumberFormat().format(company_cmacau_max_win4_field)}</small>
                  <input
                    bind:value={pasaran_win4_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win4_cmacau_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Disc(%)</label>
                  <input
                    bind:value={pasaran_disc_cmacau_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D"
                    aria-label="Win 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc_cmacau_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="cnaga" tab="Colok Naga">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchcoloknaga();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarancoloknaga();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_cnaga_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_cnaga_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_cnaga_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_cnaga_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_cnaga_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_cnaga_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Win3Digit(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win3Digit : {new Intl.NumberFormat().format(company_cnaga_max_win3_field)}</small>
                  <input
                    bind:value={pasaran_win3_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win3_cnaga_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Win4Digit(x)</label>
                  <small style="float:right;font-size:11px;color:red;"> Max Win4Digit : {new Intl.NumberFormat().format(company_cnaga_max_win4_field)}</small>
                  <input
                    bind:value={pasaran_win4_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win4_cnaga_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Disc(%)</label>
                  <input
                    bind:value={pasaran_disc_cnaga_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D"
                    aria-label="Win 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc_cnaga_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="cjitu" tab="Colok Jitu">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchcolokjitu();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarancolokjitu();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_cjitu_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_cjitu_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_cjitu_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_cjitu_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_cjitu_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_cjitu_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max WinAS(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max WinAS(x) : {new Intl.NumberFormat().format(company_cjitu_max_winas_field)}</small>
                  <input
                    bind:value={pasaran_winas_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_winas_cjitu_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max WinKop(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max WinKop(x) : {new Intl.NumberFormat().format(company_cjitu_max_winkop_field)}</small>
                  <input
                    bind:value={pasaran_winkop_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_winkop_cjitu_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max WinKepala(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max WinKepala(x) : {new Intl.NumberFormat().format(company_cjitu_max_winkepala_field)}</small>
                  <input
                    bind:value={pasaran_winkepala_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_winkepala_cjitu_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max WinEkor(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max WinEkor(x) : {new Intl.NumberFormat().format(company_cjitu_max_winkepala_field)}</small>
                  <input
                    bind:value={pasaran_winekor_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Global 4D"
                    aria-label="Limit Global 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_winekor_cjitu_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Disc(%)</label>
                  <input
                    bind:value={pasaran_desc_cjitu_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win 4D"
                    aria-label="Win 4D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_desc_cjitu_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="5050umum" tab="5050 Umum">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetch5050umum();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasaran5050umum();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_umum50_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_umum50_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_5050umum_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_5050umum_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keibesar_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keibesar_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikecil_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikecil_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keigenap_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keigenap_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiganjil_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiganjil_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Tengah(%)</label
                  >
                  <input
                    bind:value={pasaran_keitengah_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keitengah_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Kei Tepi(%)</label
                  >
                  <input
                    bind:value={pasaran_keitepi_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keitepi_5050umum_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_discbesar_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discbesar_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckecil_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckecil_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_discgenap_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discgenap_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_discganjil_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discganjil_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Tengah(%)</label
                  >
                  <input
                    bind:value={pasaran_disctengah_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disctengah_5050umum_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Tepi(%)</label
                  >
                  <input
                    bind:value={pasaran_disctepi_5050umum_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disctepi_5050umum_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="5050special" tab="5050 Special">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetch5050special();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasaran5050special();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_special50_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_special50_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_5050special_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_5050special_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei As Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiasganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei As Ganjil"
                    aria-label="Kei As Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiasganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei As Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keiasgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei As Genap"
                    aria-label="Kei As Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiasgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei As Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keiasbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei As Besar"
                    aria-label="Kei As Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiasbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei As Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiaskecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei As Kecil"
                    aria-label="Kei As Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiaskecil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kop Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikopganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kop Ganjil"
                    aria-label="Kei Kop Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikopganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kop Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keikopgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kop Genap"
                    aria-label="Kei Kop Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikopgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kop Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keikopbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kop Besar"
                    aria-label="Kei Kop Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikopbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kop Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikopkecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kop Kecil"
                    aria-label="Kei Kop Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikopkecil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kepala Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikepalaganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kepala Ganjil"
                    aria-label="Kei Kepala Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikepalaganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kepala Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keikepalagenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kepala Genap"
                    aria-label="Kei Kepala Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikepalagenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kepala Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keikepalabesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kepala Besar"
                    aria-label="Kei Kepala Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikepalabesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kepala Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikepalakecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kepala Kecil"
                    aria-label="Kei Kepala Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikepalakecil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ekor Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiekorganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Ekor Ganjil"
                    aria-label="Kei Ekor Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiekorganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ekor Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keiekorgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Ekor Genap"
                    aria-label="Kei Ekor Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiekorgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ekor Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keiekorbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Ekor Besar"
                    aria-label="Kei Ekor Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiekorbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ekor Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiekorkecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Ekor Kecil"
                    aria-label="Kei Ekor Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiekorkecil_5050special_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc AS Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_discasganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc AS Ganjil"
                    aria-label="Disc AS Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discasganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc AS Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_discasgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc AS Genap"
                    aria-label="Disc AS Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discasgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc AS Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_discasbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc AS Besar"
                    aria-label="Disc AS Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discasbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc AS Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_discaskecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discaskecil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kop Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckopganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kop Ganjil"
                    aria-label="Disc Kop Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckopganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kop Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_disckopgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kop Genap"
                    aria-label="Disc Kop Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckopgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kop Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_disckopbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kop Besar"
                    aria-label="Disc Kop Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckopbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kop Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckopkecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kop Kecil"
                    aria-label="Kei Kop Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckopkecil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kepala Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckepalaganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kepala Ganjil"
                    aria-label="Disc Kepala Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckepalaganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kepala Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_disckepalagenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kepala Genap"
                    aria-label="Disc Kepala Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckepalagenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kepala Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_disckepalabesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kepala Besar"
                    aria-label="Disc Kepala Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckepalabesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kepala Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckepalakecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kepala Kecil"
                    aria-label="Disc Kepala Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckepalakecil_5050special_field
                    )}</small
                  >
                </div>

                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ekor Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_discekorganjil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Ekor Ganjil"
                    aria-label="Disc Ekor Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discekorganjil_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ekor Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_discekorgenap_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Ekor Genap"
                    aria-label="Disc Ekor Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discekorgenap_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ekor Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_discekorbesar_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Ekor Besar"
                    aria-label="Disc Ekor Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discekorbesar_5050special_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ekor Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_discekorkecil_5050special_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Ekor Kecil"
                    aria-label="Disc Ekor Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discekorkecil_5050special_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="5050kombinasi" tab="5050 Kombinasi">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetch5050kombinasi();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasaran5050kombinasi();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_kombinasi50_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_kombinasi50_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_5050kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_5050kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Kei Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangkeimono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Kei Mono"
                    aria-label="Belakang Kei Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangkeimono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Kei Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangkeistereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Kei Stereo"
                    aria-label="Belakang Kei Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangkeistereo_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Kei Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangkeikembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Kei Kembang"
                    aria-label="Belakang Kei Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangkeikembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Kei Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangkeikempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Kei Kempis"
                    aria-label="Belakang Kei Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangkeikempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Kei Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangkeikembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Kei Kembar"
                    aria-label="Belakang Kei Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangkeikembar_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Kei Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahkeimono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Kei Mono"
                    aria-label="Tengah Kei Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahkeimono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Kei Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahkeistereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Kei Stereo"
                    aria-label="Tengah Kei Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahkeistereo_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Kei Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahkeikembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Kei Kembang"
                    aria-label="Tengah Kei Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahkeikembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Kei Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahkeikempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Kei Kempis"
                    aria-label="Tengah Kei Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahkeikempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Kei Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahkeikembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Kei Kembar"
                    aria-label="Tengah Kei Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahkeikembar_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Kei Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_depankeimono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Kei Mono"
                    aria-label="Depan Kei Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depankeimono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Kei Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_depankeistereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Kei Stereo"
                    aria-label="Depan Kei Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depankeistereo_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Kei Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_depankeikembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Kei Kembang"
                    aria-label="Depan Kei Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depankeikembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Kei Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_depankeikempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Kei Kempis"
                    aria-label="Depan Kei Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depankeikempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Kei Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_depankeikembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Kei Kembar"
                    aria-label="Depan Kei Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depankeikembar_5050kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Disc Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangdiscmono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Disc Mono"
                    aria-label="Belakang Disc Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangdiscmono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Disc Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangdiscstereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Disc Stereo"
                    aria-label="Belakang Disc Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangdiscstereo_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Disc Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangdisckembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Disc Kembang"
                    aria-label="Belakang Disc Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangdisckembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Disc Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangdisckempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Disc Kempis"
                    aria-label="Belakang Disc Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangdisckempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Belakang Disc Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_belakangdisckembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Belakang Disc Kembar"
                    aria-label="Belakang Disc Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_belakangdisckembar_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Disc Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahdiscmono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Disc Mono"
                    aria-label="Tengah Disc Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahdiscmono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Disc Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahdiscstereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Disc Stereo"
                    aria-label="Tengah Disc Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahdiscstereo_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Disc Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahdisckembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Disc Kembang"
                    aria-label="Tengah Disc Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahdisckembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Disc Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahdisckempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Disc Kempis"
                    aria-label="Tengah Disc Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahdisckempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Tengah Disc Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_tengahdisckembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Tengah Disc Kembar"
                    aria-label="Tengah Disc Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_tengahdisckembar_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Disc Mono(%)</label
                  >
                  <input
                    bind:value={pasaran_depandiscmono_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Disc Mono"
                    aria-label="Depan Disc Mono"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depandiscmono_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Disc Stereo(%)</label
                  >
                  <input
                    bind:value={pasaran_depandiscstereo_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Disc Stereo"
                    aria-label="Depan Disc Stereo"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depandiscstereo_5050kombinasi_field
                    )}</small
                  >
                </div>

                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Disc Kembang(%)</label
                  >
                  <input
                    bind:value={pasaran_depandisckembang_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Disc Kembang"
                    aria-label="Depan Disc Kembang"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depandisckembang_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Disc Kempis(%)</label
                  >
                  <input
                    bind:value={pasaran_depandisckempis_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Disc Kempis"
                    aria-label="Depan Disc Kempis"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depandisckempis_5050kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Depan Disc Kembar(%)</label
                  >
                  <input
                    bind:value={pasaran_depandisckembar_5050kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Depan Disc Kembar"
                    aria-label="Depan Disc Kembar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_depandisckembar_5050kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="macaukombinasi" tab="Macau/Kombinasi">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchmacau();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarankombinasi();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_macau_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;">
                    {new Intl.NumberFormat().format(
                      pasaran_minbet_kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_macau_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_kombinasi_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Win(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max Win(x) : {new Intl.NumberFormat().format(company_macau_max_win_field)}</small>
                  <input
                    bind:value={pasaran_win_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win"
                    aria-label="Win"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win_kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Discount(%)</label
                  >
                  <input
                    bind:value={pasaran_disc_kombinasi_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Discount"
                    aria-label="Discount"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc_kombinasi_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="dasar" tab="Dasar">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchdasar();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasarandasar();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_dasar_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_dasar_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_dasar_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_dasar_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_keibesar_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Besar"
                    aria-label="Kei Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keibesar_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_keikecil_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Kecil"
                    aria-label="Kei Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keikecil_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_keigenap_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Genap"
                    aria-label="Kei Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keigenap_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Kei Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_keiganjil_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Kei Ganjil"
                    aria-label="Kei Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_keiganjil_dasar_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Besar(%)</label
                  >
                  <input
                    bind:value={pasaran_discbesar_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Besar"
                    aria-label="Disc Besar"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discbesar_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Kecil(%)</label
                  >
                  <input
                    bind:value={pasaran_disckecil_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Kecil"
                    aria-label="Disc Kecil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disckecil_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Genap(%)</label
                  >
                  <input
                    bind:value={pasaran_discgenap_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Genap"
                    aria-label="Disc Genap"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discgenap_dasar_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Disc Ganjil(%)</label
                  >
                  <input
                    bind:value={pasaran_discganjil_dasar_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc Ganjil"
                    aria-label="Disc Ganjil"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_discganjil_dasar_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
      <TabPane tabId="shio" tab="Shio">
        <Panel height_body="700px">
          <slot:template slot="cheader">
            <div class="float-end">
              <button
                on:click={() => {
                  fetchshio();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Fetch
              </button>
              <button
                on:click={() => {
                  saveupdatepasaranshio();
                }}
                class="btn btn-warning"
                style="border-radius: 0px;"
              >
                Save
              </button>
            </div>
          </slot:template>
          <slot:template slot="cbody">
            <Row>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Shio</label>
                  <select
                    bind:value={pasaran_shioyear_shio_field}
                    name="selectshio"
                    class="form-control required"
                  >
                    <option value="kambing">Kambing</option>
                    <option value="kuda">Kuda</option>
                    <option value="ular">Ular</option>
                    <option value="naga">Naga</option>
                    <option value="kelinci">Kelinci</option>
                    <option value="harimau">Harimau</option>
                    <option value="kerbau">Kerbau</option>
                    <option value="tikus">Tikus</option>
                    <option value="babi">Babi</option>
                    <option value="anjing">Anjing</option>
                    <option value="ayam">Ayam</option>
                    <option value="monyet">Monyet</option>
                  </select>
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Min Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MinBet : {new Intl.NumberFormat().format(company_shio_max_minbet_field)}</small>
                  <input
                    bind:value={pasaran_minbet_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Min Bet"
                    aria-label="Min Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_minbet_shio_field
                    )}</small
                  >
                </div>
                <div class="mb-3 clearfix">
                  <label for="exampleFormControlInput1" class="form-label">Max Bet</label>
                  <small style="float:right;font-size:11px;color:red;">Max MaxBet : {new Intl.NumberFormat().format(company_shio_max_maxbet_field)}</small>
                  <input
                    bind:value={pasaran_maxbet_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Max Bet"
                    aria-label="Max Bet"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_maxbet_shio_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Limit Total</label
                  >
                  <input
                    bind:value={pasaran_limittotal_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total"
                    aria-label="Limit Total"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limittotal_shio_field
                    )}</small
                  >
                </div>
                <div class="mb-3">
                  <label for="exampleForm" class="form-label"
                    >Limit Global</label
                  >
                  <input
                    bind:value={pasaran_limitglobal_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Limit Total 3D"
                    aria-label="Limit Total 3D"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_limitglobal_shio_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Win(x)</label>
                  <small style="float:right;font-size:11px;color:red;">Max Win(x) : {new Intl.NumberFormat().format(company_shio_max_win_field)}</small>
                  <input
                    bind:value={pasaran_win_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Win"
                    aria-label="Win"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_win_shio_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2">
                <div class="mb-3">
                  <label for="exampleForm" class="form-label">Disc(%)</label>
                  <input
                    bind:value={pasaran_disc_shio_field}
                    on:keyup={handleKeyboard_number}
                    type="text"
                    style="text-align:right;"
                    class="form-control required"
                    placeholder="Disc"
                    aria-label="Disc"
                  />
                  <small style="float:right;font-size:11px;"
                    >{new Intl.NumberFormat().format(
                      pasaran_disc_shio_field
                    )}</small
                  >
                </div>
              </Col>
              <Col md="2" />
            </Row>
          </slot:template>
        </Panel>
      </TabPane>
    </TabContent>
  </slot:template>
</Modal>
<div
  class="modal fade"
  id="modaNewOnline"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Setting Pasaran Online
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div class="modal-body">
        <select bind:value={select_pasaranonline} class="form-control">
          <option value="minggu">Minggu</option>
          <option value="senin">Senin</option>
          <option value="selasa">Selasa</option>
          <option value="rabu">Rabu</option>
          <option value="kamis">Kamis</option>
          <option value="jumat">Jumat</option>
          <option value="sabtu">Sabtu</option>
        </select>
      </div>
      <div class="modal-footer">
        <button
          on:click={() => {
            savePasaranOnline();
          }}
          type="button"
          class="btn btn-warning btn-sm">SAVE</button
        >
      </div>
    </div>
  </div>
</div>
